export const nativeLanguageNames = {
  es: "Español",
  en: "English",
  eu: "Euskara",
  val: "Valencià",
  ca: "Català",
  de: "Deutsch",
  nl: "Nederlands",
  pl: "Polski",
  uk: "Українська",
  ru: "Русский",
};

export const translations = {
  es: {
    // App
    appName: "Caca Radar",
    appTagline: "Juntos por calles más limpias",
    
    // Map Page
    report: "Reportar",
    enter: "Entrar",
    logout: "Salir",
    legend: {
      recent: "Reciente (<48h)",
      moderate: "2-6 días",
      old: ">6 días"
    },
    
    // Report Drawer
    reportTitle: "Ayuda a tu barrio",
    reportDesc: "Señala y juntos mantenemos las calles limpias",
    gettingLocation: "Obteniendo ubicación...",
    addPhoto: "Añadir foto (opcional)",
    submitReport: "Contribuir al mapa",
    cancel: "Cancelar",
    reportSuccess: "¡Gracias! Tu comunidad te lo agradece",
    reportConfirmed: "¡Confirmado! Cada voto cuenta para mantener tu barrio limpio",
    reportError: "Error al enviar el reporte",
    locationError: "No se pudo obtener tu ubicación. Haz clic en el mapa para seleccionar manualmente.",
    locationSelected: "Ubicación seleccionada",
    fileTooLarge: "La foto es demasiado grande (max 5MB)",
    
    // Details Drawer
    detailsTitle: "Detalles del reporte",
    stillThere: "Sigue ahí",
    cleaned: "Ya limpio",
    stillThereCount: "sigue ahí",
    cleanedCount: "limpio",
    alreadyVoted: "Ya votaste",
    voteSuccess: {
      stillThere: "Confirmado que sigue ahí",
      cleaned: "Marcado como limpio"
    },
    voteError: "Error al votar",
    flagReport: "Reportar contenido inapropiado",
    flagSuccess: "Reporte marcado como inapropiado",
    flagError: "Error al marcar el reporte",
    close: "Cerrar",
    
    // Content Policy
    photoPolicy: "Si subes una foto, evita matrículas, caras, nombres u otros datos personales identificables.",
    policyAgreement: "Al subir, confirmas que tu foto cumple con estas normas.",
    
    // Flag reasons
    flagTitle: "Reportar violación",
    flagDescription: "Selecciona el motivo del reporte:",
    flagReasons: {
      licensePlate: "Matrícula visible",
      face: "Cara visible",
      name: "Nombre visible",
      personalInfo: "Otra información personal",
      inappropriate: "Contenido inapropiado",
      spam: "Spam o contenido falso",
      other: "Otro motivo"
    },
    flagSubmit: "Enviar reporte",
    flagCancel: "Cancelar",
    
    // Time
    lessThanHour: "Hace menos de 1 hora",
    hoursAgo: "Hace {n} hora",
    hoursAgoPlural: "Hace {n} horas",
    daysAgo: "Hace {n} día",
    daysAgoPlural: "Hace {n} días",
    
    // Auth
    login: "Iniciar sesión",
    register: "Crear cuenta",
    email: "Email",
    password: "Contraseña",
    name: "Nombre (opcional)",
    namePlaceholder: "Tu nombre",
    emailPlaceholder: "tu@email.com",
    passwordPlaceholder: "Mínimo 6 caracteres",
    backToMap: "Volver al mapa",
    cityRankings: "Ranking de ciudades",
    barrioRankings: "Ranking de barrios",
    heatmap: "Mapa de calor",
    advancedFilters: "Filtros avanzados",
    goPremium: "Hazte Premium",
    noAccount: "¿No tienes cuenta?",
    hasAccount: "¿Ya tienes cuenta?",
    registerLink: "Regístrate",
    loginLink: "Inicia sesión",
    useWithoutAccount: "También puedes usar la app sin cuenta",
    continueWithGoogle: "Continuar con Google",
    
    // Social/Community Messaging
    communityWelcome: "¡Bienvenido! Juntos hacemos nuestras calles más limpias.",
    reportEncouragement: "Cada reporte ayuda a tu vecindario. ¡Tú marcas la diferencia!",
    streakMessage: "¡{n} días seguidos contribuyendo! Eres increíble.",
    notificationPrompt: "¿Quieres saber cuando reportan cerca de ti?",
    notificationEnabled: "Notificaciones activadas",
    notificationDisabled: "Notificaciones desactivadas",
    loginSuccess: "Sesión iniciada correctamente",
    registerSuccess: "Cuenta creada correctamente",
    passwordTooShort: "La contraseña debe tener al menos 6 caracteres",
    genericError: "Algo salió mal. Inténtalo de nuevo.",
    username: "Nombre de usuario",
    usernamePlaceholder: "tu_nombre",
    usernameHint: "3-20 caracteres. Solo letras, números y guiones bajos.",
    usernameLength: "El nombre de usuario debe tener entre 3 y 20 caracteres",
    usernameChars: "Solo letras, números y guiones bajos",
    pickUsername: "Elige tu nombre de usuario",
    pickUsernameDesc: "Se mostrará públicamente en tus reportes y en el ranking.",
    saveUsername: "Guardar",
    usernameSaved: "Nombre de usuario guardado",
    
    // Language
    language: "Idioma",
    legalUi: {
      privacyPolicy: "Política de Privacidad",
      help: "Ayuda",
      legalAndHelp: "Ayuda y legal",
      signupNotice: "Al crear tu cuenta, puedes revisar nuestra",
      versions: "Versiones",
      acceptPrivacyPrefix: "He leído y acepto la",
      acceptTermsPrefix: "He leído y acepto los",
      ageConfirmation: "Confirmo que tengo al menos 14 años o que dispongo de la autorización legal necesaria para usar el servicio.",
      registrationConsentRequired: "Debes aceptar la Política de Privacidad, los Términos y confirmar los requisitos de edad o autorización.",
    },
    languages: nativeLanguageNames
  },
  
  en: {
    appName: "Poop Radar",
    appTagline: "Together for cleaner streets",
    report: "Report",
    enter: "Login",
    logout: "Logout",
    legend: {
      recent: "Recent (<48h)",
      moderate: "2-6 days",
      old: ">6 days"
    },
    reportTitle: "Help your neighborhood",
    reportDesc: "Mark it and together we keep streets clean",
    gettingLocation: "Getting location...",
    addPhoto: "Add photo (optional)",
    submitReport: "Contribute to the map",
    cancel: "Cancel",
    reportSuccess: "Thank you! Your community appreciates it",
    reportConfirmed: "Confirmed! Every vote helps keep your area clean",
    reportError: "Error submitting report",
    locationError: "Could not get your location. Click on the map to select manually.",
    locationSelected: "Location selected",
    fileTooLarge: "Photo is too large (max 5MB)",
    detailsTitle: "Report details",
    stillThere: "Still there",
    cleaned: "Cleaned",
    stillThereCount: "still there",
    cleanedCount: "cleaned",
    alreadyVoted: "You already voted",
    voteSuccess: {
      stillThere: "Confirmed still there",
      cleaned: "Marked as cleaned"
    },
    voteError: "Error voting",
    flagReport: "Report inappropriate content",
    flagSuccess: "Report flagged as inappropriate",
    flagError: "Error flagging report",
    close: "Close",
    photoPolicy: "If you upload a photo, avoid license plates, faces, names, or other personally identifiable information.",
    lessThanHour: "Less than 1 hour ago",
    hoursAgo: "{n} hour ago",
    hoursAgoPlural: "{n} hours ago",
    daysAgo: "{n} day ago",
    daysAgoPlural: "{n} days ago",
    login: "Login",
    register: "Create account",
    email: "Email",
    password: "Password",
    name: "Name (optional)",
    namePlaceholder: "Your name",
    emailPlaceholder: "your@email.com",
    passwordPlaceholder: "Minimum 6 characters",
    backToMap: "Back to map",
    cityRankings: "City rankings",
    barrioRankings: "Barrio rankings",
    heatmap: "Heat map",
    advancedFilters: "Advanced filters",
    goPremium: "Go Premium",
    noAccount: "Don't have an account?",
    hasAccount: "Already have an account?",
    registerLink: "Sign up",
    loginLink: "Login",
    useWithoutAccount: "You can also use the app without an account",
    continueWithGoogle: "Continue with Google",
    
    // Social/Community Messaging
    communityWelcome: "Welcome! Together we make our streets cleaner.",
    reportEncouragement: "Every report helps your neighborhood. You make the difference!",
    streakMessage: "{n} days in a row contributing! You're amazing.",
    notificationPrompt: "Want to know when reports appear near you?",
    notificationEnabled: "Notifications enabled",
    notificationDisabled: "Notifications disabled",
    loginSuccess: "Logged in successfully",
    registerSuccess: "Account created successfully",
    passwordTooShort: "Password must be at least 6 characters",
    genericError: "Something went wrong. Please try again.",
    username: "Username",
    usernamePlaceholder: "your_username",
    usernameHint: "3-20 characters. Letters, numbers and underscores only.",
    usernameLength: "Username must be between 3 and 20 characters",
    usernameChars: "Only letters, numbers and underscores allowed",
    pickUsername: "Pick a username",
    pickUsernameDesc: "This will be shown publicly on your reports and the leaderboard.",
    saveUsername: "Save",
    usernameSaved: "Username saved",
    language: "Language",
    legalUi: {
      privacyPolicy: "Privacy Policy",
      help: "Help",
      legalAndHelp: "Help & legal",
      signupNotice: "By creating your account, you can review our",
      versions: "Versions",
      acceptPrivacyPrefix: "I have read and accept the",
      acceptTermsPrefix: "I have read and accept the",
      ageConfirmation: "I confirm that I am at least 14 years old or that I have the legally required authorization to use the service.",
      registrationConsentRequired: "You must accept the Privacy Policy, the Terms, and confirm the age or authorization requirement.",
    },
    languages: nativeLanguageNames
  },
  
  de: {
    appName: "Kacke Radar",
    report: "Melden",
    enter: "Anmelden",
    logout: "Abmelden",
    legend: {
      recent: "Aktuell (<48h)",
      moderate: "2-6 Tage",
      old: ">6 Tage"
    },
    reportTitle: "Hundekot melden",
    reportDesc: "Dein Standort wird automatisch hinzugefügt",
    gettingLocation: "Standort wird ermittelt...",
    addPhoto: "Foto hinzufügen (optional)",
    submitReport: "Meldung senden",
    cancel: "Abbrechen",
    reportSuccess: "Meldung erfolgreich gesendet",
    reportError: "Fehler beim Senden der Meldung",
    locationError: "Standort konnte nicht ermittelt werden. Klicke auf die Karte zur manuellen Auswahl.",
    locationSelected: "Standort ausgewählt",
    fileTooLarge: "Foto ist zu groß (max 5MB)",
    detailsTitle: "Meldungsdetails",
    stillThere: "Noch da",
    cleaned: "Sauber",
    stillThereCount: "noch da",
    cleanedCount: "sauber",
    alreadyVoted: "Du hast bereits abgestimmt",
    voteSuccess: {
      stillThere: "Bestätigt, dass es noch da ist",
      cleaned: "Als sauber markiert"
    },
    voteError: "Fehler bei der Abstimmung",
    flagReport: "Unangemessenen Inhalt melden",
    flagSuccess: "Inhalt als unangemessen gemeldet",
    flagError: "Fehler beim Melden",
    close: "Schließen",
    
    // Content Policy
    photoPolicy: "Lade keine Fotos mit Kennzeichen, Namen, Gesichtern oder anderen persönlich identifizierbaren Informationen hoch.",
    policyAgreement: "Mit dem Hochladen bestätigst du, dass dein Foto diesen Regeln entspricht.",
    
    // Flag reasons
    flagTitle: "Verstoß melden",
    flagDescription: "Wähle den Grund für die Meldung:",
    flagReasons: {
      licensePlate: "Sichtbares Kennzeichen",
      face: "Sichtbares Gesicht",
      name: "Sichtbarer Name",
      personalInfo: "Andere persönliche Informationen",
      inappropriate: "Unangemessener Inhalt",
      spam: "Spam oder falscher Inhalt",
      other: "Anderer Grund"
    },
    flagSubmit: "Meldung senden",
    flagCancel: "Abbrechen",
    lessThanHour: "Vor weniger als 1 Stunde",
    hoursAgo: "Vor {n} Stunde",
    hoursAgoPlural: "Vor {n} Stunden",
    daysAgo: "Vor {n} Tag",
    daysAgoPlural: "Vor {n} Tagen",
    login: "Anmelden",
    register: "Konto erstellen",
    email: "E-Mail",
    password: "Passwort",
    name: "Name (optional)",
    namePlaceholder: "Dein Name",
    emailPlaceholder: "deine@email.com",
    passwordPlaceholder: "Mindestens 6 Zeichen",
    backToMap: "Zurück zur Karte",
    cityRankings: "Städte-Ranking",
    barrioRankings: "Stadtviertel-Ranking",
    heatmap: "Heatmap",
    advancedFilters: "Erweiterte Filter",
    goPremium: "Premium werden",
    noAccount: "Noch kein Konto?",
    hasAccount: "Bereits ein Konto?",
    registerLink: "Registrieren",
    loginLink: "Anmelden",
    useWithoutAccount: "Du kannst die App auch ohne Konto nutzen",
    loginSuccess: "Erfolgreich angemeldet",
    registerSuccess: "Konto erfolgreich erstellt",
    passwordTooShort: "Passwort muss mindestens 6 Zeichen haben",
    genericError: "Etwas ist schiefgelaufen. Bitte versuche es erneut.",
    username: "Benutzername",
    usernamePlaceholder: "dein_name",
    usernameHint: "3-20 Zeichen. Nur Buchstaben, Zahlen und Unterstriche.",
    usernameLength: "Benutzername muss zwischen 3 und 20 Zeichen lang sein",
    usernameChars: "Nur Buchstaben, Zahlen und Unterstriche erlaubt",
    pickUsername: "Wähle einen Benutzernamen",
    pickUsernameDesc: "Wird öffentlich bei deinen Meldungen und im Ranking angezeigt.",
    saveUsername: "Speichern",
    usernameSaved: "Benutzername gespeichert",
    language: "Sprache",
    languages: nativeLanguageNames
  },
  
  nl: {
    appName: "Poep Radar",
    report: "Melden",
    enter: "Inloggen",
    logout: "Uitloggen",
    legend: {
      recent: "Recent (<24u)",
      moderate: "2-6 dagen",
      old: ">6 dagen"
    },
    reportTitle: "Hondenpoep melden",
    reportDesc: "Je locatie wordt automatisch toegevoegd",
    gettingLocation: "Locatie ophalen...",
    addPhoto: "Foto toevoegen (optioneel)",
    submitReport: "Melding versturen",
    cancel: "Annuleren",
    reportSuccess: "Melding succesvol verzonden",
    reportError: "Fout bij verzenden melding",
    locationError: "Kon je locatie niet ophalen. Klik op de kaart om handmatig te selecteren.",
    locationSelected: "Locatie geselecteerd",
    fileTooLarge: "Foto is te groot (max 5MB)",
    detailsTitle: "Meldingsdetails",
    stillThere: "Nog steeds daar",
    cleaned: "Opgeruimd",
    stillThereCount: "nog daar",
    cleanedCount: "opgeruimd",
    alreadyVoted: "Je hebt al gestemd",
    voteSuccess: {
      stillThere: "Bevestigd dat het er nog is",
      cleaned: "Gemarkeerd als opgeruimd"
    },
    voteError: "Fout bij stemmen",
    flagReport: "Ongepaste inhoud melden",
    flagSuccess: "Inhoud als ongepast gemeld",
    flagError: "Fout bij melden",
    close: "Sluiten",
    
    // Content Policy
    photoPolicy: "Upload geen foto's met kentekens, namen, gezichten of andere persoonlijk identificeerbare informatie.",
    policyAgreement: "Door te uploaden bevestig je dat je foto aan deze regels voldoet.",
    
    // Flag reasons
    flagTitle: "Overtreding melden",
    flagDescription: "Selecteer de reden voor de melding:",
    flagReasons: {
      licensePlate: "Zichtbaar kenteken",
      face: "Zichtbaar gezicht",
      name: "Zichtbare naam",
      personalInfo: "Andere persoonlijke informatie",
      inappropriate: "Ongepaste inhoud",
      spam: "Spam of valse inhoud",
      other: "Andere reden"
    },
    flagSubmit: "Melding verzenden",
    flagCancel: "Annuleren",
    lessThanHour: "Minder dan 1 uur geleden",
    hoursAgo: "{n} uur geleden",
    hoursAgoPlural: "{n} uur geleden",
    daysAgo: "{n} dag geleden",
    daysAgoPlural: "{n} dagen geleden",
    login: "Inloggen",
    register: "Account aanmaken",
    email: "E-mail",
    password: "Wachtwoord",
    name: "Naam (optioneel)",
    namePlaceholder: "Je naam",
    emailPlaceholder: "jouw@email.com",
    passwordPlaceholder: "Minimaal 6 tekens",
    backToMap: "Terug naar kaart",
    cityRankings: "Stedenranking",
    barrioRankings: "Wijkranking",
    heatmap: "Warmtekaart",
    advancedFilters: "Geavanceerde filters",
    goPremium: "Word Premium",
    noAccount: "Geen account?",
    hasAccount: "Al een account?",
    registerLink: "Registreren",
    loginLink: "Inloggen",
    useWithoutAccount: "Je kunt de app ook zonder account gebruiken",
    loginSuccess: "Succesvol ingelogd",
    registerSuccess: "Account succesvol aangemaakt",
    passwordTooShort: "Wachtwoord moet minimaal 6 tekens bevatten",
    genericError: "Er ging iets mis. Probeer het opnieuw.",
    username: "Gebruikersnaam",
    usernamePlaceholder: "jouw_naam",
    usernameHint: "3-20 tekens. Alleen letters, cijfers en underscores.",
    usernameLength: "Gebruikersnaam moet tussen 3 en 20 tekens zijn",
    usernameChars: "Alleen letters, cijfers en underscores toegestaan",
    pickUsername: "Kies een gebruikersnaam",
    pickUsernameDesc: "Dit wordt openbaar getoond bij je meldingen en op het scorebord.",
    saveUsername: "Opslaan",
    usernameSaved: "Gebruikersnaam opgeslagen",
    language: "Taal",
    languages: nativeLanguageNames
  },
  
  pl: {
    appName: "Radar Kupy",
    report: "Zgłoś",
    enter: "Zaloguj",
    logout: "Wyloguj",
    legend: {
      recent: "Ostatnie (<48h)",
      moderate: "2-6 dni",
      old: ">6 dni"
    },
    reportTitle: "Zgłoś psią kupę",
    reportDesc: "Twoja lokalizacja zostanie dodana automatycznie",
    gettingLocation: "Pobieranie lokalizacji...",
    addPhoto: "Dodaj zdjęcie (opcjonalne)",
    submitReport: "Wyślij zgłoszenie",
    cancel: "Anuluj",
    reportSuccess: "Zgłoszenie wysłane pomyślnie",
    reportError: "Błąd podczas wysyłania zgłoszenia",
    locationError: "Nie można pobrać lokalizacji. Kliknij na mapę, aby wybrać ręcznie.",
    locationSelected: "Lokalizacja wybrana",
    fileTooLarge: "Zdjęcie jest za duże (max 5MB)",
    detailsTitle: "Szczegóły zgłoszenia",
    stillThere: "Nadal tam",
    cleaned: "Posprzątane",
    stillThereCount: "nadal tam",
    cleanedCount: "posprzątane",
    alreadyVoted: "Już głosowałeś",
    voteSuccess: {
      stillThere: "Potwierdzone, że nadal tam jest",
      cleaned: "Oznaczone jako posprzątane"
    },
    voteError: "Błąd głosowania",
    flagReport: "Zgłoś nieodpowiednią treść",
    flagSuccess: "Treść zgłoszona jako nieodpowiednia",
    flagError: "Błąd zgłaszania",
    close: "Zamknij",
    
    // Content Policy
    photoPolicy: "Nie przesyłaj zdjęć z tablicami rejestracyjnymi, nazwiskami, twarzami lub innymi danymi osobowymi.",
    policyAgreement: "Przesyłając zdjęcie, potwierdzasz zgodność z tymi zasadami.",
    
    // Flag reasons
    flagTitle: "Zgłoś naruszenie",
    flagDescription: "Wybierz powód zgłoszenia:",
    flagReasons: {
      licensePlate: "Widoczna tablica rejestracyjna",
      face: "Widoczna twarz",
      name: "Widoczne nazwisko",
      personalInfo: "Inne dane osobowe",
      inappropriate: "Nieodpowiednia treść",
      spam: "Spam lub fałszywa treść",
      other: "Inny powód"
    },
    flagSubmit: "Wyślij zgłoszenie",
    flagCancel: "Anuluj",
    lessThanHour: "Mniej niż godzinę temu",
    hoursAgo: "{n} godzinę temu",
    hoursAgoPlural: "{n} godzin temu",
    daysAgo: "{n} dzień temu",
    daysAgoPlural: "{n} dni temu",
    login: "Zaloguj się",
    register: "Utwórz konto",
    email: "Email",
    password: "Hasło",
    name: "Imię (opcjonalne)",
    namePlaceholder: "Twoje imię",
    emailPlaceholder: "twoj@email.com",
    passwordPlaceholder: "Minimum 6 znaków",
    backToMap: "Powrót do mapy",
    cityRankings: "Ranking miast",
    barrioRankings: "Ranking dzielnic",
    heatmap: "Mapa cieplna",
    advancedFilters: "Zaawansowane filtry",
    goPremium: "Przejdź na Premium",
    noAccount: "Nie masz konta?",
    hasAccount: "Masz już konto?",
    registerLink: "Zarejestruj się",
    loginLink: "Zaloguj się",
    useWithoutAccount: "Możesz też używać aplikacji bez konta",
    loginSuccess: "Zalogowano pomyślnie",
    registerSuccess: "Konto utworzone pomyślnie",
    passwordTooShort: "Hasło musi mieć co najmniej 6 znaków",
    genericError: "Coś poszło nie tak. Spróbuj ponownie.",
    username: "Nazwa użytkownika",
    usernamePlaceholder: "twoja_nazwa",
    usernameHint: "3-20 znaków. Tylko litery, cyfry i podkreślenia.",
    usernameLength: "Nazwa użytkownika musi mieć od 3 do 20 znaków",
    usernameChars: "Dozwolone tylko litery, cyfry i podkreślenia",
    pickUsername: "Wybierz nazwę użytkownika",
    pickUsernameDesc: "Będzie wyświetlana publicznie przy Twoich zgłoszeniach i w rankingu.",
    saveUsername: "Zapisz",
    usernameSaved: "Nazwa użytkownika zapisana",
    language: "Język",
    languages: nativeLanguageNames
  },
  
  
  uk: {
    appName: "Радар Какашок",
    report: "Повідомити",
    enter: "Увійти",
    logout: "Вийти",
    legend: {
      recent: "Нещодавно (<24г)",
      moderate: "2-6 днів",
      old: ">6 днів"
    },
    reportTitle: "Повідомити про собачі екскременти",
    reportDesc: "Ваше місцезнаходження буде додано автоматично",
    gettingLocation: "Отримання місцезнаходження...",
    addPhoto: "Додати фото (необов'язково)",
    submitReport: "Надіслати повідомлення",
    cancel: "Скасувати",
    reportSuccess: "Повідомлення успішно надіслано",
    reportError: "Помилка надсилання повідомлення",
    locationError: "Не вдалося отримати ваше місцезнаходження. Натисніть на карту для вибору вручну.",
    locationSelected: "Місцезнаходження вибрано",
    fileTooLarge: "Фото занадто велике (макс 5МБ)",
    detailsTitle: "Деталі повідомлення",
    stillThere: "Ще там",
    cleaned: "Прибрано",
    stillThereCount: "ще там",
    cleanedCount: "прибрано",
    alreadyVoted: "Ви вже голосували",
    voteSuccess: {
      stillThere: "Підтверджено, що ще там",
      cleaned: "Позначено як прибране"
    },
    voteError: "Помилка голосування",
    flagReport: "Повідомити про неприйнятний вміст",
    flagSuccess: "Вміст позначено як неприйнятний",
    flagError: "Помилка повідомлення",
    close: "Закрити",
    
    // Content Policy
    photoPolicy: "Не завантажуйте фото з номерними знаками, іменами, обличчями чи іншою особистою інформацією.",
    policyAgreement: "Завантажуючи, ви підтверджуєте відповідність фото цим правилам.",
    
    // Flag reasons
    flagTitle: "Повідомити про порушення",
    flagDescription: "Оберіть причину скарги:",
    flagReasons: {
      licensePlate: "Видимий номерний знак",
      face: "Видиме обличчя",
      name: "Видиме ім'я",
      personalInfo: "Інша особиста інформація",
      inappropriate: "Неприйнятний вміст",
      spam: "Спам або фейк",
      other: "Інша причина"
    },
    flagSubmit: "Надіслати скаргу",
    flagCancel: "Скасувати",
    lessThanHour: "Менше години тому",
    hoursAgo: "{n} годину тому",
    hoursAgoPlural: "{n} годин тому",
    daysAgo: "{n} день тому",
    daysAgoPlural: "{n} днів тому",
    login: "Увійти",
    register: "Створити акаунт",
    email: "Email",
    password: "Пароль",
    name: "Ім'я (необов'язково)",
    namePlaceholder: "Ваше ім'я",
    emailPlaceholder: "ваш@email.com",
    passwordPlaceholder: "Мінімум 6 символів",
    backToMap: "Назад до карти",
    cityRankings: "Рейтинг міст",
    barrioRankings: "Рейтинг районів",
    heatmap: "Теплова карта",
    advancedFilters: "Розширені фільтри",
    goPremium: "Стати Преміум",
    noAccount: "Немає акаунту?",
    hasAccount: "Вже є акаунт?",
    registerLink: "Зареєструватися",
    loginLink: "Увійти",
    useWithoutAccount: "Ви також можете користуватися додатком без акаунту",
    loginSuccess: "Успішний вхід",
    registerSuccess: "Акаунт успішно створено",
    passwordTooShort: "Пароль має містити щонайменше 6 символів",
    genericError: "Щось пішло не так. Спробуйте ще раз.",
    username: "Ім'я користувача",
    usernamePlaceholder: "ваше_імя",
    usernameHint: "3-20 символів. Лише літери, цифри та підкреслення.",
    usernameLength: "Ім'я користувача має бути від 3 до 20 символів",
    usernameChars: "Дозволені лише літери, цифри та підкреслення",
    pickUsername: "Оберіть ім'я користувача",
    pickUsernameDesc: "Воно буде публічно відображатися у ваших звітах та рейтингу.",
    saveUsername: "Зберегти",
    usernameSaved: "Ім'я користувача збережено",
    language: "Мова",
    languages: nativeLanguageNames
  },
  
  ru: {
    appName: "Радар Какашек",
    report: "Сообщить",
    enter: "Войти",
    logout: "Выйти",
    legend: {
      recent: "Недавно (<24ч)",
      moderate: "2-6 дней",
      old: ">6 дней"
    },
    reportTitle: "Сообщить о собачьих экскрементах",
    reportDesc: "Ваше местоположение будет добавлено автоматически",
    gettingLocation: "Получение местоположения...",
    addPhoto: "Добавить фото (необязательно)",
    submitReport: "Отправить сообщение",
    cancel: "Отмена",
    reportSuccess: "Сообщение успешно отправлено",
    reportError: "Ошибка отправки сообщения",
    locationError: "Не удалось получить ваше местоположение. Нажмите на карту для выбора вручную.",
    locationSelected: "Местоположение выбрано",
    fileTooLarge: "Фото слишком большое (макс 5МБ)",
    detailsTitle: "Детали сообщения",
    stillThere: "Ещё там",
    cleaned: "Убрано",
    stillThereCount: "ещё там",
    cleanedCount: "убрано",
    alreadyVoted: "Вы уже голосовали",
    voteSuccess: {
      stillThere: "Подтверждено, что ещё там",
      cleaned: "Отмечено как убранное"
    },
    voteError: "Ошибка голосования",
    flagReport: "Сообщить о неприемлемом контенте",
    flagSuccess: "Контент отмечен как неприемлемый",
    flagError: "Ошибка сообщения",
    close: "Закрыть",
    
    // Content Policy
    photoPolicy: "Не загружайте фото с номерными знаками, именами, лицами или другой личной информацией.",
    policyAgreement: "Загружая, вы подтверждаете соответствие фото этим правилам.",
    
    // Flag reasons
    flagTitle: "Сообщить о нарушении",
    flagDescription: "Выберите причину жалобы:",
    flagReasons: {
      licensePlate: "Видимый номерной знак",
      face: "Видимое лицо",
      name: "Видимое имя",
      personalInfo: "Другая личная информация",
      inappropriate: "Неприемлемый контент",
      spam: "Спам или фейк",
      other: "Другая причина"
    },
    flagSubmit: "Отправить жалобу",
    flagCancel: "Отмена",
    lessThanHour: "Менее часа назад",
    hoursAgo: "{n} час назад",
    hoursAgoPlural: "{n} часов назад",
    daysAgo: "{n} день назад",
    daysAgoPlural: "{n} дней назад",
    login: "Войти",
    register: "Создать аккаунт",
    email: "Email",
    password: "Пароль",
    name: "Имя (необязательно)",
    namePlaceholder: "Ваше имя",
    emailPlaceholder: "ваш@email.com",
    passwordPlaceholder: "Минимум 6 символов",
    backToMap: "Назад к карте",
    cityRankings: "Рейтинг городов",
    barrioRankings: "Рейтинг районов",
    heatmap: "Тепловая карта",
    advancedFilters: "Расширенные фильтры",
    goPremium: "Стать Премиум",
    noAccount: "Нет аккаунта?",
    hasAccount: "Уже есть аккаунт?",
    registerLink: "Зарегистрироваться",
    loginLink: "Войти",
    useWithoutAccount: "Вы также можете использовать приложение без аккаунта",
    loginSuccess: "Успешный вход",
    registerSuccess: "Аккаунт успешно создан",
    passwordTooShort: "Пароль должен содержать не менее 6 символов",
    genericError: "Что-то пошло не так. Попробуйте ещё раз.",
    username: "Имя пользователя",
    usernamePlaceholder: "ваше_имя",
    usernameHint: "3-20 символов. Только буквы, цифры и подчёркивания.",
    usernameLength: "Имя пользователя должно быть от 3 до 20 символов",
    usernameChars: "Допускаются только буквы, цифры и подчёркивания",
    pickUsername: "Выберите имя пользователя",
    pickUsernameDesc: "Оно будет публично отображаться в ваших отчётах и рейтинге.",
    saveUsername: "Сохранить",
    usernameSaved: "Имя пользователя сохранено",
    language: "Язык",
    languages: nativeLanguageNames
  },

  eu: {
    appName: "Kaka Radarrea",
    report: "Salatu",
    enter: "Sartu",
    logout: "Irten",
    legend: { recent: "Berria (<48h)", moderate: "2-6 egun", old: ">6 egun" },
    reportTitle: "Txakur kaka salatu",
    reportDesc: "Zure kokapena automatikoki gehituko da",
    gettingLocation: "Kokapena lortzen...",
    addPhoto: "Argazkia gehitu (aukerakoa)",
    submitReport: "Salaketa bidali",
    cancel: "Utzi",
    reportSuccess: "Salaketa ondo bidali da",
    reportError: "Errorea salaketa bidaltzean",
    locationError: "Ezin izan da zure kokapena lortu. Egin klik mapan eskuz hautatzeko.",
    locationSelected: "Kokapena hautatuta",
    fileTooLarge: "Argazkia handiegia da (max 5MB)",
    detailsTitle: "Salaketaren xehetasunak",
    stillThere: "Oraindik hor dago",
    cleaned: "Garbituta",
    stillThereCount: "oraindik hor",
    cleanedCount: "garbituta",
    alreadyVoted: "Dagoeneko bozkatu duzu",
    voteSuccess: { stillThere: "Oraindik hor dagoela baieztatu da", cleaned: "Garbituta markatu da" },
    voteError: "Errorea bozkatzerakoan",
    flagReport: "Eduki desegokia salatu",
    flagSuccess: "Edukia desegoki gisa markatu da",
    flagError: "Errorea salatzerakoan",
    close: "Itxi",
    photoPolicy: "Ez igo matrikulak, izenak, aurpegiak edo informazio pertsonala duten argazkiak.",
    policyAgreement: "Igotzerakoan, zure argazkia arau hauek betetzen dituela baieztatzen duzu.",
    flagTitle: "Urratzea salatu",
    flagDescription: "Hautatu salaketaren arrazoia:",
    flagReasons: { licensePlate: "Matrikula ikusgai", face: "Aurpegia ikusgai", name: "Izena ikusgai", personalInfo: "Beste informazio pertsonala", inappropriate: "Eduki desegokia", spam: "Spama edo eduki faltsua", other: "Beste arrazoi bat" },
    flagSubmit: "Salaketa bidali", flagCancel: "Utzi",
    lessThanHour: "Ordu bat baino gutxiago", hoursAgo: "Duela {n} ordu", hoursAgoPlural: "Duela {n} ordu", daysAgo: "Duela {n} egun", daysAgoPlural: "Duela {n} egun",
    login: "Hasi saioa", register: "Kontua sortu", email: "Emaila", password: "Pasahitza",
    name: "Izena (aukerakoa)", namePlaceholder: "Zure izena", emailPlaceholder: "zure@emaila.com", passwordPlaceholder: "Gutxienez 6 karaktere",
    backToMap: "Mapara itzuli", cityRankings: "Hirien rankinga", barrioRankings: "Auzoen rankinga", heatmap: "Bero-mapa", advancedFilters: "Iragazki aurreratuak", goPremium: "Premium egin", noAccount: "Ez duzu konturik?", hasAccount: "Dagoeneko kontu bat?",
    registerLink: "Erregistratu", loginLink: "Hasi saioa", useWithoutAccount: "Aplikazioa konturik gabe ere erabil dezakezu",
    loginSuccess: "Saioa ondo hasi da", registerSuccess: "Kontua ondo sortu da", passwordTooShort: "Pasahitzak gutxienez 6 karaktere izan behar ditu", genericError: "Zerbait gaizki joan da. Saiatu berriro.",
    username: "Erabiltzaile-izena", usernamePlaceholder: "zure_izena", usernameHint: "3-20 karaktere. Letrak, zenbakiak eta azpimarrak bakarrik.", usernameLength: "Erabiltzaile-izenak 3 eta 20 karaktere artean izan behar ditu", usernameChars: "Letrak, zenbakiak eta azpimarrak bakarrik onartzen dira", pickUsername: "Aukeratu erabiltzaile-izen bat", pickUsernameDesc: "Publikoki erakutsiko da zure salaketa eta sailkapenetan.", saveUsername: "Gorde", usernameSaved: "Erabiltzaile-izena gordeta",
    language: "Hizkuntza",
    languages: { es: "Español", en: "English", de: "Deutsch", nl: "Nederlands", pl: "Polski", uk: "Українська", ru: "Русский", eu: "Euskara", ca: "Català", val: "Valencià" }
  },

  ca: {
    appName: "Radar Caca",
    report: "Reportar",
    enter: "Entrar",
    logout: "Sortir",
    legend: { recent: "Recent (<48h)", moderate: "2-6 dies", old: ">6 dies" },
    reportTitle: "Reportar caca de gos",
    reportDesc: "La teva ubicació s'afegirà automàticament",
    gettingLocation: "Obtenint ubicació...",
    addPhoto: "Afegir foto (opcional)",
    submitReport: "Enviar report",
    cancel: "Cancel·lar",
    reportSuccess: "Report enviat correctament",
    reportError: "Error en enviar el report",
    locationError: "No s'ha pogut obtenir la teva ubicació. Fes clic al mapa per seleccionar manualment.",
    locationSelected: "Ubicació seleccionada",
    fileTooLarge: "La foto és massa gran (max 5MB)",
    detailsTitle: "Detalls del report",
    stillThere: "Encara hi és",
    cleaned: "Ja net",
    stillThereCount: "encara hi és",
    cleanedCount: "net",
    alreadyVoted: "Ja has votat",
    voteSuccess: { stillThere: "Confirmat que encara hi és", cleaned: "Marcat com a net" },
    voteError: "Error en votar",
    flagReport: "Reportar contingut inapropiat",
    flagSuccess: "Contingut marcat com a inapropiat",
    flagError: "Error en reportar",
    close: "Tancar",
    photoPolicy: "No pugis fotos amb matrícules, noms, cares o altra informació personal identificable.",
    policyAgreement: "En pujar, confirmes que la teva foto compleix amb aquestes normes.",
    flagTitle: "Reportar violació", flagDescription: "Selecciona el motiu del report:",
    flagReasons: { licensePlate: "Matrícula visible", face: "Cara visible", name: "Nom visible", personalInfo: "Altra informació personal", inappropriate: "Contingut inapropiat", spam: "Spam o contingut fals", other: "Altre motiu" },
    flagSubmit: "Enviar report", flagCancel: "Cancel·lar",
    lessThanHour: "Fa menys d'1 hora", hoursAgo: "Fa {n} hora", hoursAgoPlural: "Fa {n} hores", daysAgo: "Fa {n} dia", daysAgoPlural: "Fa {n} dies",
    login: "Iniciar sessió", register: "Crear compte", email: "Email", password: "Contrasenya",
    name: "Nom (opcional)", namePlaceholder: "El teu nom", emailPlaceholder: "el@teu.email", passwordPlaceholder: "Mínim 6 caràcters",
    backToMap: "Tornar al mapa", cityRankings: "Rànquing de ciutats", barrioRankings: "Rànquing de barris", heatmap: "Mapa de calor", advancedFilters: "Filtres avançats", goPremium: "Fes-te Premium", noAccount: "No tens compte?", hasAccount: "Ja tens compte?",
    registerLink: "Registra't", loginLink: "Inicia sessió", useWithoutAccount: "També pots fer servir l'app sense compte",
    loginSuccess: "Sessió iniciada correctament", registerSuccess: "Compte creat correctament", passwordTooShort: "La contrasenya ha de tenir almenys 6 caràcters", genericError: "Alguna cosa ha anat malament. Torna-ho a provar.",
    username: "Nom d'usuari", usernamePlaceholder: "el_teu_nom", usernameHint: "3-20 caràcters. Només lletres, números i guions baixos.", usernameLength: "El nom d'usuari ha de tenir entre 3 i 20 caràcters", usernameChars: "Només lletres, números i guions baixos", pickUsername: "Tria un nom d'usuari", pickUsernameDesc: "Es mostrarà públicament a les teves denúncies i al rànquing.", saveUsername: "Desar", usernameSaved: "Nom d'usuari desat",
    language: "Idioma",
    languages: { es: "Español", en: "English", de: "Deutsch", nl: "Nederlands", pl: "Polski", uk: "Українська", ru: "Русский", eu: "Euskara", ca: "Català", val: "Valencià" }
  },

  val: {
    appName: "Radar Caca",
    report: "Reportar",
    enter: "Entrar",
    logout: "Eixir",
    legend: { recent: "Recent (<48h)", moderate: "2-6 dies", old: ">6 dies" },
    reportTitle: "Reportar caca de gos",
    reportDesc: "La teua ubicació s'afegirà automàticament",
    gettingLocation: "Obtenint ubicació...",
    addPhoto: "Afegir foto (opcional)",
    submitReport: "Enviar report",
    cancel: "Cancel·lar",
    reportSuccess: "Report enviat correctament",
    reportError: "Error en enviar el report",
    locationError: "No s'ha pogut obtindre la teua ubicació. Fes clic al mapa per a seleccionar manualment.",
    locationSelected: "Ubicació seleccionada",
    fileTooLarge: "La foto és massa gran (max 5MB)",
    detailsTitle: "Detalls del report",
    stillThere: "Encara està ahí",
    cleaned: "Ja net",
    stillThereCount: "encara ahí",
    cleanedCount: "net",
    alreadyVoted: "Ja has votat",
    voteSuccess: { stillThere: "Confirmat que encara està ahí", cleaned: "Marcat com a net" },
    voteError: "Error en votar",
    flagReport: "Reportar contingut inapropiat",
    flagSuccess: "Contingut marcat com a inapropiat",
    flagError: "Error en reportar",
    close: "Tancar",
    photoPolicy: "No puges fotos amb matrícules, noms, cares o altra informació personal identificable.",
    policyAgreement: "En pujar, confirmes que la teua foto compleix amb estes normes.",
    flagTitle: "Reportar violació", flagDescription: "Selecciona el motiu del report:",
    flagReasons: { licensePlate: "Matrícula visible", face: "Cara visible", name: "Nom visible", personalInfo: "Altra informació personal", inappropriate: "Contingut inapropiat", spam: "Spam o contingut fals", other: "Altre motiu" },
    flagSubmit: "Enviar report", flagCancel: "Cancel·lar",
    lessThanHour: "Fa menys d'1 hora", hoursAgo: "Fa {n} hora", hoursAgoPlural: "Fa {n} hores", daysAgo: "Fa {n} dia", daysAgoPlural: "Fa {n} dies",
    login: "Iniciar sessió", register: "Crear compte", email: "Email", password: "Contrasenya",
    name: "Nom (opcional)", namePlaceholder: "El teu nom", emailPlaceholder: "el@teu.email", passwordPlaceholder: "Mínim 6 caràcters",
    backToMap: "Tornar al mapa", cityRankings: "Rànquing de ciutats", barrioRankings: "Rànquing de barris", heatmap: "Mapa de calor", advancedFilters: "Filtres avançats", goPremium: "Fes-te Premium", noAccount: "No tens compte?", hasAccount: "Ja tens compte?",
    registerLink: "Registra't", loginLink: "Inicia sessió", useWithoutAccount: "També pots usar l'app sense compte",
    loginSuccess: "Sessió iniciada correctament", registerSuccess: "Compte creat correctament", passwordTooShort: "La contrasenya ha de tindre almenys 6 caràcters", genericError: "Alguna cosa ha eixit malament. Torna a provar.",
    username: "Nom d'usuari", usernamePlaceholder: "el_teu_nom", usernameHint: "3-20 caràcters. Només lletres, números i guions baixos.", usernameLength: "El nom d'usuari ha de tindre entre 3 i 20 caràcters", usernameChars: "Només lletres, números i guions baixos", pickUsername: "Tria un nom d'usuari", pickUsernameDesc: "Es mostrarà públicament en les teues denúncies i al rànquing.", saveUsername: "Guardar", usernameSaved: "Nom d'usuari guardat",
    language: "Idioma",
    languages: { es: "Español", en: "English", de: "Deutsch", nl: "Nederlands", pl: "Polski", uk: "Українська", ru: "Русский", eu: "Euskara", ca: "Català", val: "Valencià" }
  }
};

const rankTranslations = {
  es: {
    aspiranteCagon: "Aspirante Cagón",
    agenteExcrementos: "Agente de Excrementos",
    policiaCaca: "Policía de la Caca",
    oficialDeposiciones: "Oficial de Deposiciones",
    subinspectorMojon: "Subinspector del Mojón",
    inspectorTrunos: "Inspector de Truños",
    inspectorJefeMarron: "Inspector Jefe del Marrón",
    comisarioHecesUrbanas: "Comisario de Heces Urbanas",
    comisarioApocalipsisCanino: "Comisario Principal del Apocalipsis Canino",
    directorCagadaNacional: "Director General de la Cagada Nacional",
  },
  en: {
    aspiranteCagon: "Poop Cadet",
    agenteExcrementos: "Excrement Officer",
    policiaCaca: "Poop Patrol Officer",
    oficialDeposiciones: "Deposit Officer",
    subinspectorMojon: "Deputy Inspector of Turds",
    inspectorTrunos: "Turd Inspector",
    inspectorJefeMarron: "Chief Inspector of the Mess",
    comisarioHecesUrbanas: "Commissioner of Urban Droppings",
    comisarioApocalipsisCanino: "Chief Commissioner of the Canine Apocalypse",
    directorCagadaNacional: "Director General of the National Poop Crisis",
  },
  de: {
    aspiranteCagon: "Kack-Kadett",
    agenteExcrementos: "Exkrement-Beamter",
    policiaCaca: "Kack-Polizist",
    oficialDeposiciones: "Ablagerungs-Offizier",
    subinspectorMojon: "Unterinspektor der Hundehaufen",
    inspectorTrunos: "Haufen-Inspektor",
    inspectorJefeMarron: "Chefinspektor der Schweinerei",
    comisarioHecesUrbanas: "Kommissar für städtische Hinterlassenschaften",
    comisarioApocalipsisCanino: "Hauptkommissar der Hunde-Apokalypse",
    directorCagadaNacional: "Generaldirektor der nationalen Kack-Krise",
  },
  nl: {
    aspiranteCagon: "Poepcadet",
    agenteExcrementos: "Uitwerpselenagent",
    policiaCaca: "Poepagent",
    oficialDeposiciones: "Deponeer-officier",
    subinspectorMojon: "Onderinspecteur Drollen",
    inspectorTrunos: "Drolleninspecteur",
    inspectorJefeMarron: "Hoofdinspecteur van de Troep",
    comisarioHecesUrbanas: "Commissaris Stedelijke Uitwerpselen",
    comisarioApocalipsisCanino: "Hoofdcommissaris van de Hondenapocalyps",
    directorCagadaNacional: "Directeur-generaal van de Nationale Poepcrisis",
  },
  pl: {
    aspiranteCagon: "Kadet Kupy",
    agenteExcrementos: "Agent od Odchodów",
    policiaCaca: "Patrolowy Kupy",
    oficialDeposiciones: "Oficer Depozytów",
    subinspectorMojon: "Podinspektor Kloców",
    inspectorTrunos: "Inspektor Kupsztali",
    inspectorJefeMarron: "Główny Inspektor Bajzlu",
    comisarioHecesUrbanas: "Komisarz Miejskich Odchodów",
    comisarioApocalipsisCanino: "Główny Komisarz Psiej Apokalipsy",
    directorCagadaNacional: "Dyrektor Generalny Narodowego Kryzysu Kupowego",
  },
  uk: {
    aspiranteCagon: "Кадет Какашок",
    agenteExcrementos: "Агент Екскрементів",
    policiaCaca: "Патруль Какашок",
    oficialDeposiciones: "Офіцер Відкладень",
    subinspectorMojon: "Заступник Інспектора Куп",
    inspectorTrunos: "Інспектор Куп",
    inspectorJefeMarron: "Головний Інспектор Безладу",
    comisarioHecesUrbanas: "Комісар Міських Екскрементів",
    comisarioApocalipsisCanino: "Головний Комісар Собачого Апокаліпсису",
    directorCagadaNacional: "Генеральний Директор Національної Кака-Кризи",
  },
  ru: {
    aspiranteCagon: "Какашечный Кадет",
    agenteExcrementos: "Агент Экскрементов",
    policiaCaca: "Какашечный Патрульный",
    oficialDeposiciones: "Офицер Отложений",
    subinspectorMojon: "Заместитель Инспектора Куч",
    inspectorTrunos: "Инспектор Куч",
    inspectorJefeMarron: "Главный Инспектор Бардака",
    comisarioHecesUrbanas: "Комиссар Городских Следов",
    comisarioApocalipsisCanino: "Главный Комиссар Собачьего Апокалипсиса",
    directorCagadaNacional: "Генеральный Директор Национального Кака-Кризиса",
  },
  eu: {
    aspiranteCagon: "Kakaren Ikaslea",
    agenteExcrementos: "Gorozkien Agentea",
    policiaCaca: "Kakaren Polizia",
    oficialDeposiciones: "Gorozkien Ofiziala",
    subinspectorMojon: "Zirin Ikuskatzaileordea",
    inspectorTrunos: "Kaka Ikuskatzailea",
    inspectorJefeMarron: "Nahastearen Ikuskatzaile Nagusia",
    comisarioHecesUrbanas: "Hiri Gorozkien Komisarioa",
    comisarioApocalipsisCanino: "Txakur Apokalipsiaren Komisario Nagusia",
    directorCagadaNacional: "Kaka Hondamendi Nazionalaren Zuzendari Nagusia",
  },
  ca: {
    aspiranteCagon: "Aspirant Cagador",
    agenteExcrementos: "Agent d’Excrements",
    policiaCaca: "Policia de la Caca",
    oficialDeposiciones: "Oficial de Deposicions",
    subinspectorMojon: "Subinspector del Tros",
    inspectorTrunos: "Inspector de Cagarros",
    inspectorJefeMarron: "Inspector en Cap del Merder",
    comisarioHecesUrbanas: "Comissari d’Excrements Urbans",
    comisarioApocalipsisCanino: "Comissari Principal de l’Apocalipsi Canina",
    directorCagadaNacional: "Director General de la Cagada Nacional",
  },
  val: {
    aspiranteCagon: "Aspirant Cagador",
    agenteExcrementos: "Agent d’Excrements",
    policiaCaca: "Policia de la Caca",
    oficialDeposiciones: "Oficial de Deposicions",
    subinspectorMojon: "Subinspector del Tros",
    inspectorTrunos: "Inspector de Cagarros",
    inspectorJefeMarron: "Inspector en Cap del Merder",
    comisarioHecesUrbanas: "Comissari d’Excrements Urbans",
    comisarioApocalipsisCanino: "Comissari Principal de l’Apocalipsi Canina",
    directorCagadaNacional: "Director General de la Cagada Nacional",
  },
};

const rankUiTranslations = {
  es: {
    yourRank: "Tu Rango",
    levelPercentile: "Nivel {level} — Percentil {percentile}%",
    rankPromotion: "Has ascendido a {rank}",
    rankChanged: "Tu rango ha cambiado a {rank}",
    cityPosition: "Eres #{rank} en {city}",
    cityFallback: "tu ciudad",
    rankSystemFeature: "Sistema de rangos y racha",
    rankAlertsFeature: "Alertas de cambio de rango",
    visibleRankFeature: "Nombre y rango visible en reportes",
    profileShareText: "{name} es {rank} con {score} puntos y {reports} reportes. {badges} insignias. ¡Únete a mantener tu ciudad limpia!",
    profileCopied: "Perfil copiado al portapapeles",
    shareTitle: "{name} en Caca Radar",
    downloadText: "Descarga Caca Radar:\niOS: {ios}\nAndroid: {android}",
  },
  en: {
    yourRank: "Your Rank",
    levelPercentile: "Level {level} — Percentile {percentile}%",
    rankPromotion: "You have been promoted to {rank}",
    rankChanged: "Your rank changed to {rank}",
    cityPosition: "You are #{rank} in {city}",
    cityFallback: "your city",
    rankSystemFeature: "Ranks and streak system",
    rankAlertsFeature: "Rank-change alerts",
    visibleRankFeature: "Name and rank visible on reports",
    profileShareText: "{name} is {rank} with {score} points and {reports} reports. {badges} badges. Join in and help keep your city clean!",
    profileCopied: "Profile copied to clipboard",
    shareTitle: "{name} on Caca Radar",
    downloadText: "Download Caca Radar:\niOS: {ios}\nAndroid: {android}",
  },
  de: {
    yourRank: "Dein Rang",
    levelPercentile: "Level {level} — Perzentil {percentile}%",
    rankPromotion: "Du wurdest befördert zu {rank}",
    rankChanged: "Dein Rang ist jetzt {rank}",
    cityPosition: "Du bist #{rank} in {city}",
    cityFallback: "deiner Stadt",
    rankSystemFeature: "Rang- und Serien-System",
    rankAlertsFeature: "Benachrichtigungen bei Rangwechseln",
    visibleRankFeature: "Name und Rang sichtbar in Meldungen",
    profileShareText: "{name} ist {rank} mit {score} Punkten und {reports} Meldungen. {badges} Abzeichen. Mach mit und halte deine Stadt sauber!",
    profileCopied: "Profil in die Zwischenablage kopiert",
    shareTitle: "{name} auf Caca Radar",
    downloadText: "Caca Radar herunterladen:\niOS: {ios}\nAndroid: {android}",
  },
  nl: {
    yourRank: "Je rang",
    levelPercentile: "Level {level} — Percentiel {percentile}%",
    rankPromotion: "Je bent gepromoveerd tot {rank}",
    rankChanged: "Je rang is nu {rank}",
    cityPosition: "Je bent #{rank} in {city}",
    cityFallback: "je stad",
    rankSystemFeature: "Rangen- en streaksysteem",
    rankAlertsFeature: "Meldingen bij rangwijzigingen",
    visibleRankFeature: "Naam en rang zichtbaar bij meldingen",
    profileShareText: "{name} is {rank} met {score} punten en {reports} meldingen. {badges} badges. Doe mee en houd je stad schoon!",
    profileCopied: "Profiel gekopieerd naar klembord",
    shareTitle: "{name} op Caca Radar",
    downloadText: "Download Caca Radar:\niOS: {ios}\nAndroid: {android}",
  },
  pl: {
    yourRank: "Twoja ranga",
    levelPercentile: "Poziom {level} — Percentyl {percentile}%",
    rankPromotion: "Awansujesz na rangę {rank}",
    rankChanged: "Twoja ranga zmieniła się na {rank}",
    cityPosition: "Jesteś #{rank} w {city}",
    cityFallback: "swoim mieście",
    rankSystemFeature: "System rang i serii",
    rankAlertsFeature: "Alerty o zmianie rangi",
    visibleRankFeature: "Nazwa i ranga widoczne przy zgłoszeniach",
    profileShareText: "{name} to {rank} z {score} punktami i {reports} zgłoszeniami. Odznaki: {badges}. Dołącz i pomóż utrzymać miasto w czystości!",
    profileCopied: "Profil skopiowany do schowka",
    shareTitle: "{name} w Caca Radar",
    downloadText: "Pobierz Caca Radar:\niOS: {ios}\nAndroid: {android}",
  },
  uk: {
    yourRank: "Ваш ранг",
    levelPercentile: "Рівень {level} — Перцентиль {percentile}%",
    rankPromotion: "Вас підвищено до {rank}",
    rankChanged: "Ваш ранг змінено на {rank}",
    cityPosition: "Ви #{rank} у {city}",
    cityFallback: "вашому місті",
    rankSystemFeature: "Система рангів і серій",
    rankAlertsFeature: "Сповіщення про зміну рангу",
    visibleRankFeature: "Ім’я та ранг видно у повідомленнях",
    profileShareText: "{name} — {rank} з {score} балами та {reports} повідомленнями. Відзнаки: {badges}. Долучайтеся й допомагайте тримати місто чистим!",
    profileCopied: "Профіль скопійовано",
    shareTitle: "{name} у Caca Radar",
    downloadText: "Завантажити Caca Radar:\niOS: {ios}\nAndroid: {android}",
  },
  ru: {
    yourRank: "Ваш ранг",
    levelPercentile: "Уровень {level} — Перцентиль {percentile}%",
    rankPromotion: "Вы повышены до {rank}",
    rankChanged: "Ваш ранг изменился на {rank}",
    cityPosition: "Вы #{rank} в {city}",
    cityFallback: "вашем городе",
    rankSystemFeature: "Система рангов и серий",
    rankAlertsFeature: "Уведомления о смене ранга",
    visibleRankFeature: "Имя и ранг видны в сообщениях",
    profileShareText: "{name} — {rank} с {score} очками и {reports} сообщениями. Значков: {badges}. Присоединяйтесь и помогайте держать город чистым!",
    profileCopied: "Профиль скопирован",
    shareTitle: "{name} в Caca Radar",
    downloadText: "Скачать Caca Radar:\niOS: {ios}\nAndroid: {android}",
  },
  eu: {
    yourRank: "Zure maila",
    levelPercentile: "{level}. maila — {percentile}. pertzentila",
    rankPromotion: "{rank} mailara igo zara",
    rankChanged: "Zure maila {rank} da orain",
    cityPosition: "#{rank} zara {city} hirian",
    cityFallback: "zure hirian",
    rankSystemFeature: "Maila eta segida sistema",
    rankAlertsFeature: "Maila aldaketen alertak",
    visibleRankFeature: "Izena eta maila salaketetan ikusgai",
    profileShareText: "{name} {rank} da, {score} puntu eta {reports} salaketarekin. {badges} domina. Batu eta lagundu zure hiria garbi mantentzen!",
    profileCopied: "Profila arbelean kopiatu da",
    shareTitle: "{name} Caca Radarren",
    downloadText: "Deskargatu Caca Radar:\niOS: {ios}\nAndroid: {android}",
  },
  ca: {
    yourRank: "El teu rang",
    levelPercentile: "Nivell {level} — Percentil {percentile}%",
    rankPromotion: "Has ascendit a {rank}",
    rankChanged: "El teu rang ha canviat a {rank}",
    cityPosition: "Ets #{rank} a {city}",
    cityFallback: "la teva ciutat",
    rankSystemFeature: "Sistema de rangs i ratxa",
    rankAlertsFeature: "Alertes de canvi de rang",
    visibleRankFeature: "Nom i rang visibles als reports",
    profileShareText: "{name} és {rank} amb {score} punts i {reports} reports. {badges} insígnies. Uneix-t’hi i ajuda a mantenir la ciutat neta!",
    profileCopied: "Perfil copiat al porta-retalls",
    shareTitle: "{name} a Caca Radar",
    downloadText: "Descarrega Caca Radar:\niOS: {ios}\nAndroid: {android}",
  },
  val: {
    yourRank: "El teu rang",
    levelPercentile: "Nivell {level} — Percentil {percentile}%",
    rankPromotion: "Has ascendit a {rank}",
    rankChanged: "El teu rang ha canviat a {rank}",
    cityPosition: "Eres #{rank} a {city}",
    cityFallback: "la teua ciutat",
    rankSystemFeature: "Sistema de rangs i ratxa",
    rankAlertsFeature: "Alertes de canvi de rang",
    visibleRankFeature: "Nom i rang visibles als reports",
    profileShareText: "{name} és {rank} amb {score} punts i {reports} reports. {badges} insígnies. Unix-te i ajuda a mantindre la ciutat neta!",
    profileCopied: "Perfil copiat al porta-retalls",
    shareTitle: "{name} a Caca Radar",
    downloadText: "Descarrega Caca Radar:\niOS: {ios}\nAndroid: {android}",
  },
};

Object.keys(translations).forEach((lang) => {
  translations[lang].ranks = rankTranslations[lang] || rankTranslations.es;
  translations[lang].rankUi = rankUiTranslations[lang] || rankUiTranslations.es;
});

const communityTranslations = {
  de: {
    reportEncouragement: "Jede Meldung hilft deiner Nachbarschaft. Du machst den Unterschied!",
    streakMessage: "{n} Tage in Folge beigetragen! Stark!",
  },
  nl: {
    reportEncouragement: "Elke melding helpt je buurt. Jij maakt het verschil!",
    streakMessage: "{n} dagen op rij bijgedragen! Geweldig!",
  },
  pl: {
    reportEncouragement: "Każde zgłoszenie pomaga Twojej okolicy. Robisz różnicę!",
    streakMessage: "{n} dni z rzędu pomagasz! Świetnie!",
  },
  uk: {
    reportEncouragement: "Кожне повідомлення допомагає вашому району. Ви змінюєте місто!",
    streakMessage: "{n} днів поспіль допомоги! Чудово!",
  },
  ru: {
    reportEncouragement: "Каждое сообщение помогает вашему району. Вы меняете город!",
    streakMessage: "{n} дней подряд помогаете! Отлично!",
  },
  eu: {
    reportEncouragement: "Salaketa bakoitzak zure auzoari laguntzen dio. Zuk egiten duzu aldea!",
    streakMessage: "{n} egun jarraian laguntzen! Bikain!",
  },
  ca: {
    reportEncouragement: "Cada report ajuda el teu barri. Tu marques la diferència!",
    streakMessage: "{n} dies seguits contribuint! Increïble!",
  },
  val: {
    reportEncouragement: "Cada report ajuda el teu barri. Tu marques la diferència!",
    streakMessage: "{n} dies seguits contribuint! Increïble!",
  },
};

Object.keys(communityTranslations).forEach((lang) => {
  Object.assign(translations[lang], communityTranslations[lang]);
});

const menuLegalTranslations = {
  es: {
    legalUi: {
      privacyPolicy: "Política de Privacidad",
      help: "Ayuda",
      legalAndHelp: "Ayuda y legal",
      versions: "Versiones",
      termsOfUse: "Términos de uso",
      cookiesPolicy: "Política de Cookies",
      communityGuidelines: "Normas de la comunidad",
      mainMenuAdvisory: "Caca Radar es una herramienta privada, independiente y no oficial. Los avisos del mapa son aportaciones de la comunidad y pueden ser exactos, incompletos, desactualizados o retirados tras moderación.",
    },
    mapUi: {
      communityReportsAdvisory: "Los avisos mostrados en Caca Radar son aportaciones de la comunidad. Pueden ser exactos, incompletos, desactualizados o retirados tras moderación.",
    },
  },
  en: {
    legalUi: {
      privacyPolicy: "Privacy Policy",
      help: "Help",
      legalAndHelp: "Help & legal",
      versions: "Versions",
      termsOfUse: "Terms of use",
      cookiesPolicy: "Cookie Policy",
      communityGuidelines: "Community guidelines",
      mainMenuAdvisory: "Caca Radar is a private, independent and unofficial tool. Map reports are community contributions and may be exact, incomplete, outdated or removed after moderation.",
    },
    mapUi: {
      communityReportsAdvisory: "The reports shown in Caca Radar are community contributions. They may be exact, incomplete, outdated or removed after moderation.",
    },
  },
  de: {
    legalUi: {
      privacyPolicy: "Datenschutzrichtlinie",
      help: "Hilfe",
      legalAndHelp: "Hilfe & Rechtliches",
      versions: "Versionen",
      termsOfUse: "Nutzungsbedingungen",
      cookiesPolicy: "Cookie-Richtlinie",
      communityGuidelines: "Community-Richtlinien",
      mainMenuAdvisory: "Caca Radar ist ein privates, unabhängiges und inoffizielles Tool. Kartenmeldungen sind Beiträge der Community und können exakt, unvollständig, veraltet oder nach der Moderation entfernt sein.",
    },
    mapUi: {
      communityReportsAdvisory: "Die in Caca Radar angezeigten Meldungen sind Beiträge der Community. Sie können exakt, unvollständig, veraltet oder nach der Moderation entfernt sein.",
    },
  },
  nl: {
    legalUi: {
      privacyPolicy: "Privacybeleid",
      help: "Hulp",
      legalAndHelp: "Hulp & juridisch",
      versions: "Versies",
      termsOfUse: "Gebruiksvoorwaarden",
      cookiesPolicy: "Cookiebeleid",
      communityGuidelines: "Communityrichtlijnen",
      mainMenuAdvisory: "Caca Radar is een privé, onafhankelijke en niet-officiële tool. Meldingen op de kaart zijn bijdragen van de community en kunnen exact, onvolledig, verouderd of na moderatie verwijderd zijn.",
    },
    mapUi: {
      communityReportsAdvisory: "De meldingen die in Caca Radar worden getoond, zijn bijdragen van de community. Ze kunnen exact, onvolledig, verouderd of na moderatie verwijderd zijn.",
    },
  },
  pl: {
    legalUi: {
      privacyPolicy: "Polityka prywatności",
      help: "Pomoc",
      legalAndHelp: "Pomoc i kwestie prawne",
      versions: "Wersje",
      termsOfUse: "Warunki korzystania",
      cookiesPolicy: "Polityka cookies",
      communityGuidelines: "Zasady społeczności",
      mainMenuAdvisory: "Caca Radar to prywatne, niezależne i nieoficjalne narzędzie. Zgłoszenia na mapie są wkładem społeczności i mogą być dokładne, niepełne, nieaktualne lub usunięte po moderacji.",
    },
    mapUi: {
      communityReportsAdvisory: "Zgłoszenia wyświetlane w Caca Radar są wkładem społeczności. Mogą być dokładne, niepełne, nieaktualne lub usunięte po moderacji.",
    },
  },
  uk: {
    legalUi: {
      privacyPolicy: "Політика конфіденційності",
      help: "Допомога",
      legalAndHelp: "Допомога та правова інформація",
      versions: "Версії",
      termsOfUse: "Умови використання",
      cookiesPolicy: "Політика файлів кукі",
      communityGuidelines: "Правила спільноти",
      mainMenuAdvisory: "Caca Radar — це приватний, незалежний і неофіційний сервіс. Позначки на мапі є внеском спільноти й можуть бути точними, неповними, застарілими або видаленими після модерації.",
    },
    mapUi: {
      communityReportsAdvisory: "Повідомлення, показані в Caca Radar, є внеском спільноти. Вони можуть бути точними, неповними, застарілими або видаленими після модерації.",
    },
  },
  ru: {
    legalUi: {
      privacyPolicy: "Политика конфиденциальности",
      help: "Помощь",
      legalAndHelp: "Помощь и правовая информация",
      versions: "Версии",
      termsOfUse: "Условия использования",
      cookiesPolicy: "Политика файлов куки",
      communityGuidelines: "Правила сообщества",
      mainMenuAdvisory: "Caca Radar — это частный, независимый и неофициальный сервис. Отметки на карте — это вклад сообщества, и они могут быть точными, неполными, устаревшими или удалёнными после модерации.",
    },
    mapUi: {
      communityReportsAdvisory: "Сообщения, показанные в Caca Radar, являются вкладом сообщества. Они могут быть точными, неполными, устаревшими или удалёнными после модерации.",
    },
  },
  eu: {
    legalUi: {
      privacyPolicy: "Pribatutasun Politika",
      help: "Laguntza",
      legalAndHelp: "Laguntza eta lege-oharrak",
      versions: "Bertsioak",
      termsOfUse: "Erabilera-baldintzak",
      cookiesPolicy: "Cookie Politika",
      communityGuidelines: "Komunitateko arauak",
      mainMenuAdvisory: "Caca Radar tresna pribatu, independente eta ez-ofiziala da. Mapako abisuak komunitatearen ekarpenak dira, eta zehatzak, osatugabeak, zaharkituak edo moderazioaren ondoren kenduak izan daitezke.",
    },
    mapUi: {
      communityReportsAdvisory: "Caca Radar-en agertzen diren abisuak komunitatearen ekarpenak dira. Zehatzak, osatugabeak, zaharkituak edo moderazioaren ondoren kenduak izan daitezke.",
    },
  },
  ca: {
    legalUi: {
      privacyPolicy: "Política de Privacitat",
      help: "Ajuda",
      legalAndHelp: "Ajuda i legal",
      versions: "Versions",
      termsOfUse: "Termes d'ús",
      cookiesPolicy: "Política de Cookies",
      communityGuidelines: "Normes de la comunitat",
      mainMenuAdvisory: "Caca Radar és una eina privada, independent i no oficial. Els avisos del mapa són aportacions de la comunitat i poden ser exactes, incomplets, desactualitzats o retirats després de la moderació.",
    },
    mapUi: {
      communityReportsAdvisory: "Els avisos mostrats a Caca Radar són aportacions de la comunitat. Poden ser exactes, incomplets, desactualitzats o retirats després de la moderació.",
    },
  },
  val: {
    legalUi: {
      privacyPolicy: "Política de Privacitat",
      help: "Ajuda",
      legalAndHelp: "Ajuda i legal",
      versions: "Versions",
      termsOfUse: "Termes d'ús",
      cookiesPolicy: "Política de Cookies",
      communityGuidelines: "Normes de la comunitat",
      mainMenuAdvisory: "Caca Radar és una eina privada, independent i no oficial. Els avisos del mapa són aportacions de la comunitat i poden ser exactes, incomplets, desactualitzats o retirats després de la moderació.",
    },
    mapUi: {
      communityReportsAdvisory: "Els avisos mostrats a Caca Radar són aportacions de la comunitat. Poden ser exactes, incomplets, desactualitzats o retirats després de la moderació.",
    },
  },
};

Object.keys(translations).forEach((lang) => {
  const extra = menuLegalTranslations[lang] || menuLegalTranslations.es;
  Object.entries(extra).forEach(([group, values]) => {
    translations[lang][group] = {
      ...(translations[lang][group] || {}),
      ...values,
    };
  });
});

const premiumUiTranslations = {
  es: {
    cityRankingsFeature: "Ranking de ciudades más limpias/sucias",
    barrioRankingsFeature: "Ranking de barrios por limpieza",
    weeklyLeaderboardFeature: "Leaderboard completo + semanal",
    pointsMultiplierFeature: "Multiplicador de puntos 1.5x",
    premiumBadgeFeature: "Insignia Premium en el mapa",
  },
  en: {
    cityRankingsFeature: "Cleanest/dirtiest city rankings",
    barrioRankingsFeature: "Neighborhood cleanliness rankings",
    weeklyLeaderboardFeature: "Full + weekly leaderboard",
    pointsMultiplierFeature: "1.5x points multiplier",
    premiumBadgeFeature: "Premium badge on the map",
  },
  de: {
    cityRankingsFeature: "Ranking der saubersten/schmutzigsten Städte",
    barrioRankingsFeature: "Sauberkeitsranking der Stadtviertel",
    weeklyLeaderboardFeature: "Vollständiges + wöchentliches Leaderboard",
    pointsMultiplierFeature: "1,5x Punkte-Multiplikator",
    premiumBadgeFeature: "Premium-Abzeichen auf der Karte",
  },
  nl: {
    cityRankingsFeature: "Ranking van schoonste/vuilste steden",
    barrioRankingsFeature: "Wijkranking op netheid",
    weeklyLeaderboardFeature: "Volledig + wekelijks leaderboard",
    pointsMultiplierFeature: "1,5x puntenvermenigvuldiger",
    premiumBadgeFeature: "Premiumbadge op de kaart",
  },
  pl: {
    cityRankingsFeature: "Ranking najczystszych/najbrudniejszych miast",
    barrioRankingsFeature: "Ranking czystości dzielnic",
    weeklyLeaderboardFeature: "Pełny i tygodniowy leaderboard",
    pointsMultiplierFeature: "Mnożnik punktów 1,5x",
    premiumBadgeFeature: "Odznaka Premium na mapie",
  },
  uk: {
    cityRankingsFeature: "Рейтинг найчистіших/найбрудніших міст",
    barrioRankingsFeature: "Рейтинг чистоти районів",
    weeklyLeaderboardFeature: "Повна і тижнева таблиця лідерів",
    pointsMultiplierFeature: "Множник балів 1,5x",
    premiumBadgeFeature: "Значок Преміум на карті",
  },
  ru: {
    cityRankingsFeature: "Рейтинг самых чистых/грязных городов",
    barrioRankingsFeature: "Рейтинг чистоты районов",
    weeklyLeaderboardFeature: "Полная и недельная таблица лидеров",
    pointsMultiplierFeature: "Множитель очков 1,5x",
    premiumBadgeFeature: "Значок Премиум на карте",
  },
  eu: {
    cityRankingsFeature: "Hiri garbien/zikinien sailkapena",
    barrioRankingsFeature: "Auzoen garbitasun sailkapena",
    weeklyLeaderboardFeature: "Leaderboard osoa + astekoa",
    pointsMultiplierFeature: "1,5x puntu biderkatzailea",
    premiumBadgeFeature: "Premium domina mapan",
  },
  ca: {
    cityRankingsFeature: "Rànquing de ciutats més netes/brutes",
    barrioRankingsFeature: "Rànquing de barris per netedat",
    weeklyLeaderboardFeature: "Leaderboard complet + setmanal",
    pointsMultiplierFeature: "Multiplicador de punts 1,5x",
    premiumBadgeFeature: "Insígnia Premium al mapa",
  },
  val: {
    cityRankingsFeature: "Rànquing de ciutats més netes/brutes",
    barrioRankingsFeature: "Rànquing de barris per netedat",
    weeklyLeaderboardFeature: "Leaderboard complet + setmanal",
    pointsMultiplierFeature: "Multiplicador de punts 1,5x",
    premiumBadgeFeature: "Insígnia Premium al mapa",
  },
};

Object.keys(translations).forEach((lang) => {
  translations[lang].premiumUi = premiumUiTranslations[lang] || premiumUiTranslations.es;
});

const appUiTranslations = {
  es: {
    mapUi: {
      registerToReport: "Regístrate gratis para reportar",
      registerToVote: "Regístrate gratis para votar",
      registerToValidate: "Regístrate gratis para validar",
      confirmed: "Confirmado",
      rejected: "Rechazado",
      validationError: "Error al validar",
      noLongerHere: "Ya no está",
      noLongerHereCount: "ya no está",
      alreadyMarkedResolved: "Ya marcaste este reporte",
      proximityRequired: "Debes estar a menos de {meters} m para confirmar, rechazar o marcar que ya no está.",
      locationRequiredForAction: "Necesitamos tu GPS para esta acción. Acércate a menos de {meters} m e inténtalo de nuevo.",
      tooFarFromReport: "Estás demasiado lejos del reporte ({distance} m). Debes estar a menos de {meters} m.",
      useValidationToConfirm: "Usa Confirmar o Rechazar para indicar si el reporte sigue ahí.",
      voteSuccess: { noLongerHere: "Marcado como ya no está", upvote: "Voto positivo registrado", downvote: "Voto negativo registrado" },
      voteError: "Error al marcar el reporte",
      downvoteGoneQuestion: "¿Ya no está esta caca?",
      linkCopied: "Enlace copiado al portapapeles",
      shareError: "Error al compartir",
      pushUnsupported: "Tu navegador no soporta notificaciones push",
      pushUnavailableOnThisBuild: "Las notificaciones push en iPhone estarán disponibles cuando Apple active la cuenta de desarrollador.",
      pushDisabled: "Notificaciones desactivadas",
      pushEnabledNearby: "Notificaciones activadas para reportes cercanos",
      pushEnabled: "Notificaciones activadas",
      pushPermissionDenied: "Permiso de notificaciones denegado",
      pushError: "Error activando notificaciones",
      anonymous: "Anónimo",
      registeredUser: "Usuario registrado",
      unranked: "Sin rango",
      userFallback: "Usuario",
      feedback: "Feedback",
      myProfile: "Mi Perfil",
      myImpact: "Mi Impacto",
      pointsShort: "pts",
      dayShort: "d",
      descriptionPlaceholder: "Descripción opcional...",
      photoAlt: "Foto",
      photoCompressionError: "No pudimos preparar la foto. Prueba con otra imagen o vuelve a intentarlo.",
      photoCompressedWarning: "La foto se ha optimizado, pero sigue siendo algo pesada.",
      filters: { all: "Todos", verified: "Verificados", fresh: "Fresca", moderate: "En proceso", old: "Fósil" },
      status: { verified: "Verificado", rejected: "Rechazado", pending: "Pendiente" },
      privateReportsTitle: "Los reportes son privados",
      privateReportsBody: "Inicia sesión para ver reportes comunitarios y usar el mapa completo.",
      privateReportsMunicipalityNote: "Las cuentas municipales y autorizadas siguen accediendo desde sus flujos autenticados.",
      confidence: "Confianza: {value}%",
      validations: "{count} validaciones",
      helpful: "Útil",
      notHelpful: "No útil",
      confirm: "Confirmar",
      reject: "Rechazar",
      yourValidation: "Tu validación: {value}",
      share: "Compartir",
      recenterMap: "Centrar mapa",
      signIn: "Iniciar sesión",
      createAccount: "Crear cuenta",
      notificationTitle: "Activa las notificaciones",
      notificationBody: "Te avisaremos de reportes cerca de ti",
      notificationNo: "No",
    },
    profileUi: {
      usernameTooShort: "Mínimo 3 caracteres",
      usernameUpdated: "Nombre de usuario actualizado",
      shareError: "Error al compartir",
      upgradePremium: "Hazte Premium",
      shareProfile: "Compartir perfil",
      communityImpact: "Mi Impacto Comunitario",
      totalPoints: "Puntos totales",
      reports: "Reportes",
      votes: "Votos",
      streak: "Racha",
      accuracy: "Precisión",
      impact: "Impacto",
      badges: "Insignias",
      trustLevel: "Nivel de Confianza",
      status: "Estado",
      trustTiers: { restricted: "Restringido", low: "Bajo", normal: "Normal", trusted: "Confiable" },
      notifications: "Notificaciones",
      notificationsDesc: "Recibe avisos cuando se reporten cacas cerca de tus ubicaciones guardadas.",
      browserPermissionDenied: "Permiso de notificaciones denegado en el navegador",
      loginMethods: "Métodos de acceso",
      loginMethodsDesc: "Vincula Google o Apple para entrar con el mismo perfil desde otros métodos de acceso.",
      googleLinked: "Google vinculado",
      appleLinked: "Apple vinculado",
      linkApple: "Vincular Apple",
      passwordLogin: "Email y contraseña",
      linked: "Vinculado",
      notLinked: "Sin vincular",
      scoringTitle: "Cómo ganar puntos",
      scoreReport: "Reportar",
      scoreCorrectValidation: "Validación correcta",
      scoreVerifiedReport: "Reporte verificado",
      scoreUpvoteReceived: "Voto positivo recibido",
      scoreStreak: "Racha 7 / 14 / 30 días",
      scorePhotoDescription: "+5 foto, +3 descripción",
      scoreFirstFive: "+5 bonus primeros 5",
      premiumMultiplier: "Premium: multiplicador 1.5x en todos los puntos",
    },
    feedbackUi: {
      bug: "Bug / Error",
      suggestion: "Sugerencia",
      other: "Otro",
      messageRequired: "Escribe un mensaje",
      thanks: "Gracias por tu feedback",
      sendError: "Error al enviar. Inténtalo de nuevo.",
      bugPlaceholder: "Describe el problema que encontraste...",
      ideaPlaceholder: "Cuéntanos tu idea...",
      send: "Enviar",
    },
    authRecovery: {
      forgotLink: "¿Olvidaste tu contraseña?",
      checkEmailTitle: "Revisa tu email",
      checkEmailBody: "Si {email} tiene una cuenta, recibirás un enlace para restablecer tu contraseña.",
      backToLogin: "Volver a iniciar sesión",
      forgotTitle: "¿Olvidaste tu contraseña?",
      forgotDescription: "Introduce tu email y te enviaremos un enlace para restablecerla.",
      sendLink: "Enviar enlace",
      sendError: "Error al enviar. Inténtalo de nuevo.",
      resetSuccessTitle: "Contraseña actualizada",
      resetSuccessBody: "Ya puedes iniciar sesión con tu nueva contraseña.",
      newPasswordTitle: "Nueva contraseña",
      newPasswordDescription: "Introduce tu nueva contraseña.",
      newPasswordLabel: "Nueva contraseña",
      confirmPasswordLabel: "Confirmar contraseña",
      repeatPasswordPlaceholder: "Repite la contraseña",
      resetPassword: "Restablecer contraseña",
      requestNewLink: "Solicitar nuevo enlace",
      passwordsDoNotMatch: "Las contraseñas no coinciden",
      invalidLink: "Enlace inválido. Solicita uno nuevo.",
      passwordUpdated: "Contraseña actualizada",
      resetError: "Error al restablecer. El enlace puede haber expirado.",
    },
    subscriptionUi: {
      trialActivated: "Prueba gratuita de 7 días activada",
      subscriptionActivated: "Suscripción activada",
      freePhotoDesc: "Reportar con foto y descripción",
      freeMapReports: "Ver todos los reportes en el mapa",
      freeValidate: "Confirmar y validar reportes",
      heatDensity: "Mapa de calor de densidad",
      advancedFilterDetails: "Filtros avanzados (frescura, estado)",
      nearbyPushAlerts: "Alertas push para reportes cercanos",
      cleanRoute: "Ruta limpia (evitar zonas sucias)",
      premiumTitle: "Caca Radar Premium",
      premiumSubtitle: "Herramientas avanzadas para mantener tu ciudad limpia",
      free: "Gratis",
      alreadyPremium: "Ya eres Premium",
      enjoyFeatures: "Disfruta de todas las funciones",
      freeTrialTitle: "7 días GRATIS",
      freeTrialSubtitle: "Prueba todas las funciones premium sin compromiso",
      startFreeTrial: "Empezar prueba gratuita",
      monthly: "Mensual",
      annual: "Anual",
      monthlyPriceFallback: "0,99 €",
      annualPriceFallback: "9,99 €",
      perMonth: "/mes",
      perYear: "/año",
      save37: "MEJOR VALOR",
      onlyMonthly: "Se factura anualmente",
      subscribe: "Suscribirse",
      appStoreManaged: "La suscripción Premium en iPhone se gestiona mediante la compra oficial de App Store.",
      restorePurchases: "Restaurar compras",
      restoringPurchases: "Restaurando...",
      restoreSuccess: "Compras restauradas correctamente",
      restoreError: "No se pudieron restaurar las compras",
      noPurchasesToRestore: "No encontramos compras activas para restaurar",
      loadingStoreProducts: "Cargando precios oficiales de App Store...",
      storeProductsUnavailable: "No se pudieron cargar los productos de App Store",
      purchaseCancelled: "Compra cancelada",
      purchasePending: "La compra está pendiente de confirmación",
      purchaseUnknown: "La compra no pudo completarse correctamente",
      purchaseError: "No se pudo completar la compra",
      processingPurchase: "Procesando...",
      municipalAccountsTitle: "Cuentas municipales",
      municipalAccountsSubtitle: "Da a tu Ayuntamiento una forma simple de detectar puntos recurrentes de suciedad, revisar avisos vecinales y mostrar progreso visible en las zonas problemáticas.",
      municipalPopulationGuide: "Elige el plan según la población oficial del municipio.",
      municipalAccountsSetupNote: "Las funciones municipales se activan durante el onboarding. Algunas herramientas pueden configurarse según las necesidades del municipio.",
      municipalPilotNote: "Configuración piloto disponible para los primeros municipios.",
      mostCommonMunicipal: "La opción más habitual para pueblos y ciudades pequeñas",
      municipalAnnualRecommended: "Solo anual",
      municipalAnnualOnlyLabel: "Facturación",
      municipalAnnualOnlyNote: "Suscripción anual. Sin opción mensual municipal.",
      requestMunicipalAccess: "Solicitar acceso municipal",
      municipalPopulationLabel: "Población",
      municipalConfiguredIndividually: "Las cuentas municipales se configuran individualmente tras el onboarding. Las funciones pueden activarse progresivamente según las necesidades del municipio y el flujo de trabajo local disponible.",
      municipalBillingContact: "Para suscripciones municipales, pagos y facturas: jefe@cacaradar.es",
      municipalNativeQuestionsContact: "Las suscripciones municipales se gestionan mediante App Store o Google Play. Para preguntas sobre suscripciones municipales, onboarding o facturas, contacte con jefe@cacaradar.es.",
      municipalOnboardingContact: "El acceso municipal se activa tras el contacto inicial y el onboarding.",
      municipalBasicTitle: "Municipal Básico",
      municipalBasicPopulation: "Hasta 20.000 habitantes",
      municipalBasicAnnualPrice: "399 €/año + IVA",
      municipalBasicDescription: "Para municipios pequeños que quieren una forma clara y accesible de seguir los avisos locales.",
      municipalPlusTitle: "Municipal Plus",
      municipalPlusPopulation: "20.001–100.000 habitantes",
      municipalPlusAnnualPrice: "799 €/año + IVA",
      municipalPlusDescription: "Para municipios medianos que necesitan más visibilidad operativa, personal compartido y seguimiento por barrio.",
      municipalProTitle: "Municipal Pro",
      municipalProPopulation: "100.001+ habitantes",
      municipalProAnnualPrice: "999 €/año + IVA",
      municipalProDescription: "Para ciudades y despliegues amplios que requieren equipos, mapas avanzados y una puesta en marcha más personalizada.",
      municipalProCustomQuote: "Los despliegues metropolitanos, provinciales o personalizados pueden requerir un presupuesto a medida.",
      subscribeMunicipalBasic: "Subscribe to Municipal Básico",
      subscribeMunicipalPlus: "Subscribe to Municipal Plus",
      subscribeMunicipalPro: "Subscribe to Municipal Pro",
      municipalFeatureVerifiedProfile: "Perfil municipal verificado",
      municipalFeaturePublicReports: "Acceso a los avisos del municipio",
      municipalFeatureBasicDashboard: "Dashboard municipal básico de reportes",
      municipalFeatureBasicMap: "Mapa básico de reportes",
      municipalFeatureResolve: "Capacidad para marcar avisos como revisados o resueltos",
      municipalFeatureMonthlyExport: "Exportación mensual de reportes",
      municipalFeatureEmailSupport: "Soporte por email",
      municipalFeatureEverythingBasic: "Todo lo incluido en Municipal Básico",
      municipalFeatureStaffAccounts: "Múltiples cuentas de personal",
      municipalFeatureBarrioFilters: "Filtros por barrio o distrito",
      municipalFeatureVisibleStatuses: "Actualizaciones de estado visibles para los usuarios",
      municipalFeatureBasicAnalytics: "Dashboard básico de analíticas",
      municipalFeatureCsvExports: "Exportaciones CSV descargables",
      municipalFeatureReplyTemplates: "Plantillas de respuesta para avisos municipales frecuentes",
      municipalFeatureMonthlyPdf: "Resumen mensual en PDF",
      municipalFeatureEverythingPlus: "Todo lo incluido en Municipal Plus",
      municipalFeatureTeams: "Acceso para múltiples departamentos o equipos",
      municipalFeatureAdvancedHeatmaps: "Mapas de calor avanzados por barrio o zona personalizada",
      municipalFeaturePrioritySupport: "Soporte municipal prioritario",
      municipalFeatureCustomCategories: "Categorías de reportes personalizadas",
      municipalFeatureQuarterlyReports: "Informes analíticos trimestrales",
      municipalFeatureCampaignTools: "Herramientas para campañas públicas de limpieza",
      municipalFeatureCustomOnboarding: "Onboarding personalizado opcional",
      municipalities: "Para Ayuntamientos",
      municipalitySubtitle: "Paneles municipales personalizados, analíticas avanzadas y herramientas de gestión para equipos de limpieza.",
      registerMunicipality: "Registrar Municipio",
      createMunicipalityDashboard: "Crear panel municipal",
      municipalityFeatureDashboards: "Dashboards municipales activos con mapa, reportes, flags y seguimiento operativo por ciudad.",
      municipalityFeatureCleaning: "Los equipos de limpieza y gestión pueden marcar zonas o bloques de reportes como ya limpiados dentro de su municipio.",
      municipalityFeatureCustom: "Cada suscripción incluye dashboards personalizados y espacio para funcionalidades específicas de tu ayuntamiento.",
      municipalityFeatureSupport: "Onboarding acompañado, soporte prioritario y activación manual para ajustar el panel a vuestro flujo real.",
      municipalityAppStoreNote: "El alta municipal puede gestionarse mediante suscripción en la App Store dentro de la app.",
      municipalityBillingWarning: "Si necesitas factura o prefieres facturación directa, contacta con jefe@cacaradar.es antes de completar el alta.",
      municipalityManualSetup: "La activación de cada panel municipal se confirma manualmente tras la suscripción.",
      paymentNote: "Pago a través de App Store o Google Play. Cancela cuando quieras.",
    },
    activityUi: {
      nearbyReportsToday: "{count} reportes nuevos cerca de ti hoy",
      spainReportsToday: "{count} reportes nuevos en España hoy",
      activeZones: "{count} zonas activas",
      activeZonesInCity: "{count} zonas activas en {city}",
    },
    loginUi: {
      forgotPassword: "¿Olvidaste tu contraseña?",
      or: "o",
      appleComingSoon: "Apple ID (próximamente)",
      appleSignIn: "Continuar con Apple",
      appleSuccess: "Sesión iniciada con Apple",
      appleError: "Error al iniciar sesión con Apple",
      googleSuccess: "Sesión iniciada con Google",
      googleError: "Error al iniciar sesión con Google",
      googleBrowserOnly: "Google solo está disponible en el navegador web por ahora.",
      googleNotConfigured: "Google no está configurado en esta versión.",
      googleUnavailable: "No se pudo cargar Google Sign-In.",
      redirecting: "Redirigiendo...",
      connectingApple: "Conectando con Apple...",
      connectingGoogle: "Conectando con Google...",
      contentAdvisoryExtra: "No subas datos personales innecesarios de terceros. Evita rostros identificables, menores, matrículas u otra información personal salvo que sea estrictamente necesario y lícito.",
    },
    rankingUi: {
      cities: "Ciudades",
      neighborhoods: "Barrios",
      dirtiest: "Más sucias",
      cleanest: "Más limpias",
      citySummary: "{count} ciudades con reportes activos. Ordenadas por reportes / 10.000 hab.",
      noEnoughData: "No hay datos suficientes",
      points: "puntos",
      reports: "reportes",
      votes: "votos",
      streak: "racha",
      trust: "Confianza: {value}",
      national: "Nacional",
      byCity: "Por Ciudad",
      noDataYet: "No hay datos todavía",
      noCitiesWithReports: "No hay ciudades con reportes",
      noData: "No hay datos",
    },
    municipalityUi: {
      noDashboardAccess: "Esta cuenta no tiene acceso al panel de municipios.",
      invalidCredentials: "Credenciales inválidas",
      backToMap: "Volver al mapa",
      cityPanel: "Panel de Ayuntamiento",
      cityAccess: "Acceso Municipio",
      dashboardAccess: "Acceder al Panel",
      notRegistered: "¿Tu municipio no está registrado?",
      registerHere: "Regístrate aquí",
      backToLogin: "Volver al login",
      registerTitle: "Registra tu Ayuntamiento",
      registerSubtitle: "Usa tu email oficial del ayuntamiento para verificar tu identidad.",
      contactName: "Nombre del contacto",
      contactPlaceholder: "Nombre y apellido",
      municipalityName: "Nombre del municipio",
      province: "Provincia",
      officialEmail: "Email oficial del ayuntamiento",
      officialDomainHint: "Debe ser un dominio oficial (.es, .gob.es, .org)",
      registerMunicipality: "Registrar Municipio",
      appStoreSubscriptionNote: "El alta municipal puede gestionarse mediante suscripción en la App Store dentro de la app.",
      billingWarning: "Si necesitas factura o prefieres facturación directa, escribe a jefe@cacaradar.es antes de completar el alta.",
      manualActivationNote: "La activación de cada panel municipal se confirma manualmente tras la suscripción.",
      codeSent: "Código de verificación enviado a tu email",
      emailVerified: "Email verificado correctamente",
      invalidCode: "Código inválido",
      codeResent: "Código reenviado",
      resendError: "Error al reenviar el código",
      verifyEmail: "Verifica tu email",
      codeSentTo: "Hemos enviado un código de 6 dígitos a {email}",
      verificationCode: "Código de verificación",
      verify: "Verificar",
      resendCode: "Reenviar código",
      completedTitle: "Registro completado",
      completedBody: "Tu cuenta de municipio ha sido creada. Ya puedes acceder al panel de control.",
      goToDashboard: "Ir al Panel",
    },
    adminUi: {
      codeSent: "Código enviado a tu email",
      accessVerified: "Acceso verificado",
      wrongCode: "Código incorrecto",
      panel: "Panel de Administración",
      access: "Acceso Admin",
      stepCredentials: "Paso 1: Introduce tus credenciales",
      continue: "Continuar",
      verification: "Verificación",
      stepCode: "Paso 2: Introduce el código enviado a {email}",
      verifyAccess: "Verificar acceso",
      backToStep1: "Volver al paso 1",
    },
    analyticsUi: {
      title: "Analíticas — {municipality}",
      last30Days: "Datos de los últimos 30 días",
      reports30d: "Reportes (30d)",
      activeReports: "Activos",
      verified: "Verificados",
      avgResolution: "Tiempo medio resolución",
      flagRate: "Tasa de flags",
      vsPreviousMonth: "{delta}% vs mes anterior",
      timeline: "Evolución",
      byHour: "Por Hora",
      statuses: "Estados",
      topZones: "Top Zonas",
      reportsByDay: "Reportes por día",
      hourlyDistribution: "Distribución por hora del día",
      reportStatus: "Estado de reportes",
      topReportZones: "Zonas con más reportes",
      noEnoughData: "No hay suficientes datos",
    },
  },
  en: {
    mapUi: {
      registerToReport: "Sign up free to report",
      registerToVote: "Sign up free to vote",
      registerToValidate: "Sign up free to validate",
      confirmed: "Confirmed",
      rejected: "Rejected",
      validationError: "Error validating",
      noLongerHere: "No longer here",
      noLongerHereCount: "no longer here",
      alreadyMarkedResolved: "You already marked this report",
      proximityRequired: "You must be within {meters} m to confirm, reject, or mark a report as no longer here.",
      locationRequiredForAction: "We need your GPS for this action. Move within {meters} m and try again.",
      tooFarFromReport: "You are too far from the report ({distance} m). You must be within {meters} m.",
      useValidationToConfirm: "Use Confirm or Reject to indicate whether the report is still there.",
      voteSuccess: { noLongerHere: "Marked as no longer here", upvote: "Upvote recorded", downvote: "Downvote recorded" },
      voteError: "Error marking the report",
      downvoteGoneQuestion: "Is this mess already gone?",
      linkCopied: "Link copied to clipboard",
      shareError: "Error sharing",
      pushUnsupported: "Your browser does not support push notifications",
      pushUnavailableOnThisBuild: "Push notifications on iPhone will be available once Apple activates the developer account.",
      pushDisabled: "Notifications disabled",
      pushEnabledNearby: "Notifications enabled for nearby reports",
      pushEnabled: "Notifications enabled",
      pushPermissionDenied: "Notification permission denied",
      pushError: "Error enabling notifications",
      anonymous: "Anonymous",
      registeredUser: "Registered user",
      unranked: "Unranked",
      userFallback: "User",
      feedback: "Feedback",
      myProfile: "My Profile",
      myImpact: "My Impact",
      pointsShort: "pts",
      dayShort: "d",
      descriptionPlaceholder: "Optional description...",
      photoAlt: "Photo",
      photoCompressionError: "We couldn't prepare that photo. Try another image or try again.",
      photoCompressedWarning: "The photo was optimized, but it is still a bit large.",
      filters: { all: "All", verified: "Verified", fresh: "Fresh", moderate: "In progress", old: "Fossil" },
      status: { verified: "Verified", rejected: "Rejected", pending: "Pending" },
      privateReportsTitle: "Reports are private",
      privateReportsBody: "Sign in to view community reports and use the full map.",
      privateReportsMunicipalityNote: "Municipal and other authorized accounts still access reports through authenticated flows.",
      confidence: "Confidence: {value}%",
      validations: "{count} validations",
      helpful: "Helpful",
      notHelpful: "Not helpful",
      confirm: "Confirm",
      reject: "Reject",
      yourValidation: "Your validation: {value}",
      share: "Share",
      recenterMap: "Re-center map",
      signIn: "Sign in",
      createAccount: "Create account",
      notificationTitle: "Enable notifications",
      notificationBody: "We will alert you about reports nearby",
      notificationNo: "No",
    },
    profileUi: {
      usernameTooShort: "Minimum 3 characters",
      usernameUpdated: "Username updated",
      shareError: "Error sharing",
      upgradePremium: "Go Premium",
      shareProfile: "Share profile",
      communityImpact: "My Community Impact",
      totalPoints: "Total points",
      reports: "Reports",
      votes: "Votes",
      streak: "Streak",
      accuracy: "Accuracy",
      impact: "Impact",
      badges: "Badges",
      trustLevel: "Trust Level",
      status: "Status",
      trustTiers: { restricted: "Restricted", low: "Low", normal: "Normal", trusted: "Trusted" },
      notifications: "Notifications",
      notificationsDesc: "Get alerts when poop is reported near your saved locations.",
      browserPermissionDenied: "Notification permission denied in the browser",
      loginMethods: "Login methods",
      loginMethodsDesc: "Link Google or Apple so you can use the same profile across sign-in methods.",
      googleLinked: "Google linked",
      appleLinked: "Apple linked",
      linkApple: "Link Apple",
      passwordLogin: "Email and password",
      linked: "Linked",
      notLinked: "Not linked",
      scoringTitle: "How to earn points",
      scoreReport: "Report",
      scoreCorrectValidation: "Correct validation",
      scoreVerifiedReport: "Verified report",
      scoreUpvoteReceived: "Upvote received",
      scoreStreak: "7 / 14 / 30 day streak",
      scorePhotoDescription: "+5 photo, +3 description",
      scoreFirstFive: "+5 bonus for first 5",
      premiumMultiplier: "Premium: 1.5x multiplier on all points",
    },
    feedbackUi: {
      bug: "Bug / Error",
      suggestion: "Suggestion",
      other: "Other",
      messageRequired: "Write a message",
      thanks: "Thanks for your feedback",
      sendError: "Error sending. Try again.",
      bugPlaceholder: "Describe the problem you found...",
      ideaPlaceholder: "Tell us your idea...",
      send: "Send",
    },
    authRecovery: {
      forgotLink: "Forgot your password?",
      checkEmailTitle: "Check your email",
      checkEmailBody: "If {email} has an account, you will receive a link to reset your password.",
      backToLogin: "Back to login",
      forgotTitle: "Forgot your password?",
      forgotDescription: "Enter your email and we will send you a reset link.",
      sendLink: "Send link",
      sendError: "Error sending. Try again.",
      resetSuccessTitle: "Password updated",
      resetSuccessBody: "You can now log in with your new password.",
      newPasswordTitle: "New password",
      newPasswordDescription: "Enter your new password.",
      newPasswordLabel: "New password",
      confirmPasswordLabel: "Confirm password",
      repeatPasswordPlaceholder: "Repeat the password",
      resetPassword: "Reset password",
      requestNewLink: "Request a new link",
      passwordsDoNotMatch: "Passwords do not match",
      invalidLink: "Invalid link. Request a new one.",
      passwordUpdated: "Password updated",
      resetError: "Error resetting. The link may have expired.",
    },
    subscriptionUi: {
      trialActivated: "7-day free trial activated",
      subscriptionActivated: "Subscription activated",
      freePhotoDesc: "Report with photo and description",
      freeMapReports: "See all reports on the map",
      freeValidate: "Confirm and validate reports",
      heatDensity: "Density heatmap",
      advancedFilterDetails: "Advanced filters (freshness, status)",
      nearbyPushAlerts: "Push alerts for nearby reports",
      cleanRoute: "Clean route (avoid dirty zones)",
      premiumTitle: "Caca Radar Premium",
      premiumSubtitle: "Advanced tools to keep your city clean",
      free: "Free",
      alreadyPremium: "You are already Premium",
      enjoyFeatures: "Enjoy all features",
      freeTrialTitle: "7 days FREE",
      freeTrialSubtitle: "Try all premium features with no commitment",
      startFreeTrial: "Start free trial",
      monthly: "Monthly",
      annual: "Annual",
      monthlyPriceFallback: "€0.99",
      annualPriceFallback: "€9.99",
      perMonth: "/month",
      perYear: "/year",
      save37: "BEST VALUE",
      onlyMonthly: "Billed yearly",
      subscribe: "Subscribe",
      appStoreManaged: "Premium on iPhone is handled through the official App Store purchase flow.",
      restorePurchases: "Restore purchases",
      restoringPurchases: "Restoring...",
      restoreSuccess: "Purchases restored successfully",
      restoreError: "Could not restore purchases",
      noPurchasesToRestore: "We could not find any active purchases to restore",
      loadingStoreProducts: "Loading official App Store prices...",
      storeProductsUnavailable: "Could not load App Store products",
      purchaseCancelled: "Purchase cancelled",
      purchasePending: "The purchase is pending confirmation",
      purchaseUnknown: "The purchase could not be completed correctly",
      purchaseError: "Could not complete the purchase",
      processingPurchase: "Processing...",
      municipalAccountsTitle: "Municipal Accounts",
      municipalAccountsSubtitle: "Give your Ayuntamiento a simple way to monitor recurring cleanliness hotspots, review citizen reports, and show visible progress in problem areas.",
      municipalPopulationGuide: "Choose the plan based on the municipality’s official population.",
      municipalAccountsSetupNote: "Municipal features are activated during onboarding. Some tools may be configured according to the municipality’s needs.",
      municipalPilotNote: "Pilot setup available for early municipalities.",
      mostCommonMunicipal: "Most common for towns and small cities",
      municipalAnnualRecommended: "Annual only",
      municipalAnnualOnlyLabel: "Billing",
      municipalAnnualOnlyNote: "Annual subscription. No monthly municipal option.",
      requestMunicipalAccess: "Request Municipal Access",
      municipalPopulationLabel: "Population",
      municipalConfiguredIndividually: "Municipal accounts are configured individually after onboarding. Features may be activated progressively depending on the municipality’s needs and the available local workflow.",
      municipalBillingContact: "For municipal subscriptions, payment, and invoices: jefe@cacaradar.es",
      municipalNativeQuestionsContact: "Municipal subscriptions are handled through the App Store or Google Play. For questions about municipal subscriptions, onboarding, or invoices, contact jefe@cacaradar.es.",
      municipalOnboardingContact: "Municipal access is activated after contact and onboarding.",
      municipalBasicTitle: "Municipal Básico",
      municipalBasicPopulation: "Up to 20,000 residents",
      municipalBasicAnnualPrice: "€399/year + IVA",
      municipalBasicDescription: "For smaller municipalities that want a clear, lightweight way to follow local reports.",
      municipalPlusTitle: "Municipal Plus",
      municipalPlusPopulation: "20,001–100,000 residents",
      municipalPlusAnnualPrice: "€799/year + IVA",
      municipalPlusDescription: "For towns and growing cities that need staff access, barrio-level visibility, and stronger reporting tools.",
      municipalProTitle: "Municipal Pro",
      municipalProPopulation: "100,001+ residents",
      municipalProAnnualPrice: "€999/year + IVA",
      municipalProDescription: "For larger city deployments that need team access, advanced maps, and more tailored onboarding support.",
      municipalProCustomQuote: "Larger metropolitan, provincial, or custom deployments may require a tailored quote.",
      subscribeMunicipalBasic: "Subscribe to Municipal Básico",
      subscribeMunicipalPlus: "Subscribe to Municipal Plus",
      subscribeMunicipalPro: "Subscribe to Municipal Pro",
      municipalFeatureVerifiedProfile: "Verified municipal profile",
      municipalFeaturePublicReports: "Access to municipality reports",
      municipalFeatureBasicDashboard: "Basic municipal report dashboard",
      municipalFeatureBasicMap: "Basic map of reports",
      municipalFeatureResolve: "Ability to mark reports as reviewed or resolved",
      municipalFeatureMonthlyExport: "Monthly report export",
      municipalFeatureEmailSupport: "Email support",
      municipalFeatureEverythingBasic: "Everything in Municipal Básico",
      municipalFeatureStaffAccounts: "Multiple staff accounts",
      municipalFeatureBarrioFilters: "Barrio / district-level filtering",
      municipalFeatureVisibleStatuses: "Report status updates visible to users",
      municipalFeatureBasicAnalytics: "Basic analytics dashboard",
      municipalFeatureCsvExports: "Downloadable CSV exports",
      municipalFeatureReplyTemplates: "Response templates for common municipal replies",
      municipalFeatureMonthlyPdf: "Monthly summary PDF",
      municipalFeatureEverythingPlus: "Everything in Municipal Plus",
      municipalFeatureTeams: "Multiple department/team access",
      municipalFeatureAdvancedHeatmaps: "Advanced heatmaps by barrio or custom zone",
      municipalFeaturePrioritySupport: "Priority municipal support",
      municipalFeatureCustomCategories: "Custom report categories",
      municipalFeatureQuarterlyReports: "Quarterly analytics reports",
      municipalFeatureCampaignTools: "Campaign tools for public cleanliness initiatives",
      municipalFeatureCustomOnboarding: "Optional custom onboarding",
      municipalities: "For Municipalities",
      municipalitySubtitle: "Custom municipality dashboards, advanced analytics, and management tools for cleaning teams.",
      registerMunicipality: "Register Municipality",
      createMunicipalityDashboard: "Create municipality dashboard",
      municipalityFeatureDashboards: "Live municipal dashboards with map, reports, flags, and city-level operational tracking.",
      municipalityFeatureCleaning: "Cleaner and management accounts can mark cleaned areas or report clusters as resolved across their municipality.",
      municipalityFeatureCustom: "Every subscription includes personalized dashboards and room for custom features specific to your municipality.",
      municipalityFeatureSupport: "Guided onboarding, priority support, and manual activation so the dashboard matches your real workflow.",
      municipalityAppStoreNote: "Municipality onboarding can be handled through an App Store subscription inside the app.",
      municipalityBillingWarning: "If you require an invoice or need direct billing, contact jefe@cacaradar.es before completing onboarding.",
      municipalityManualSetup: "Each municipality dashboard is activated manually after the subscription is confirmed.",
      paymentNote: "Payment through the App Store or Google Play. Cancel anytime.",
    },
    activityUi: {
      nearbyReportsToday: "{count} new reports near you today",
      spainReportsToday: "{count} new reports in Spain today",
      activeZones: "{count} active zones",
      activeZonesInCity: "{count} active zones in {city}",
    },
    loginUi: {
      forgotPassword: "Forgot your password?",
      or: "or",
      appleComingSoon: "Apple ID (coming soon)",
      appleSignIn: "Continue with Apple",
      appleSuccess: "Signed in with Apple",
      appleError: "Error signing in with Apple",
      googleSuccess: "Signed in with Google",
      googleError: "Error signing in with Google",
      googleBrowserOnly: "Google sign-in is only available in the web browser for now.",
      googleNotConfigured: "Google sign-in is not configured for this build.",
      googleUnavailable: "Unable to load Google Sign-In.",
      redirecting: "Redirecting...",
      connectingApple: "Connecting with Apple...",
      connectingGoogle: "Connecting with Google...",
      contentAdvisoryExtra: "Do not upload unnecessary third-party personal data. Avoid identifiable faces, minors, license plates, or other personal information unless it is strictly necessary and lawful.",
    },
    rankingUi: {
      cities: "Cities",
      neighborhoods: "Neighborhoods",
      dirtiest: "Dirtiest",
      cleanest: "Cleanest",
      citySummary: "{count} cities with active reports. Sorted by reports / 10,000 residents.",
      noEnoughData: "Not enough data",
      points: "points",
      reports: "reports",
      votes: "votes",
      streak: "streak",
      trust: "Trust: {value}",
      national: "National",
      byCity: "By City",
      noDataYet: "No data yet",
      noCitiesWithReports: "No cities with reports",
      noData: "No data",
    },
    municipalityUi: {
      noDashboardAccess: "This account does not have municipality dashboard access.",
      invalidCredentials: "Invalid credentials",
      backToMap: "Back to map",
      cityPanel: "Municipality Panel",
      cityAccess: "Municipality Access",
      dashboardAccess: "Access Dashboard",
      notRegistered: "Is your municipality not registered?",
      registerHere: "Register here",
      backToLogin: "Back to login",
      registerTitle: "Register your Municipality",
      registerSubtitle: "Use your official municipality email to verify your identity.",
      contactName: "Contact name",
      contactPlaceholder: "First and last name",
      municipalityName: "Municipality name",
      province: "Province",
      officialEmail: "Official municipality email",
      officialDomainHint: "Must be an official domain (.es, .gob.es, .org)",
      registerMunicipality: "Register Municipality",
      appStoreSubscriptionNote: "Municipality onboarding can be handled through an App Store subscription inside the app.",
      billingWarning: "If you require an invoice or need direct billing, email jefe@cacaradar.es before completing onboarding.",
      manualActivationNote: "Each municipality dashboard is activated manually after the subscription is confirmed.",
      codeSent: "Verification code sent to your email",
      emailVerified: "Email verified successfully",
      invalidCode: "Invalid code",
      codeResent: "Code resent",
      resendError: "Error resending the code",
      verifyEmail: "Verify your email",
      codeSentTo: "We sent a 6-digit code to {email}",
      verificationCode: "Verification code",
      verify: "Verify",
      resendCode: "Resend code",
      completedTitle: "Registration complete",
      completedBody: "Your municipality account has been created. You can now access the dashboard.",
      goToDashboard: "Go to Dashboard",
    },
    adminUi: {
      codeSent: "Code sent to your email",
      accessVerified: "Access verified",
      wrongCode: "Incorrect code",
      panel: "Administration Panel",
      access: "Admin Access",
      stepCredentials: "Step 1: Enter your credentials",
      continue: "Continue",
      verification: "Verification",
      stepCode: "Step 2: Enter the code sent to {email}",
      verifyAccess: "Verify access",
      backToStep1: "Back to step 1",
    },
    analyticsUi: {
      title: "Analytics — {municipality}",
      last30Days: "Data from the last 30 days",
      reports30d: "Reports (30d)",
      activeReports: "Active",
      verified: "Verified",
      avgResolution: "Average resolution time",
      flagRate: "Flag rate",
      vsPreviousMonth: "{delta}% vs previous month",
      timeline: "Timeline",
      byHour: "By Hour",
      statuses: "Statuses",
      topZones: "Top Zones",
      reportsByDay: "Reports by day",
      hourlyDistribution: "Distribution by hour of day",
      reportStatus: "Report status",
      topReportZones: "Zones with most reports",
      noEnoughData: "Not enough data",
    },
  },
};

const localizedUiOverrides = {
  de: {
    mapUi: { registerToReport: "Kostenlos registrieren, um zu melden", registerToVote: "Kostenlos registrieren, um abzustimmen", registerToValidate: "Kostenlos registrieren, um zu validieren", confirmed: "Bestätigt", rejected: "Abgelehnt", validationError: "Fehler beim Validieren", noLongerHere: "Nicht mehr da", noLongerHereCount: "nicht mehr da", alreadyMarkedResolved: "Du hast diesen Bericht bereits markiert", proximityRequired: "Du musst innerhalb von {meters} m sein, um zu bestätigen, abzulehnen oder als nicht mehr da zu markieren.", locationRequiredForAction: "Wir brauchen dein GPS für diese Aktion. Geh auf weniger als {meters} m heran und versuche es erneut.", tooFarFromReport: "Du bist zu weit vom Bericht entfernt ({distance} m). Du musst innerhalb von {meters} m sein.", useValidationToConfirm: "Nutze Bestätigen oder Ablehnen, um anzugeben, ob der Bericht noch da ist.", voteSuccess: { noLongerHere: "Als nicht mehr da markiert" }, voteError: "Fehler beim Markieren des Berichts", linkCopied: "Link in die Zwischenablage kopiert", shareError: "Fehler beim Teilen", pushUnsupported: "Dein Browser unterstützt keine Push-Benachrichtigungen", pushUnavailableOnThisBuild: "Push-Benachrichtigungen auf dem iPhone sind verfügbar, sobald Apple das Entwicklerkonto aktiviert.", pushDisabled: "Benachrichtigungen deaktiviert", pushEnabledNearby: "Benachrichtigungen für Meldungen in der Nähe aktiviert", pushEnabled: "Benachrichtigungen aktiviert", pushPermissionDenied: "Benachrichtigungen verweigert", pushError: "Fehler beim Aktivieren der Benachrichtigungen", anonymous: "Anonym", registeredUser: "Registrierter Nutzer", unranked: "Ohne Rang", userFallback: "Nutzer", feedback: "Rückmeldung", myProfile: "Mein Profil", myImpact: "Mein Beitrag", pointsShort: "Pkt.", dayShort: "T", descriptionPlaceholder: "Optionale Beschreibung...", photoAlt: "Foto", filters: { all: "Alle", verified: "Verifiziert", fresh: "Frisch", moderate: "In Bearbeitung", old: "Fossil" }, status: { verified: "Verifiziert", rejected: "Abgelehnt", pending: "Ausstehend" }, confidence: "Vertrauen: {value}%", validations: "{count} Validierungen", helpful: "Hilfreich", notHelpful: "Nicht hilfreich", confirm: "Bestätigen", reject: "Ablehnen", yourValidation: "Deine Validierung: {value}", share: "Teilen", recenterMap: "Karte zentrieren", notificationTitle: "Benachrichtigungen aktivieren", notificationBody: "Wir melden dir Berichte in deiner Nähe", notificationNo: "Nein" },
    profileUi: { usernameTooShort: "Mindestens 3 Zeichen", usernameUpdated: "Benutzername aktualisiert", shareError: "Fehler beim Teilen", upgradePremium: "Premium werden", shareProfile: "Profil teilen", communityImpact: "Mein Community-Beitrag", totalPoints: "Gesamtpunkte", reports: "Meldungen", votes: "Stimmen", streak: "Serie", accuracy: "Genauigkeit", impact: "Wirkung", badges: "Abzeichen", trustLevel: "Vertrauensniveau", status: "Status", trustTiers: { restricted: "Eingeschränkt", low: "Niedrig", normal: "Normal", trusted: "Vertrauenswürdig" }, notifications: "Benachrichtigungen", notificationsDesc: "Erhalte Hinweise, wenn in der Nähe deiner gespeicherten Orte etwas gemeldet wird.", browserPermissionDenied: "Benachrichtigungen im Browser verweigert", scoringTitle: "So sammelst du Punkte", scoreReport: "Melden", scoreCorrectValidation: "Korrekte Validierung", scoreVerifiedReport: "Verifizierte Meldung", scoreUpvoteReceived: "Positive Stimme erhalten", scoreStreak: "7 / 14 / 30 Tage Serie", scorePhotoDescription: "+5 Foto, +3 Beschreibung", scoreFirstFive: "+5 Bonus für die ersten 5", premiumMultiplier: "Premium: 1,5x Multiplikator auf alle Punkte", appleLinked: "Apple verknüpft", linkApple: "Apple verknüpfen" },
    feedbackUi: { bug: "Bug / Fehler", suggestion: "Vorschlag", other: "Sonstiges", messageRequired: "Schreib eine Nachricht", thanks: "Danke für dein Feedback", sendError: "Fehler beim Senden. Versuch es erneut.", bugPlaceholder: "Beschreibe das Problem...", ideaPlaceholder: "Erzähl uns deine Idee...", send: "Senden" },
    authRecovery: { forgotLink: "Passwort vergessen?", checkEmailTitle: "Prüfe deine E-Mail", checkEmailBody: "Wenn {email} ein Konto hat, erhältst du einen Link zum Zurücksetzen.", backToLogin: "Zurück zum Login", forgotTitle: "Passwort vergessen?", forgotDescription: "Gib deine E-Mail ein und wir senden dir einen Link.", sendLink: "Link senden", sendError: "Fehler beim Senden. Versuch es erneut.", resetSuccessTitle: "Passwort aktualisiert", resetSuccessBody: "Du kannst dich jetzt mit deinem neuen Passwort anmelden.", newPasswordTitle: "Neues Passwort", newPasswordDescription: "Gib dein neues Passwort ein.", newPasswordLabel: "Neues Passwort", confirmPasswordLabel: "Passwort bestätigen", repeatPasswordPlaceholder: "Passwort wiederholen", resetPassword: "Passwort zurücksetzen", requestNewLink: "Neuen Link anfordern", passwordsDoNotMatch: "Passwörter stimmen nicht überein", invalidLink: "Ungültiger Link. Fordere einen neuen an.", passwordUpdated: "Passwort aktualisiert", resetError: "Fehler beim Zurücksetzen. Der Link ist möglicherweise abgelaufen." },
    loginUi: { forgotPassword: "Passwort vergessen?", or: "oder", appleComingSoon: "Apple ID (bald verfügbar)", appleSignIn: "Mit Apple fortfahren", appleSuccess: "Mit Apple angemeldet", appleError: "Fehler bei der Apple-Anmeldung", googleSuccess: "Mit Google angemeldet", googleError: "Fehler bei der Google-Anmeldung", redirecting: "Weiterleitung...", connectingApple: "Verbindung mit Apple...", connectingGoogle: "Verbindung mit Google..." },
  },
  nl: {
    mapUi: { registerToReport: "Registreer gratis om te melden", registerToVote: "Registreer gratis om te stemmen", registerToValidate: "Registreer gratis om te valideren", confirmed: "Bevestigd", rejected: "Afgewezen", validationError: "Fout bij valideren", noLongerHere: "Niet meer hier", noLongerHereCount: "niet meer hier", alreadyMarkedResolved: "Je hebt dit report al gemarkeerd", proximityRequired: "Je moet binnen {meters} m zijn om te bevestigen, af te wijzen of als niet meer hier te markeren.", locationRequiredForAction: "We hebben je gps nodig voor deze actie. Kom binnen {meters} m en probeer het opnieuw.", tooFarFromReport: "Je bent te ver van het report ({distance} m). Je moet binnen {meters} m zijn.", useValidationToConfirm: "Gebruik Bevestigen of Afwijzen om aan te geven of het report er nog ligt.", voteSuccess: { noLongerHere: "Gemarkeerd als niet meer hier" }, voteError: "Fout bij het markeren van het report", linkCopied: "Link gekopieerd", shareError: "Fout bij delen", pushUnsupported: "Je browser ondersteunt geen pushmeldingen", pushUnavailableOnThisBuild: "Pushmeldingen op iPhone zijn beschikbaar zodra Apple het ontwikkelaarsaccount activeert.", pushDisabled: "Meldingen uitgeschakeld", pushEnabledNearby: "Meldingen voor nabijgelegen reports ingeschakeld", pushEnabled: "Meldingen ingeschakeld", pushPermissionDenied: "Meldingstoestemming geweigerd", pushError: "Fout bij inschakelen van meldingen", anonymous: "Anoniem", registeredUser: "Geregistreerde gebruiker", unranked: "Zonder rang", userFallback: "Gebruiker", feedback: "Feedback geven", myProfile: "Mijn profiel", myImpact: "Mijn impact", pointsShort: "ptn", dayShort: "d", descriptionPlaceholder: "Optionele beschrijving...", photoAlt: "Foto", filters: { all: "Alles", verified: "Geverifieerd", fresh: "Vers", moderate: "Bezig", old: "Fossiel" }, status: { verified: "Geverifieerd", rejected: "Afgewezen", pending: "In afwachting" }, confidence: "Vertrouwen: {value}%", validations: "{count} validaties", helpful: "Nuttig", notHelpful: "Niet nuttig", confirm: "Bevestigen", reject: "Afwijzen", yourValidation: "Jouw validatie: {value}", share: "Delen", recenterMap: "Kaart centreren", notificationTitle: "Meldingen inschakelen", notificationBody: "We waarschuwen je voor reports in de buurt", notificationNo: "Nee" },
    profileUi: { usernameTooShort: "Minimaal 3 tekens", usernameUpdated: "Gebruikersnaam bijgewerkt", shareError: "Fout bij delen", upgradePremium: "Neem Premium", shareProfile: "Profiel delen", communityImpact: "Mijn community-impact", totalPoints: "Totaal punten", reports: "Reports", votes: "Stemmen", streak: "Reeks", accuracy: "Nauwkeurigheid", impact: "Impact", badges: "Badges", trustLevel: "Vertrouwensniveau", status: "Status", trustTiers: { restricted: "Beperkt", low: "Laag", normal: "Normaal", trusted: "Betrouwbaar" }, notifications: "Meldingen", notificationsDesc: "Ontvang waarschuwingen wanneer er poep wordt gemeld bij je opgeslagen locaties.", browserPermissionDenied: "Meldingstoestemming geweigerd in de browser", scoringTitle: "Zo verdien je punten", scoreReport: "Melden", scoreCorrectValidation: "Correcte validatie", scoreVerifiedReport: "Geverifieerd report", scoreUpvoteReceived: "Positieve stem ontvangen", scoreStreak: "Reeks van 7 / 14 / 30 dagen", scorePhotoDescription: "+5 foto, +3 beschrijving", scoreFirstFive: "+5 bonus voor eerste 5", premiumMultiplier: "Premium: 1,5x multiplier op alle punten", appleLinked: "Apple gekoppeld", linkApple: "Apple koppelen" },
    feedbackUi: { bug: "Bug / Fout", suggestion: "Suggestie", other: "Overig", messageRequired: "Schrijf een bericht", thanks: "Bedankt voor je feedback", sendError: "Fout bij verzenden. Probeer opnieuw.", bugPlaceholder: "Beschrijf het probleem...", ideaPlaceholder: "Vertel ons je idee...", send: "Verzenden" },
    authRecovery: { forgotLink: "Wachtwoord vergeten?", checkEmailTitle: "Controleer je e-mail", checkEmailBody: "Als {email} een account heeft, ontvang je een link om je wachtwoord te resetten.", backToLogin: "Terug naar inloggen", forgotTitle: "Wachtwoord vergeten?", forgotDescription: "Voer je e-mail in en we sturen je een resetlink.", sendLink: "Link verzenden", sendError: "Fout bij verzenden. Probeer opnieuw.", resetSuccessTitle: "Wachtwoord bijgewerkt", resetSuccessBody: "Je kunt nu inloggen met je nieuwe wachtwoord.", newPasswordTitle: "Nieuw wachtwoord", newPasswordDescription: "Voer je nieuwe wachtwoord in.", newPasswordLabel: "Nieuw wachtwoord", confirmPasswordLabel: "Wachtwoord bevestigen", repeatPasswordPlaceholder: "Herhaal het wachtwoord", resetPassword: "Wachtwoord resetten", requestNewLink: "Nieuwe link aanvragen", passwordsDoNotMatch: "Wachtwoorden komen niet overeen", invalidLink: "Ongeldige link. Vraag een nieuwe aan.", passwordUpdated: "Wachtwoord bijgewerkt", resetError: "Fout bij resetten. De link is mogelijk verlopen." },
    loginUi: { forgotPassword: "Wachtwoord vergeten?", or: "of", appleComingSoon: "Apple ID (binnenkort)", appleSignIn: "Doorgaan met Apple", appleSuccess: "Ingelogd met Apple", appleError: "Fout bij inloggen met Apple", googleSuccess: "Ingelogd met Google", googleError: "Fout bij inloggen met Google", redirecting: "Doorsturen...", connectingApple: "Verbinden met Apple...", connectingGoogle: "Verbinden met Google..." },
  },
  pl: {
    mapUi: { registerToReport: "Zarejestruj się za darmo, aby zgłaszać", registerToVote: "Zarejestruj się za darmo, aby głosować", registerToValidate: "Zarejestruj się za darmo, aby weryfikować", confirmed: "Potwierdzono", rejected: "Odrzucono", validationError: "Błąd weryfikacji", noLongerHere: "Już tego nie ma", noLongerHereCount: "już tego nie ma", alreadyMarkedResolved: "To zgłoszenie zostało już przez Ciebie oznaczone", proximityRequired: "Musisz być w promieniu {meters} m, aby potwierdzić, odrzucić lub oznaczyć zgłoszenie jako już niewidoczne.", locationRequiredForAction: "Do tej akcji potrzebujemy Twojego GPS. Podejdź na mniej niż {meters} m i spróbuj ponownie.", tooFarFromReport: "Jesteś za daleko od zgłoszenia ({distance} m). Musisz być w promieniu {meters} m.", useValidationToConfirm: "Użyj Potwierdź lub Odrzuć, aby wskazać, czy zgłoszenie nadal tam jest.", voteSuccess: { noLongerHere: "Oznaczono jako już niewidoczne" }, voteError: "Błąd podczas oznaczania zgłoszenia", linkCopied: "Link skopiowany", shareError: "Błąd udostępniania", pushUnsupported: "Twoja przeglądarka nie obsługuje powiadomień push", pushUnavailableOnThisBuild: "Powiadomienia push na iPhonie będą dostępne, gdy Apple aktywuje konto deweloperskie.", pushDisabled: "Powiadomienia wyłączone", pushEnabledNearby: "Powiadomienia o pobliskich zgłoszeniach włączone", pushEnabled: "Powiadomienia włączone", pushPermissionDenied: "Odmówiono zgody na powiadomienia", pushError: "Błąd włączania powiadomień", anonymous: "Anonim", registeredUser: "Zarejestrowany użytkownik", unranked: "Bez rangi", userFallback: "Użytkownik", feedback: "Opinia", myProfile: "Mój profil", myImpact: "Mój wpływ", pointsShort: "pkt", dayShort: "d", descriptionPlaceholder: "Opcjonalny opis...", photoAlt: "Zdjęcie", filters: { all: "Wszystkie", verified: "Zweryfikowane", fresh: "Świeże", moderate: "W toku", old: "Skamielina" }, status: { verified: "Zweryfikowane", rejected: "Odrzucone", pending: "Oczekuje" }, confidence: "Pewność: {value}%", validations: "{count} weryfikacji", helpful: "Pomocne", notHelpful: "Niepomocne", confirm: "Potwierdź", reject: "Odrzuć", yourValidation: "Twoja weryfikacja: {value}", share: "Udostępnij", recenterMap: "Wyśrodkuj mapę", notificationTitle: "Włącz powiadomienia", notificationBody: "Powiadomimy Cię o zgłoszeniach w pobliżu", notificationNo: "Nie" },
    profileUi: { usernameTooShort: "Minimum 3 znaki", usernameUpdated: "Nazwa użytkownika zaktualizowana", shareError: "Błąd udostępniania", upgradePremium: "Przejdź na Premium", shareProfile: "Udostępnij profil", communityImpact: "Mój wpływ społeczny", totalPoints: "Suma punktów", reports: "Zgłoszenia", votes: "Głosy", streak: "Seria", accuracy: "Trafność", impact: "Wpływ", badges: "Odznaki", trustLevel: "Poziom zaufania", status: "Status", trustTiers: { restricted: "Ograniczony", low: "Niski", normal: "Normalny", trusted: "Zaufany" }, notifications: "Powiadomienia", notificationsDesc: "Otrzymuj alerty, gdy w pobliżu zapisanych lokalizacji pojawią się zgłoszenia.", browserPermissionDenied: "Odmówiono powiadomień w przeglądarce", scoringTitle: "Jak zdobywać punkty", scoreReport: "Zgłoszenie", scoreCorrectValidation: "Poprawna weryfikacja", scoreVerifiedReport: "Zweryfikowane zgłoszenie", scoreUpvoteReceived: "Otrzymany głos pozytywny", scoreStreak: "Seria 7 / 14 / 30 dni", scorePhotoDescription: "+5 zdjęcie, +3 opis", scoreFirstFive: "+5 bonus za pierwsze 5", premiumMultiplier: "Premium: mnożnik 1,5x na wszystkie punkty", appleLinked: "Apple połączone", linkApple: "Połącz Apple" },
    feedbackUi: { bug: "Błąd", suggestion: "Sugestia", other: "Inne", messageRequired: "Napisz wiadomość", thanks: "Dziękujemy za feedback", sendError: "Błąd wysyłania. Spróbuj ponownie.", bugPlaceholder: "Opisz znaleziony problem...", ideaPlaceholder: "Opowiedz nam o swoim pomyśle...", send: "Wyślij" },
    authRecovery: { forgotLink: "Nie pamiętasz hasła?", checkEmailTitle: "Sprawdź e-mail", checkEmailBody: "Jeśli {email} ma konto, otrzymasz link do resetu hasła.", backToLogin: "Wróć do logowania", forgotTitle: "Nie pamiętasz hasła?", forgotDescription: "Podaj e-mail, a wyślemy link resetujący.", sendLink: "Wyślij link", sendError: "Błąd wysyłania. Spróbuj ponownie.", resetSuccessTitle: "Hasło zaktualizowane", resetSuccessBody: "Możesz teraz zalogować się nowym hasłem.", newPasswordTitle: "Nowe hasło", newPasswordDescription: "Wpisz nowe hasło.", newPasswordLabel: "Nowe hasło", confirmPasswordLabel: "Potwierdź hasło", repeatPasswordPlaceholder: "Powtórz hasło", resetPassword: "Zresetuj hasło", requestNewLink: "Poproś o nowy link", passwordsDoNotMatch: "Hasła nie są takie same", invalidLink: "Nieprawidłowy link. Poproś o nowy.", passwordUpdated: "Hasło zaktualizowane", resetError: "Błąd resetowania. Link mógł wygasnąć." },
    loginUi: { forgotPassword: "Nie pamiętasz hasła?", or: "lub", appleComingSoon: "Apple ID (wkrótce)", appleSignIn: "Kontynuuj z Apple", appleSuccess: "Zalogowano przez Apple", appleError: "Błąd logowania przez Apple", googleSuccess: "Zalogowano przez Google", googleError: "Błąd logowania przez Google", redirecting: "Przekierowanie...", connectingApple: "Łączenie z Apple...", connectingGoogle: "Łączenie z Google..." },
  },
};

["uk", "ru", "eu", "ca", "val"].forEach((lang) => {
  appUiTranslations[lang] = appUiTranslations.en;
});

localizedUiOverrides.uk = {
  mapUi: {
    registeredUser: "Зареєстрований користувач",
    unranked: "Без рангу",
    noLongerHere: "Більше немає",
    noLongerHereCount: "більше немає",
    alreadyMarkedResolved: "Ви вже позначили цей звіт",
    proximityRequired: "Ви маєте бути в межах {meters} м, щоб підтвердити, відхилити або позначити, що цього вже немає.",
    locationRequiredForAction: "Для цієї дії потрібен GPS. Підійдіть ближче ніж на {meters} м і спробуйте ще раз.",
    tooFarFromReport: "Ви надто далеко від звіту ({distance} м). Потрібно бути в межах {meters} м.",
    useValidationToConfirm: "Скористайтеся Підтвердити або Відхилити, щоб вказати, чи звіт ще актуальний.",
    voteSuccess: { noLongerHere: "Позначено як таке, чого вже немає" },
    voteError: "Помилка позначення звіту",
    feedback: "Зворотний зв’язок",
  },
};

localizedUiOverrides.ru = {
  mapUi: {
    registeredUser: "Зарегистрированный пользователь",
    unranked: "Без ранга",
    noLongerHere: "Уже нет",
    noLongerHereCount: "уже нет",
    alreadyMarkedResolved: "Вы уже отметили этот репорт",
    proximityRequired: "Нужно находиться в пределах {meters} м, чтобы подтвердить, отклонить или отметить, что этого уже нет.",
    locationRequiredForAction: "Для этого действия нужен GPS. Подойдите на расстояние менее {meters} м и попробуйте снова.",
    tooFarFromReport: "Вы слишком далеко от репорта ({distance} м). Нужно быть в пределах {meters} м.",
    useValidationToConfirm: "Используйте Подтвердить или Отклонить, чтобы указать, остался ли репорт на месте.",
    voteSuccess: { noLongerHere: "Отмечено как уже отсутствующее" },
    voteError: "Ошибка при отметке репорта",
    feedback: "Обратная связь",
  },
};

localizedUiOverrides.eu = {
  mapUi: {
    registeredUser: "Erabiltzaile erregistratua",
    unranked: "Rangorik gabe",
    noLongerHere: "Jada ez dago",
    noLongerHereCount: "jada ez dago",
    alreadyMarkedResolved: "Dagoeneko markatu duzu txosten hau",
    proximityRequired: "Baieztatu, baztertu edo jada ez dagoela markatzeko, {meters} m barruan egon behar duzu.",
    locationRequiredForAction: "Ekintza honetarako GPSa behar dugu. Hurbildu {meters} m baino gutxiagora eta saiatu berriro.",
    tooFarFromReport: "Txostenetik urrunegi zaude ({distance} m). {meters} m barruan egon behar duzu.",
    useValidationToConfirm: "Erabili Baieztatu edo Baztertu txostena oraindik hor dagoen adierazteko.",
    voteSuccess: { noLongerHere: "Jada ez dagoela markatu da" },
    voteError: "Errorea txostena markatzean",
  },
};

localizedUiOverrides.ca = {
  mapUi: {
    registeredUser: "Usuari registrat",
    unranked: "Sense rang",
    noLongerHere: "Ja no hi és",
    noLongerHereCount: "ja no hi és",
    alreadyMarkedResolved: "Ja has marcat aquest report",
    proximityRequired: "Has d'estar a menys de {meters} m per confirmar, rebutjar o marcar que ja no hi és.",
    locationRequiredForAction: "Necessitem el teu GPS per a aquesta acció. Acosta't a menys de {meters} m i torna-ho a provar.",
    tooFarFromReport: "Ets massa lluny del report ({distance} m). Has d'estar a menys de {meters} m.",
    useValidationToConfirm: "Fes servir Confirmar o Rebutjar per indicar si el report encara hi és.",
    voteSuccess: { noLongerHere: "Marcat com que ja no hi és" },
    voteError: "Error en marcar el report",
  },
};

localizedUiOverrides.val = {
  mapUi: {
    registeredUser: "Usuari registrat",
    unranked: "Sense rang",
    noLongerHere: "Ja no està ahí",
    noLongerHereCount: "ja no està ahí",
    alreadyMarkedResolved: "Ja has marcat este report",
    proximityRequired: "Has d'estar a menys de {meters} m per confirmar, rebutjar o marcar que ja no està ahí.",
    locationRequiredForAction: "Necessitem el teu GPS per a esta acció. Acosta't a menys de {meters} m i torna-ho a provar.",
    tooFarFromReport: "Estàs massa lluny del report ({distance} m). Has d'estar a menys de {meters} m.",
    useValidationToConfirm: "Fes servir Confirmar o Rebutjar per indicar si el report encara està ahí.",
    voteSuccess: { noLongerHere: "Marcat com que ja no està ahí" },
    voteError: "Error en marcar el report",
  },
};

Object.entries(localizedUiOverrides).forEach(([lang, groups]) => {
  appUiTranslations[lang] = {
    ...appUiTranslations.en,
    ...groups,
  };
});

Object.keys(translations).forEach((lang) => {
  const ui = appUiTranslations[lang] || appUiTranslations.en;
  Object.entries(ui).forEach(([group, values]) => {
    translations[lang][group] = {
      ...(translations[lang][group] || {}),
      ...values,
    };
  });
});

const extraUiTranslations = {
  es: {
    feedbackUi: {
      title: "Feedback",
    },
    pointsUi: {
      pointsLabel: "puntos",
    },
    helpUi: {
      title: "Ayuda",
      intro: "¿Necesitas soporte, información legal o ayuda con tu cuenta? Esta página te lleva al lugar adecuado.",
      contactTitle: "Contacto / soporte",
      contactBody: "Para soporte, dudas de privacidad o contacto general, escribe a",
      privacyTitle: "Privacidad",
      termsTitle: "Términos de uso y aviso legal",
      termsPlaceholder: "Placeholder de Términos de Uso. Añade aquí la ruta o el documento final cuando esté disponible.",
      deletionTitle: "Eliminación de cuenta / datos",
      deletionIntro: "Puedes gestionar la eliminación de tu cuenta desde la ruta dedicada dentro de la app, o contactarnos directamente si prefieres una solicitud manual.",
      deleteAccountLink: "Eliminar cuenta",
      deletionEmailIntro: "También puedes solicitar la eliminación de tu cuenta o datos escribiendo a",
    },
    deleteAccountUi: {
      yourAccount: "tu cuenta",
      title: "Eliminar cuenta",
      subtitle: "Eliminación permanente de tu cuenta de Caca Radar",
      signInFirst: "Primero inicia sesión si quieres eliminar tu cuenta desde dentro de la app.",
      goToLogin: "Ir al login",
      emailDeletionRequest: "Solicitar por email",
      warningLead: "Estás a punto de eliminar permanentemente",
      warningBody1: "Esto elimina tu cuenta, el acceso, las notificaciones, los lugares guardados, votos y otros registros específicos del usuario.",
      warningBody2: "Los reportes que ya publicaste pueden permanecer en el servicio de forma anonimizada para que el mapa público siga intacto.",
      confirmLabel: "Entiendo que esta acción es permanente y quiero eliminar mi cuenta ahora.",
      deleting: "Eliminando...",
      deleteCta: "Eliminar mi cuenta",
      keepAccount: "Conservar mi cuenta",
      success: "Tu cuenta ha sido eliminada.",
      error: "No pudimos eliminar tu cuenta ahora mismo.",
    },
    rankingUi: {
      leaderboardTitle: "Leaderboard",
      loadError: "Error cargando rankings",
      loadBarrioError: "Error cargando datos de barrios",
      copied: "Copiado al portapapeles",
      shareError: "Error al compartir",
      premiumTitle: "Rankings Premium",
      premiumBody: "Accede a los rankings de ciudades y barrios con Caca Radar Premium",
      viewPremiumPlans: "Ver planes Premium",
      pageTitle: "Rankings",
      shareRanking: "Compartir ranking",
      cityLabel: "Ciudad",
      activeReportsInCity: "{count} reportes activos en {city}",
      noNeighborhoodData: "No hay datos de barrios para esta ciudad",
      verifiedReportsShort: "verificados",
      reportsLabel: "reportes",
    },
    impactUi: {
      loadError: "Error cargando datos de impacto",
      copied: "Copiado al portapapeles",
      shareError: "Error al compartir",
      backProfile: "Perfil",
      title: "Tu Impacto Comunitario",
      subtitle: "Cada reporte que haces ayuda a tu vecindario",
      impactPoints: "puntos de impacto",
      reportsLabel: "Reportes",
      cleanedZonesLabel: "Zonas limpiadas",
      cleanedZonesSub: "{percent}% de tus reportes",
      confirmationsLabel: "Confirmaciones",
      municipalitiesLabel: "Municipios",
      mapTitle: "Tu mapa de impacto",
      cleanedLegend: "Limpiado",
      activeLegend: "Activo",
      confirmedLegend: "Confirmado",
      areasTitle: "Zonas donde has contribuido",
      moreAreas: "+{count} más",
      emptyTitle: "Empieza a contribuir",
      emptyBody: "Reporta cacas de perro en tu barrio para ver tu impacto aquí",
      goToMap: "Ir al mapa",
      shareButton: "Compartir mi impacto",
      footer: "Juntos hacemos nuestras calles más limpias. Cada reporte cuenta.",
      shareTitle: "Mi impacto — Caca Radar",
      shareLead: "Mi impacto en Caca Radar:",
      shareStats1: "{reports} reportes | {cleaned} zonas limpiadas",
      shareStats2: "{confirmations} confirmaciones | {municipalities} municipios",
      shareScore: "Puntuación de impacto: {score}",
      shareFooter: "Juntos hacemos nuestras calles más limpias",
      monthlyActivity: "Tu actividad mensual",
    },
  },
  en: {
    feedbackUi: {
      title: "Feedback",
    },
    pointsUi: {
      pointsLabel: "points",
    },
    helpUi: {
      title: "Help",
      intro: "Need support, legal information, or help with your account? This page is the quickest way to the right place.",
      contactTitle: "Contact / support",
      contactBody: "For support, privacy questions, or general contact, email",
      privacyTitle: "Privacy",
      termsTitle: "Terms of Use and Legal Notice",
      termsPlaceholder: "Terms of Use placeholder. Add the final published terms route or document here when available.",
      deletionTitle: "Account deletion / data deletion",
      deletionIntro: "You can manage account deletion from the dedicated in-app route below, or contact us directly if you prefer a manual request.",
      deleteAccountLink: "Delete Account",
      deletionEmailIntro: "You can also request account or data deletion by emailing",
    },
    deleteAccountUi: {
      yourAccount: "your account",
      title: "Delete Account",
      subtitle: "Permanent deletion for your Caca Radar account",
      signInFirst: "Please sign in first if you want to delete your account from inside the app.",
      goToLogin: "Go to login",
      emailDeletionRequest: "Email deletion request",
      warningLead: "You are about to permanently delete",
      warningBody1: "This removes your account, sign-in access, notifications, saved places, votes, and other user-specific records.",
      warningBody2: "Reports you already published may remain in the service in anonymised form so the public map stays intact.",
      confirmLabel: "I understand this action is permanent and I want to delete my account now.",
      deleting: "Deleting...",
      deleteCta: "Delete my account",
      keepAccount: "Keep my account",
      success: "Your account has been deleted.",
      error: "We couldn't delete your account right now.",
    },
    rankingUi: {
      leaderboardTitle: "Leaderboard",
      loadError: "Error loading rankings",
      loadBarrioError: "Error loading neighborhood data",
      copied: "Copied to clipboard",
      shareError: "Error sharing",
      premiumTitle: "Premium Rankings",
      premiumBody: "Access city and neighborhood rankings with Caca Radar Premium",
      viewPremiumPlans: "View Premium plans",
      pageTitle: "Rankings",
      shareRanking: "Share ranking",
      cityLabel: "City",
      activeReportsInCity: "{count} active reports in {city}",
      noNeighborhoodData: "No neighborhood data for this city",
      verifiedReportsShort: "verified",
      reportsLabel: "reports",
    },
    impactUi: {
      loadError: "Error loading impact data",
      copied: "Copied to clipboard",
      shareError: "Error sharing",
      backProfile: "Profile",
      title: "Your Community Impact",
      subtitle: "Every report you make helps your neighborhood",
      impactPoints: "impact points",
      reportsLabel: "Reports",
      cleanedZonesLabel: "Cleaned zones",
      cleanedZonesSub: "{percent}% of your reports",
      confirmationsLabel: "Confirmations",
      municipalitiesLabel: "Municipalities",
      mapTitle: "Your impact map",
      cleanedLegend: "Cleaned",
      activeLegend: "Active",
      confirmedLegend: "Confirmed",
      areasTitle: "Areas where you contributed",
      moreAreas: "+{count} more",
      emptyTitle: "Start contributing",
      emptyBody: "Report dog poop in your neighborhood to see your impact here",
      goToMap: "Go to map",
      shareButton: "Share my impact",
      footer: "Together we make our streets cleaner. Every report counts.",
      shareTitle: "My impact — Caca Radar",
      shareLead: "My impact on Caca Radar:",
      shareStats1: "{reports} reports | {cleaned} cleaned zones",
      shareStats2: "{confirmations} confirmations | {municipalities} municipalities",
      shareScore: "Impact score: {score}",
      shareFooter: "Together we make our streets cleaner",
      monthlyActivity: "Your monthly activity",
    },
  },
  eu: {
    helpUi: {
      title: "Laguntza",
      intro: "Laguntza, informazio juridikoa edo kontuarekin lotutako laguntza behar duzu? Orrialde honek tokirik egokienera eramango zaitu.",
      contactTitle: "Kontaktua / laguntza",
      contactBody: "Laguntza, pribatutasun-galderak edo harreman orokorra lortzeko, idatzi hona",
      privacyTitle: "Pribatutasuna",
      termsTitle: "Erabilera baldintzak eta lege-oharra",
      deletionTitle: "Kontua / datuak ezabatzea",
      deletionIntro: "Kontua ezabatzeko, aplikazioko bide dedikatua erabil dezakezu, edo nahiago baduzu eskuzko eskaera bat bidali.",
      deleteAccountLink: "Ezabatu kontua",
      deletionEmailIntro: "Kontua edo datuak ezabatzeko eska dezakezu hemen idatzita",
    },
    deleteAccountUi: {
      yourAccount: "zure kontua",
      title: "Ezabatu kontua",
      subtitle: "Caca Radar kontuaren ezabaketa iraunkorra",
      signInFirst: "Hasi saioa lehenik aplikaziotik kontua ezabatu nahi baduzu.",
      goToLogin: "Joan saioa hastera",
      emailDeletionRequest: "Eskatu posta bidez",
      warningLead: "Betiko ezabatzera zoaz",
      warningBody1: "Honek zure kontua, saio-hasiera, jakinarazpenak, gordetako lekuak, botoak eta erabiltzaileari lotutako beste erregistro batzuk ezabatuko ditu.",
      warningBody2: "Argitaratutako txostenak zerbitzuan anonimizatuta gera daitezke mapa publikoa osorik mantentzeko.",
      confirmLabel: "Ulertzen dut ekintza hau iraunkorra dela eta nire kontua orain ezabatu nahi dudala.",
      deleting: "Ezabatzen...",
      deleteCta: "Ezabatu nire kontua",
      keepAccount: "Mantendu nire kontua",
      success: "Zure kontua ezabatu da.",
      error: "Ezin izan dugu zure kontua une honetan ezabatu.",
    },
    impactUi: {
      loadError: "Errorea inpaktu datuak kargatzean",
      copied: "Arbelera kopiatuta",
      shareError: "Errorea partekatzean",
      backProfile: "Profila",
      title: "Zure komunitate-inpaktua",
      subtitle: "Egiten duzun txosten bakoitzak zure auzoari laguntzen dio",
      impactPoints: "inpaktu puntu",
      reportsLabel: "Txostenak",
      cleanedZonesLabel: "Garbitutako eremuak",
      cleanedZonesSub: "zure txostenen %{percent}",
      confirmationsLabel: "Baieztapenak",
      municipalitiesLabel: "Udalerriak",
      mapTitle: "Zure inpaktuaren mapa",
      cleanedLegend: "Garbitua",
      activeLegend: "Aktiboa",
      confirmedLegend: "Baieztatua",
      areasTitle: "Lagundu duzun eremuak",
      moreAreas: "+{count} gehiago",
      emptyTitle: "Hasi laguntzen",
      emptyBody: "Jakinarazi txakur-kakak zure auzoan zure inpaktua hemen ikusteko",
      goToMap: "Joan mapara",
      shareButton: "Partekatu nire inpaktua",
      footer: "Elkarrekin gure kaleak garbiago egiten ditugu. Txosten bakoitzak balio du.",
      shareTitle: "Nire inpaktua — Caca Radar",
      shareLead: "Nire inpaktua Caca Radar-en:",
      shareStats1: "{reports} txosten | {cleaned} garbitutako gune",
      shareStats2: "{confirmations} baieztapen | {municipalities} udalerri",
      shareScore: "Inpaktu puntuazioa: {score}",
      shareFooter: "Elkarrekin gure kaleak garbiago egiten ditugu",
      monthlyActivity: "Zure hileko jarduera",
    },
  },
  val: {
    helpUi: {
      title: "Ajuda",
      intro: "Necessites suport, informació legal o ajuda amb el teu compte? Esta pàgina et porta al lloc adequat.",
      contactTitle: "Contacte / suport",
      contactBody: "Per a suport, dubtes de privacitat o contacte general, escriu a",
      privacyTitle: "Privacitat",
      termsTitle: "Termes d'ús i avís legal",
      deletionTitle: "Eliminació de compte / dades",
      deletionIntro: "Pots gestionar l'eliminació del teu compte des de la ruta dedicada dins de l'app, o contactar-nos directament si preferixes una sol·licitud manual.",
      deleteAccountLink: "Eliminar compte",
      deletionEmailIntro: "També pots sol·licitar l'eliminació del teu compte o dades escrivint a",
    },
    deleteAccountUi: {
      yourAccount: "el teu compte",
      title: "Eliminar compte",
      subtitle: "Eliminació permanent del teu compte de Caca Radar",
      signInFirst: "Primer inicia sessió si vols eliminar el teu compte des de dins de l'app.",
      goToLogin: "Anar a l'inici de sessió",
      emailDeletionRequest: "Sol·licitar per correu",
      warningLead: "Estàs a punt d'eliminar permanentment",
      warningBody1: "Això elimina el teu compte, l'accés, les notificacions, els llocs guardats, els vots i altres registres específics de l'usuari.",
      warningBody2: "Els reports que ja has publicat poden romandre en el servei de forma anonimitzada perquè el mapa públic continue intacte.",
      confirmLabel: "Entenc que esta acció és permanent i vull eliminar el meu compte ara.",
      deleting: "Eliminant...",
      deleteCta: "Eliminar el meu compte",
      keepAccount: "Conservar el meu compte",
      success: "El teu compte ha sigut eliminat.",
      error: "No hem pogut eliminar el teu compte ara mateix.",
    },
    impactUi: {
      loadError: "Error carregant dades d'impacte",
      copied: "Copiat al porta-retalls",
      shareError: "Error en compartir",
      backProfile: "Perfil",
      title: "El teu impacte comunitari",
      subtitle: "Cada report que fas ajuda el teu barri",
      impactPoints: "punts d'impacte",
      reportsLabel: "Reports",
      cleanedZonesLabel: "Zones netejades",
      cleanedZonesSub: "{percent}% dels teus reports",
      confirmationsLabel: "Confirmacions",
      municipalitiesLabel: "Municipis",
      mapTitle: "El teu mapa d'impacte",
      cleanedLegend: "Netejat",
      activeLegend: "Actiu",
      confirmedLegend: "Confirmat",
      areasTitle: "Zones on has contribuït",
      moreAreas: "+{count} més",
      emptyTitle: "Comença a contribuir",
      emptyBody: "Reporta caques de gos al teu barri per a vore el teu impacte ací",
      goToMap: "Anar al mapa",
      shareButton: "Compartir el meu impacte",
      footer: "Junts fem els nostres carrers més nets. Cada report compta.",
      shareTitle: "El meu impacte — Caca Radar",
      shareLead: "El meu impacte en Caca Radar:",
      shareStats1: "{reports} reports | {cleaned} zones netejades",
      shareStats2: "{confirmations} confirmacions | {municipalities} municipis",
      shareScore: "Puntuació d'impacte: {score}",
      shareFooter: "Junts fem els nostres carrers més nets",
      monthlyActivity: "La teua activitat mensual",
    },
  },
  ca: {
    helpUi: {
      title: "Ajuda",
      intro: "Necessites suport, informació legal o ajuda amb el teu compte? Aquesta pàgina et porta al lloc adequat.",
      contactTitle: "Contacte / suport",
      contactBody: "Per a suport, dubtes de privacitat o contacte general, escriu a",
      privacyTitle: "Privacitat",
      termsTitle: "Termes d'ús i avís legal",
      deletionTitle: "Eliminació del compte / dades",
      deletionIntro: "Pots gestionar l'eliminació del teu compte des de la ruta dedicada dins de l'app, o contactar-nos directament si prefereixes una sol·licitud manual.",
      deleteAccountLink: "Eliminar compte",
      deletionEmailIntro: "També pots sol·licitar l'eliminació del teu compte o dades escrivint a",
    },
    deleteAccountUi: {
      yourAccount: "el teu compte",
      title: "Eliminar compte",
      subtitle: "Eliminació permanent del teu compte de Caca Radar",
      signInFirst: "Primer inicia sessió si vols eliminar el teu compte des de dins de l'app.",
      goToLogin: "Vés a l'inici de sessió",
      emailDeletionRequest: "Sol·licitar per correu",
      warningLead: "Estàs a punt d'eliminar permanentment",
      warningBody1: "Això elimina el teu compte, l'accés, les notificacions, els llocs desats, els vots i altres registres específics de l'usuari.",
      warningBody2: "Els reports que ja has publicat poden romandre al servei de forma anonimitzada perquè el mapa públic continuï intacte.",
      confirmLabel: "Entenc que aquesta acció és permanent i vull eliminar el meu compte ara.",
      deleting: "Eliminant...",
      deleteCta: "Eliminar el meu compte",
      keepAccount: "Conservar el meu compte",
      success: "El teu compte ha estat eliminat.",
      error: "No hem pogut eliminar el teu compte ara mateix.",
    },
    impactUi: {
      loadError: "Error en carregar les dades d'impacte",
      copied: "Copiat al porta-retalls",
      shareError: "Error en compartir",
      backProfile: "Perfil",
      title: "El teu impacte comunitari",
      subtitle: "Cada report que fas ajuda el teu barri",
      impactPoints: "punts d'impacte",
      reportsLabel: "Reports",
      cleanedZonesLabel: "Zones netejades",
      cleanedZonesSub: "{percent}% dels teus reports",
      confirmationsLabel: "Confirmacions",
      municipalitiesLabel: "Municipis",
      mapTitle: "El teu mapa d'impacte",
      cleanedLegend: "Netejat",
      activeLegend: "Actiu",
      confirmedLegend: "Confirmat",
      areasTitle: "Zones on has contribuït",
      moreAreas: "+{count} més",
      emptyTitle: "Comença a contribuir",
      emptyBody: "Reporta caques de gos al teu barri per veure el teu impacte aquí",
      goToMap: "Vés al mapa",
      shareButton: "Comparteix el meu impacte",
      footer: "Junts fem els nostres carrers més nets. Cada report compta.",
      shareTitle: "El meu impacte — Caca Radar",
      shareLead: "El meu impacte a Caca Radar:",
      shareStats1: "{reports} reports | {cleaned} zones netejades",
      shareStats2: "{confirmations} confirmacions | {municipalities} municipis",
      shareScore: "Puntuació d'impacte: {score}",
      shareFooter: "Junts fem els nostres carrers més nets",
      monthlyActivity: "La teva activitat mensual",
    },
  },
  de: {
    helpUi: {
      title: "Hilfe",
      intro: "Brauchst du Support, rechtliche Informationen oder Hilfe mit deinem Konto? Diese Seite bringt dich schnell an die richtige Stelle.",
      contactTitle: "Kontakt / Support",
      contactBody: "Für Support, Datenschutzfragen oder allgemeinen Kontakt schreibe an",
      privacyTitle: "Datenschutz",
      termsTitle: "Nutzungsbedingungen und Rechtshinweis",
      deletionTitle: "Konto- / Datenlöschung",
      deletionIntro: "Du kannst die Löschung deines Kontos über den dafür vorgesehenen Bereich in der App verwalten oder uns direkt kontaktieren, wenn du lieber eine manuelle Anfrage stellen möchtest.",
      deleteAccountLink: "Konto löschen",
      deletionEmailIntro: "Du kannst auch die Löschung deines Kontos oder deiner Daten per E-Mail anfordern unter",
    },
    deleteAccountUi: {
      yourAccount: "dein Konto",
      title: "Konto löschen",
      subtitle: "Dauerhafte Löschung deines Caca-Radar-Kontos",
      signInFirst: "Bitte melde dich zuerst an, wenn du dein Konto innerhalb der App löschen möchtest.",
      goToLogin: "Zum Login",
      emailDeletionRequest: "Per E-Mail anfordern",
      warningLead: "Du bist dabei, dauerhaft zu löschen",
      warningBody1: "Dadurch werden dein Konto, dein Zugriff, Benachrichtigungen, gespeicherte Orte, Abstimmungen und andere nutzerspezifische Daten entfernt.",
      warningBody2: "Bereits veröffentlichte Meldungen können in anonymisierter Form im Dienst verbleiben, damit die öffentliche Karte intakt bleibt.",
      confirmLabel: "Ich verstehe, dass diese Aktion dauerhaft ist, und möchte mein Konto jetzt löschen.",
      deleting: "Wird gelöscht...",
      deleteCta: "Mein Konto löschen",
      keepAccount: "Mein Konto behalten",
      success: "Dein Konto wurde gelöscht.",
      error: "Wir konnten dein Konto gerade nicht löschen.",
    },
    impactUi: {
      loadError: "Fehler beim Laden der Wirkungsdaten",
      copied: "In die Zwischenablage kopiert",
      shareError: "Fehler beim Teilen",
      backProfile: "Profil",
      title: "Dein Community-Einfluss",
      subtitle: "Jede Meldung hilft deiner Nachbarschaft",
      impactPoints: "Wirkungspunkte",
      reportsLabel: "Meldungen",
      cleanedZonesLabel: "Bereinigte Zonen",
      cleanedZonesSub: "{percent}% deiner Meldungen",
      confirmationsLabel: "Bestätigungen",
      municipalitiesLabel: "Gemeinden",
      mapTitle: "Deine Wirkungskarte",
      cleanedLegend: "Bereinigt",
      activeLegend: "Aktiv",
      confirmedLegend: "Bestätigt",
      areasTitle: "Gebiete, in denen du geholfen hast",
      moreAreas: "+{count} weitere",
      emptyTitle: "Fang an mitzuhelfen",
      emptyBody: "Melde Hundekot in deiner Nachbarschaft, um deine Wirkung hier zu sehen",
      goToMap: "Zur Karte",
      shareButton: "Meine Wirkung teilen",
      footer: "Gemeinsam machen wir unsere Straßen sauberer. Jede Meldung zählt.",
      shareTitle: "Meine Wirkung — Caca Radar",
      shareLead: "Meine Wirkung in Caca Radar:",
      shareStats1: "{reports} Meldungen | {cleaned} bereinigte Zonen",
      shareStats2: "{confirmations} Bestätigungen | {municipalities} Gemeinden",
      shareScore: "Wirkungspunktzahl: {score}",
      shareFooter: "Gemeinsam machen wir unsere Straßen sauberer",
      monthlyActivity: "Deine monatliche Aktivität",
    },
  },
  nl: {
    helpUi: {
      title: "Help",
      intro: "Hulp nodig, juridische informatie of ondersteuning met je account? Deze pagina brengt je snel naar de juiste plek.",
      contactTitle: "Contact / ondersteuning",
      contactBody: "Voor ondersteuning, privacyvragen of algemeen contact mail je naar",
      privacyTitle: "Privacy",
      termsTitle: "Gebruiksvoorwaarden en juridische kennisgeving",
      deletionTitle: "Account- / gegevensverwijdering",
      deletionIntro: "Je kunt het verwijderen van je account beheren via de speciale route in de app, of direct contact met ons opnemen als je liever een handmatig verzoek doet.",
      deleteAccountLink: "Account verwijderen",
      deletionEmailIntro: "Je kunt ook verwijdering van je account of gegevens aanvragen door te mailen naar",
    },
    deleteAccountUi: {
      yourAccount: "je account",
      title: "Account verwijderen",
      subtitle: "Permanente verwijdering van je Caca Radar-account",
      signInFirst: "Log eerst in als je je account vanuit de app wilt verwijderen.",
      goToLogin: "Ga naar inloggen",
      emailDeletionRequest: "Verzoek per e-mail",
      warningLead: "Je staat op het punt permanent te verwijderen",
      warningBody1: "Dit verwijdert je account, toegang, meldingen, opgeslagen plaatsen, stemmen en andere gebruikersspecifieke gegevens.",
      warningBody2: "Rapporten die je al hebt gepubliceerd kunnen in geanonimiseerde vorm in de dienst blijven zodat de publieke kaart intact blijft.",
      confirmLabel: "Ik begrijp dat deze actie permanent is en ik wil mijn account nu verwijderen.",
      deleting: "Bezig met verwijderen...",
      deleteCta: "Mijn account verwijderen",
      keepAccount: "Mijn account behouden",
      success: "Je account is verwijderd.",
      error: "We konden je account nu niet verwijderen.",
    },
    impactUi: {
      loadError: "Fout bij laden van impactgegevens",
      copied: "Gekopieerd naar klembord",
      shareError: "Fout bij delen",
      backProfile: "Profiel",
      title: "Jouw impact op de gemeenschap",
      subtitle: "Elk rapport dat je maakt helpt je buurt",
      impactPoints: "impactpunten",
      reportsLabel: "Rapporten",
      cleanedZonesLabel: "Opgeruimde zones",
      cleanedZonesSub: "{percent}% van je rapporten",
      confirmationsLabel: "Bevestigingen",
      municipalitiesLabel: "Gemeenten",
      mapTitle: "Jouw impactkaart",
      cleanedLegend: "Opgeruimd",
      activeLegend: "Actief",
      confirmedLegend: "Bevestigd",
      areasTitle: "Gebieden waar je hebt bijgedragen",
      moreAreas: "+{count} meer",
      emptyTitle: "Begin met bijdragen",
      emptyBody: "Meld hondenpoep in je buurt om hier je impact te zien",
      goToMap: "Ga naar de kaart",
      shareButton: "Deel mijn impact",
      footer: "Samen maken we onze straten schoner. Elk rapport telt.",
      shareTitle: "Mijn impact — Caca Radar",
      shareLead: "Mijn impact in Caca Radar:",
      shareStats1: "{reports} rapporten | {cleaned} opgeruimde zones",
      shareStats2: "{confirmations} bevestigingen | {municipalities} gemeenten",
      shareScore: "Impactscore: {score}",
      shareFooter: "Samen maken we onze straten schoner",
      monthlyActivity: "Je maandelijkse activiteit",
    },
  },
  pl: {
    helpUi: {
      title: "Pomoc",
      intro: "Potrzebujesz wsparcia, informacji prawnych lub pomocy z kontem? Ta strona prowadzi we właściwe miejsce.",
      contactTitle: "Kontakt / wsparcie",
      contactBody: "W sprawie wsparcia, prywatności lub kontaktu ogólnego napisz na",
      privacyTitle: "Prywatność",
      termsTitle: "Warunki korzystania i nota prawna",
      deletionTitle: "Usunięcie konta / danych",
      deletionIntro: "Możesz zarządzać usunięciem konta z poziomu odpowiedniej ścieżki w aplikacji albo skontaktować się z nami bezpośrednio, jeśli wolisz ręczny wniosek.",
      deleteAccountLink: "Usuń konto",
      deletionEmailIntro: "Możesz też poprosić o usunięcie konta lub danych, pisząc na",
    },
    deleteAccountUi: {
      yourAccount: "Twoje konto",
      title: "Usuń konto",
      subtitle: "Trwałe usunięcie konta Caca Radar",
      signInFirst: "Najpierw zaloguj się, jeśli chcesz usunąć konto z poziomu aplikacji.",
      goToLogin: "Przejdź do logowania",
      emailDeletionRequest: "Poproś e-mailem",
      warningLead: "Zaraz trwale usuniesz",
      warningBody1: "To usunie Twoje konto, dostęp, powiadomienia, zapisane miejsca, głosy i inne dane użytkownika.",
      warningBody2: "Opublikowane wcześniej zgłoszenia mogą pozostać w usłudze w formie zanonimizowanej, aby publiczna mapa pozostała kompletna.",
      confirmLabel: "Rozumiem, że to działanie jest trwałe i chcę teraz usunąć swoje konto.",
      deleting: "Usuwanie...",
      deleteCta: "Usuń moje konto",
      keepAccount: "Zachowaj moje konto",
      success: "Twoje konto zostało usunięte.",
      error: "Nie mogliśmy teraz usunąć Twojego konta.",
    },
    impactUi: {
      loadError: "Błąd ładowania danych wpływu",
      copied: "Skopiowano do schowka",
      shareError: "Błąd podczas udostępniania",
      backProfile: "Profil",
      title: "Twój wpływ na społeczność",
      subtitle: "Każde zgłoszenie pomaga Twojej okolicy",
      impactPoints: "punkty wpływu",
      reportsLabel: "Zgłoszenia",
      cleanedZonesLabel: "Oczyszczone strefy",
      cleanedZonesSub: "{percent}% Twoich zgłoszeń",
      confirmationsLabel: "Potwierdzenia",
      municipalitiesLabel: "Gminy",
      mapTitle: "Twoja mapa wpływu",
      cleanedLegend: "Oczyszczone",
      activeLegend: "Aktywne",
      confirmedLegend: "Potwierdzone",
      areasTitle: "Obszary, w których pomogłeś",
      moreAreas: "+{count} więcej",
      emptyTitle: "Zacznij pomagać",
      emptyBody: "Zgłaszaj psie odchody w swojej okolicy, aby zobaczyć swój wpływ tutaj",
      goToMap: "Przejdź do mapy",
      shareButton: "Udostępnij mój wpływ",
      footer: "Razem sprawiamy, że nasze ulice są czystsze. Każde zgłoszenie się liczy.",
      shareTitle: "Mój wpływ — Caca Radar",
      shareLead: "Mój wpływ w Caca Radar:",
      shareStats1: "{reports} zgłoszeń | {cleaned} oczyszczonych stref",
      shareStats2: "{confirmations} potwierdzeń | {municipalities} gmin",
      shareScore: "Wynik wpływu: {score}",
      shareFooter: "Razem sprawiamy, że nasze ulice są czystsze",
      monthlyActivity: "Twoja miesięczna aktywność",
    },
  },
  uk: {
    helpUi: {
      title: "Допомога",
      intro: "Потрібна підтримка, юридична інформація або допомога з обліковим записом? Ця сторінка швидко приведе вас у потрібне місце.",
      contactTitle: "Контакт / підтримка",
      contactBody: "Для підтримки, питань щодо приватності або загального зв’язку напишіть на",
      privacyTitle: "Конфіденційність",
      termsTitle: "Умови користування та правове повідомлення",
      deletionTitle: "Видалення акаунта / даних",
      deletionIntro: "Ви можете керувати видаленням акаунта через окремий маршрут у застосунку або звернутися до нас безпосередньо, якщо віддаєте перевагу ручному запиту.",
      deleteAccountLink: "Видалити акаунт",
      deletionEmailIntro: "Ви також можете подати запит на видалення акаунта або даних, написавши на",
    },
    deleteAccountUi: {
      yourAccount: "ваш акаунт",
      title: "Видалити акаунт",
      subtitle: "Повне видалення вашого акаунта Caca Radar",
      signInFirst: "Спочатку увійдіть, якщо хочете видалити акаунт із застосунку.",
      goToLogin: "Перейти до входу",
      emailDeletionRequest: "Запит електронною поштою",
      warningLead: "Ви збираєтеся назавжди видалити",
      warningBody1: "Це видалить ваш акаунт, доступ, сповіщення, збережені місця, голоси та інші дані, пов’язані з користувачем.",
      warningBody2: "Опубліковані вами повідомлення можуть залишитися в сервісі в анонімізованому вигляді, щоб публічна мапа залишалася цілісною.",
      confirmLabel: "Я розумію, що ця дія є незворотною, і хочу видалити свій акаунт зараз.",
      deleting: "Видалення...",
      deleteCta: "Видалити мій акаунт",
      keepAccount: "Залишити мій акаунт",
      success: "Ваш акаунт видалено.",
      error: "Нам не вдалося видалити ваш акаунт просто зараз.",
    },
    impactUi: {
      loadError: "Помилка завантаження даних впливу",
      copied: "Скопійовано в буфер обміну",
      shareError: "Помилка під час поширення",
      backProfile: "Профіль",
      title: "Ваш вплив на спільноту",
      subtitle: "Кожен ваш звіт допомагає вашому району",
      impactPoints: "балів впливу",
      reportsLabel: "Звіти",
      cleanedZonesLabel: "Очищені зони",
      cleanedZonesSub: "{percent}% ваших звітів",
      confirmationsLabel: "Підтвердження",
      municipalitiesLabel: "Муніципалітети",
      mapTitle: "Ваша карта впливу",
      cleanedLegend: "Очищено",
      activeLegend: "Активне",
      confirmedLegend: "Підтверджено",
      areasTitle: "Зони, де ви допомогли",
      moreAreas: "+{count} ще",
      emptyTitle: "Почніть допомагати",
      emptyBody: "Повідомляйте про собачі екскременти у своєму районі, щоб побачити свій вплив тут",
      goToMap: "Перейти до мапи",
      shareButton: "Поширити мій вплив",
      footer: "Разом ми робимо наші вулиці чистішими. Кожне повідомлення має значення.",
      shareTitle: "Мій вплив — Caca Radar",
      shareLead: "Мій вплив у Caca Radar:",
      shareStats1: "{reports} звітів | {cleaned} очищених зон",
      shareStats2: "{confirmations} підтверджень | {municipalities} муніципалітетів",
      shareScore: "Рейтинг впливу: {score}",
      shareFooter: "Разом ми робимо наші вулиці чистішими",
      monthlyActivity: "Ваша активність за місяць",
    },
  },
  ru: {
    helpUi: {
      title: "Помощь",
      intro: "Нужна поддержка, юридическая информация или помощь с аккаунтом? Эта страница быстро приведет вас в нужное место.",
      contactTitle: "Контакт / поддержка",
      contactBody: "По вопросам поддержки, конфиденциальности или общего контакта пишите на",
      privacyTitle: "Конфиденциальность",
      termsTitle: "Условия использования и правовое уведомление",
      deletionTitle: "Удаление аккаунта / данных",
      deletionIntro: "Вы можете управлять удалением аккаунта через специальный раздел в приложении или связаться с нами напрямую, если предпочитаете ручной запрос.",
      deleteAccountLink: "Удалить аккаунт",
      deletionEmailIntro: "Вы также можете запросить удаление аккаунта или данных, написав на",
    },
    deleteAccountUi: {
      yourAccount: "ваш аккаунт",
      title: "Удалить аккаунт",
      subtitle: "Полное удаление вашего аккаунта Caca Radar",
      signInFirst: "Сначала войдите, если хотите удалить аккаунт из приложения.",
      goToLogin: "Перейти ко входу",
      emailDeletionRequest: "Запрос по электронной почте",
      warningLead: "Вы собираетесь навсегда удалить",
      warningBody1: "Это удалит ваш аккаунт, доступ, уведомления, сохраненные места, голоса и другие данные, относящиеся к пользователю.",
      warningBody2: "Уже опубликованные вами сообщения могут остаться в сервисе в анонимизированном виде, чтобы публичная карта оставалась целой.",
      confirmLabel: "Я понимаю, что это действие необратимо, и хочу удалить свой аккаунт сейчас.",
      deleting: "Удаление...",
      deleteCta: "Удалить мой аккаунт",
      keepAccount: "Оставить мой аккаунт",
      success: "Ваш аккаунт удален.",
      error: "Мы не смогли удалить ваш аккаунт прямо сейчас.",
    },
    impactUi: {
      loadError: "Ошибка загрузки данных об эффекте",
      copied: "Скопировано в буфер обмена",
      shareError: "Ошибка при отправке",
      backProfile: "Профиль",
      title: "Ваш вклад в сообщество",
      subtitle: "Каждое ваше сообщение помогает вашему району",
      impactPoints: "баллов влияния",
      reportsLabel: "Сообщения",
      cleanedZonesLabel: "Убранные зоны",
      cleanedZonesSub: "{percent}% ваших сообщений",
      confirmationsLabel: "Подтверждения",
      municipalitiesLabel: "Муниципалитеты",
      mapTitle: "Ваша карта влияния",
      cleanedLegend: "Убрано",
      activeLegend: "Активно",
      confirmedLegend: "Подтверждено",
      areasTitle: "Зоны, где вы помогли",
      moreAreas: "+{count} ещё",
      emptyTitle: "Начните помогать",
      emptyBody: "Сообщайте о собачьих отходах в вашем районе, чтобы увидеть свой вклад здесь",
      goToMap: "Перейти к карте",
      shareButton: "Поделиться моим вкладом",
      footer: "Вместе мы делаем наши улицы чище. Каждое сообщение важно.",
      shareTitle: "Мой вклад — Caca Radar",
      shareLead: "Мой вклад в Caca Radar:",
      shareStats1: "{reports} сообщений | {cleaned} убранных зон",
      shareStats2: "{confirmations} подтверждений | {municipalities} муниципалитетов",
      shareScore: "Рейтинг влияния: {score}",
      shareFooter: "Вместе мы делаем наши улицы чище",
      monthlyActivity: "Ваша активность за месяц",
    },
  },
};

Object.keys(translations).forEach((lang) => {
  const extra = extraUiTranslations[lang] || extraUiTranslations.en;
  Object.entries(extra).forEach(([group, values]) => {
    translations[lang][group] = {
      ...(translations[lang][group] || {}),
      ...values,
    };
  });
});

const cityReportUiTranslations = {
  es: {
    cityReportUi: {
      menuLabel: "Reporte de ciudad",
      pageTitle: "Reporte de ciudad",
      pageIntro: "Busca una ciudad con reportes activos y comparte una vista rápida de su situación actual.",
      premiumTitle: "Reporte de ciudad Premium",
      premiumBody: "Busca ciudades con reportes activos, revisa su estado actual y comparte un resumen privado.",
      privateTitle: "Los informes no son públicos",
      privateBody: "Inicia sesión para consultar resúmenes de reportes. Las cuentas municipales autorizadas también pueden acceder a estos datos.",
      viewPremiumPlans: "Ver planes Premium",
      cityListError: "No pudimos cargar las ciudades activas",
      barrioListError: "No pudimos cargar los barrios activos",
      loadError: "No pudimos cargar el reporte de la ciudad",
      searchPlaceholder: "Escribe una ciudad con reportes activos",
      searchAction: "Buscar",
      searchHint: "Solo se muestran ciudades que tienen reportes activos ahora mismo.",
      barrioSearchPlaceholder: "Escribe un barrio con reportes activos",
      barrioSearchAction: "Elegir barrio",
      barrioSearchHint: "Puedes acotar el reporte a un barrio con avisos activos en esta ciudad.",
      loadingCities: "Cargando ciudades...",
      loadingBarrios: "Cargando barrios...",
      activeCountShort: "{count} activos",
      noMatches: "No hay coincidencias para esa ciudad",
      noBarrioMatches: "No hay coincidencias para ese barrio",
      chooseCity: "Selecciona una ciudad para ver su reporte actual.",
      emptyState: "No hay un reporte disponible para esta ciudad ahora mismo.",
      shareButton: "Compartir",
      shareTitle: "{location} — reporte de ciudad",
      shareText: "{location}: {fresh} frescos, {older} antiguos y {fossils} fósiles. Mira el reporte de ciudad en Caca Radar.",
      copied: "Enlace copiado al portapapeles",
      shareError: "Error al compartir",
      summaryLine: "{location} — {fresh} frescos, {older} antiguos, {fossils} fósiles.",
      locationWithBarrio: "{city} — {barrio}",
      totalActiveLabel: "Reportes activos",
      freshLabel: "Frescos",
      olderLabel: "Antiguos",
      fossilLabel: "Fósiles",
      mapTitle: "Mapa actual de la ciudad",
      barrioMapTitle: "Mapa actual del barrio",
      publicViewNote: "Estás viendo una versión autenticada y compartible de este reporte de ciudad.",
    },
  },
  en: {
    cityReportUi: {
      menuLabel: "City report",
      pageTitle: "City report",
      pageIntro: "Search for a city with active reports and share a quick snapshot of its current situation.",
      premiumTitle: "Premium city report",
      premiumBody: "Search cities with active reports, review their current state, and share a private snapshot.",
      privateTitle: "City reports are not public",
      privateBody: "Sign in to review report summaries. Authorized municipal accounts can also access this data.",
      viewPremiumPlans: "View Premium plans",
      cityListError: "We couldn't load the active cities",
      barrioListError: "We couldn't load the active neighborhoods",
      loadError: "We couldn't load this city report",
      searchPlaceholder: "Type a city with active reports",
      searchAction: "Search",
      searchHint: "Only cities with active reports right now are shown here.",
      barrioSearchPlaceholder: "Type a neighborhood with active reports",
      barrioSearchAction: "Pick neighborhood",
      barrioSearchHint: "You can narrow this report down to a neighborhood with active reports in this city.",
      loadingCities: "Loading cities...",
      loadingBarrios: "Loading neighborhoods...",
      activeCountShort: "{count} active",
      noMatches: "No matches for that city",
      noBarrioMatches: "No matches for that neighborhood",
      chooseCity: "Pick a city to see its current report.",
      emptyState: "There is no report available for this city right now.",
      shareButton: "Share",
      shareTitle: "{location} — city report",
      shareText: "{location}: {fresh} fresh, {older} older, {fossils} fossils. Check the city report on Caca Radar.",
      copied: "Link copied to clipboard",
      shareError: "Error sharing",
      summaryLine: "{location} — {fresh} fresh, {older} older, {fossils} fossils.",
      locationWithBarrio: "{city} — {barrio}",
      totalActiveLabel: "Active reports",
      freshLabel: "Fresh",
      olderLabel: "Older",
      fossilLabel: "Fossils",
      mapTitle: "Current city map",
      barrioMapTitle: "Current neighborhood map",
      publicViewNote: "You're viewing an authenticated, shareable version of this city report.",
    },
  },
  de: {
    cityReportUi: {
      menuLabel: "Stadtbericht",
      pageTitle: "Stadtbericht",
      pageIntro: "Suche eine Stadt mit aktiven Meldungen und teile eine schnelle Übersicht der aktuellen Lage.",
      premiumTitle: "Premium-Stadtbericht",
      premiumBody: "Suche Städte mit aktiven Meldungen, prüfe ihren aktuellen Stand und teile eine öffentliche Übersicht.",
      viewPremiumPlans: "Premium-Pläne ansehen",
      cityListError: "Die aktiven Städte konnten nicht geladen werden",
      barrioListError: "Die aktiven Stadtteile konnten nicht geladen werden",
      loadError: "Dieser Stadtbericht konnte nicht geladen werden",
      searchPlaceholder: "Stadt mit aktiven Meldungen eingeben",
      searchAction: "Suchen",
      searchHint: "Hier werden nur Städte angezeigt, die aktuell aktive Meldungen haben.",
      barrioSearchPlaceholder: "Stadtteil mit aktiven Meldungen eingeben",
      barrioSearchAction: "Stadtteil wählen",
      barrioSearchHint: "Du kannst diesen Bericht auf einen Stadtteil mit aktiven Meldungen in dieser Stadt eingrenzen.",
      loadingCities: "Städte werden geladen...",
      loadingBarrios: "Stadtteile werden geladen...",
      activeCountShort: "{count} aktiv",
      noMatches: "Keine Treffer für diese Stadt",
      noBarrioMatches: "Keine Treffer für diesen Stadtteil",
      chooseCity: "Wähle eine Stadt, um ihren aktuellen Bericht zu sehen.",
      emptyState: "Für diese Stadt ist gerade kein Bericht verfügbar.",
      shareButton: "Teilen",
      shareTitle: "{location} — Stadtbericht",
      shareText: "{location}: {fresh} frisch, {older} älter, {fossils} fossil. Sieh dir den Stadtbericht in Caca Radar an.",
      copied: "Link in die Zwischenablage kopiert",
      shareError: "Fehler beim Teilen",
      summaryLine: "{location} — {fresh} frisch, {older} älter, {fossils} fossil.",
      locationWithBarrio: "{city} — {barrio}",
      totalActiveLabel: "Aktive Meldungen",
      freshLabel: "Frisch",
      olderLabel: "Älter",
      fossilLabel: "Fossil",
      mapTitle: "Aktuelle Stadtkarte",
      barrioMapTitle: "Aktuelle Stadtteilkarte",
      publicViewNote: "Du siehst eine öffentliche und teilbare Version dieses Stadtberichts.",
    },
  },
  nl: {
    cityReportUi: {
      menuLabel: "Stadsrapport",
      pageTitle: "Stadsrapport",
      pageIntro: "Zoek een stad met actieve meldingen en deel een snelle momentopname van de huidige situatie.",
      premiumTitle: "Premium-stadsrapport",
      premiumBody: "Zoek steden met actieve meldingen, bekijk hun huidige status en deel een publieke momentopname.",
      viewPremiumPlans: "Bekijk Premium-abonnementen",
      cityListError: "We konden de actieve steden niet laden",
      barrioListError: "We konden de actieve wijken niet laden",
      loadError: "We konden dit stadsrapport niet laden",
      searchPlaceholder: "Typ een stad met actieve meldingen",
      searchAction: "Zoeken",
      searchHint: "Alleen steden met nu actieve meldingen worden hier getoond.",
      barrioSearchPlaceholder: "Typ een wijk met actieve meldingen",
      barrioSearchAction: "Wijk kiezen",
      barrioSearchHint: "Je kunt dit rapport verfijnen naar een wijk met actieve meldingen in deze stad.",
      loadingCities: "Steden laden...",
      loadingBarrios: "Wijken laden...",
      activeCountShort: "{count} actief",
      noMatches: "Geen overeenkomsten voor die stad",
      noBarrioMatches: "Geen overeenkomsten voor die wijk",
      chooseCity: "Kies een stad om het actuele rapport te bekijken.",
      emptyState: "Er is nu geen rapport beschikbaar voor deze stad.",
      shareButton: "Delen",
      shareTitle: "{location} — stadsrapport",
      shareText: "{location}: {fresh} vers, {older} ouder, {fossils} fossielen. Bekijk het stadsrapport op Caca Radar.",
      copied: "Link gekopieerd",
      shareError: "Fout bij delen",
      summaryLine: "{location} — {fresh} vers, {older} ouder, {fossils} fossielen.",
      locationWithBarrio: "{city} — {barrio}",
      totalActiveLabel: "Actieve meldingen",
      freshLabel: "Vers",
      olderLabel: "Ouder",
      fossilLabel: "Fossielen",
      mapTitle: "Huidige stadskaart",
      barrioMapTitle: "Huidige wijkkaart",
      publicViewNote: "Je bekijkt een openbare, deelbare versie van dit stadsrapport.",
    },
  },
  pl: {
    cityReportUi: {
      menuLabel: "Raport miasta",
      pageTitle: "Raport miasta",
      pageIntro: "Wyszukaj miasto z aktywnymi zgłoszeniami i udostępnij szybki podgląd jego obecnej sytuacji.",
      premiumTitle: "Raport miasta Premium",
      premiumBody: "Wyszukuj miasta z aktywnymi zgłoszeniami, sprawdzaj ich bieżący stan i udostępniaj publiczny podgląd.",
      viewPremiumPlans: "Zobacz plany Premium",
      cityListError: "Nie udało się wczytać aktywnych miast",
      barrioListError: "Nie udało się wczytać aktywnych dzielnic",
      loadError: "Nie udało się wczytać raportu miasta",
      searchPlaceholder: "Wpisz miasto z aktywnymi zgłoszeniami",
      searchAction: "Szukaj",
      searchHint: "Tutaj wyświetlane są tylko miasta, które mają teraz aktywne zgłoszenia.",
      barrioSearchPlaceholder: "Wpisz dzielnicę z aktywnymi zgłoszeniami",
      barrioSearchAction: "Wybierz dzielnicę",
      barrioSearchHint: "Możesz zawęzić ten raport do dzielnicy z aktywnymi zgłoszeniami w tym mieście.",
      loadingCities: "Ładowanie miast...",
      loadingBarrios: "Ładowanie dzielnic...",
      activeCountShort: "{count} aktywnych",
      noMatches: "Brak wyników dla tego miasta",
      noBarrioMatches: "Brak wyników dla tej dzielnicy",
      chooseCity: "Wybierz miasto, aby zobaczyć jego bieżący raport.",
      emptyState: "Dla tego miasta nie ma teraz dostępnego raportu.",
      shareButton: "Udostępnij",
      shareTitle: "{location} — raport miasta",
      shareText: "{location}: {fresh} świeżych, {older} starszych, {fossils} skamielin. Zobacz raport miasta w Caca Radar.",
      copied: "Link skopiowany",
      shareError: "Błąd udostępniania",
      summaryLine: "{location} — {fresh} świeżych, {older} starszych, {fossils} skamielin.",
      locationWithBarrio: "{city} — {barrio}",
      totalActiveLabel: "Aktywne zgłoszenia",
      freshLabel: "Świeże",
      olderLabel: "Starsze",
      fossilLabel: "Skamieliny",
      mapTitle: "Aktualna mapa miasta",
      barrioMapTitle: "Aktualna mapa dzielnicy",
      publicViewNote: "Oglądasz publiczną, udostępnialną wersję tego raportu miasta.",
    },
  },
  uk: {
    cityReportUi: {
      menuLabel: "Звіт міста",
      pageTitle: "Звіт міста",
      pageIntro: "Знайдіть місто з активними повідомленнями та поділіться швидким знімком його поточної ситуації.",
      premiumTitle: "Преміум-звіт міста",
      premiumBody: "Шукайте міста з активними повідомленнями, переглядайте їхній поточний стан і діліться публічним знімком.",
      viewPremiumPlans: "Переглянути плани Premium",
      cityListError: "Не вдалося завантажити активні міста",
      barrioListError: "Не вдалося завантажити активні райони",
      loadError: "Не вдалося завантажити звіт міста",
      searchPlaceholder: "Введіть місто з активними повідомленнями",
      searchAction: "Пошук",
      searchHint: "Тут показуються лише міста, які зараз мають активні повідомлення.",
      barrioSearchPlaceholder: "Введіть район з активними повідомленнями",
      barrioSearchAction: "Обрати район",
      barrioSearchHint: "Ви можете звузити цей звіт до району з активними повідомленнями в цьому місті.",
      loadingCities: "Завантаження міст...",
      loadingBarrios: "Завантаження районів...",
      activeCountShort: "{count} активних",
      noMatches: "Для цього міста немає збігів",
      noBarrioMatches: "Для цього району немає збігів",
      chooseCity: "Виберіть місто, щоб побачити його поточний звіт.",
      emptyState: "Зараз для цього міста немає доступного звіту.",
      shareButton: "Поширити",
      shareTitle: "{location} — звіт міста",
      shareText: "{location}: {fresh} свіжих, {older} старіших, {fossils} викопних. Перегляньте звіт міста в Caca Radar.",
      copied: "Посилання скопійовано",
      shareError: "Помилка під час поширення",
      summaryLine: "{location} — {fresh} свіжих, {older} старіших, {fossils} викопних.",
      locationWithBarrio: "{city} — {barrio}",
      totalActiveLabel: "Активні повідомлення",
      freshLabel: "Свіжі",
      olderLabel: "Старіші",
      fossilLabel: "Викопні",
      mapTitle: "Поточна карта міста",
      barrioMapTitle: "Поточна карта району",
      publicViewNote: "Ви переглядаєте публічну версію цього звіту міста, якою можна поділитися.",
    },
  },
  ru: {
    cityReportUi: {
      menuLabel: "Отчёт по городу",
      pageTitle: "Отчёт по городу",
      pageIntro: "Найдите город с активными сообщениями и поделитесь быстрым снимком его текущей ситуации.",
      premiumTitle: "Премиум-отчёт по городу",
      premiumBody: "Ищите города с активными сообщениями, смотрите их текущее состояние и делитесь публичным снимком.",
      viewPremiumPlans: "Посмотреть планы Премиум",
      cityListError: "Не удалось загрузить активные города",
      barrioListError: "Не удалось загрузить активные районы",
      loadError: "Не удалось загрузить отчёт по городу",
      searchPlaceholder: "Введите город с активными сообщениями",
      searchAction: "Поиск",
      searchHint: "Здесь показываются только города, в которых сейчас есть активные сообщения.",
      barrioSearchPlaceholder: "Введите район с активными сообщениями",
      barrioSearchAction: "Выбрать район",
      barrioSearchHint: "Вы можете сузить этот отчёт до района с активными сообщениями в этом городе.",
      loadingCities: "Загрузка городов...",
      loadingBarrios: "Загрузка районов...",
      activeCountShort: "{count} активных",
      noMatches: "Для этого города ничего не найдено",
      noBarrioMatches: "Для этого района ничего не найдено",
      chooseCity: "Выберите город, чтобы посмотреть его текущий отчёт.",
      emptyState: "Сейчас для этого города нет доступного отчёта.",
      shareButton: "Поделиться",
      shareTitle: "{location} — отчёт по городу",
      shareText: "{location}: {fresh} свежих, {older} старых, {fossils} ископаемых. Посмотрите отчёт по городу в Caca Radar.",
      copied: "Ссылка скопирована",
      shareError: "Ошибка при отправке",
      summaryLine: "{location} — {fresh} свежих, {older} старых, {fossils} ископаемых.",
      locationWithBarrio: "{city} — {barrio}",
      totalActiveLabel: "Активные сообщения",
      freshLabel: "Свежие",
      olderLabel: "Старые",
      fossilLabel: "Ископаемые",
      mapTitle: "Текущая карта города",
      barrioMapTitle: "Текущая карта района",
      publicViewNote: "Вы просматриваете публичную версию этого отчёта по городу, которой можно поделиться.",
    },
  },
  eu: {
    cityReportUi: {
      menuLabel: "Hiri txostena",
      pageTitle: "Hiri txostena",
      pageIntro: "Bilatu txosten aktiboak dituen hiri bat eta partekatu une honetako egoeraren laburpena.",
      premiumTitle: "Premium hiri txostena",
      premiumBody: "Bilatu txosten aktiboak dituzten hiriak, berrikusi haien uneko egoera eta partekatu laburpen publikoa.",
      viewPremiumPlans: "Ikusi Premium planak",
      cityListError: "Ezin izan dira hiri aktiboak kargatu",
      barrioListError: "Ezin izan dira auzo aktiboak kargatu",
      loadError: "Ezin izan da hiri txostena kargatu",
      searchPlaceholder: "Idatzi txosten aktiboak dituen hiri bat",
      searchAction: "Bilatu",
      searchHint: "Hemen une honetan txosten aktiboak dituzten hiriak bakarrik agertzen dira.",
      barrioSearchPlaceholder: "Idatzi txosten aktiboak dituen auzo bat",
      barrioSearchAction: "Aukeratu auzoa",
      barrioSearchHint: "Txostena hiri honetako txosten aktiboak dituen auzo batera mugatu dezakezu.",
      loadingCities: "Hiriak kargatzen...",
      loadingBarrios: "Auzoak kargatzen...",
      activeCountShort: "{count} aktibo",
      noMatches: "Ez dago bat datorren hiririk",
      noBarrioMatches: "Ez dago bat datorren auzorik",
      chooseCity: "Aukeratu hiri bat bere uneko txostena ikusteko.",
      emptyState: "Une honetan ez dago hiri honetarako txostenik.",
      shareButton: "Partekatu",
      shareTitle: "{location} — hiri txostena",
      shareText: "{location}: {fresh} fresko, {older} zaharrago, {fossils} fosil. Ikusi hiri txostena Caca Radar-en.",
      copied: "Esteka arbelean kopiatu da",
      shareError: "Errorea partekatzean",
      summaryLine: "{location} — {fresh} fresko, {older} zaharrago, {fossils} fosil.",
      locationWithBarrio: "{city} — {barrio}",
      totalActiveLabel: "Txosten aktiboak",
      freshLabel: "Freskoak",
      olderLabel: "Zaharragoak",
      fossilLabel: "Fosilak",
      mapTitle: "Hiriaren uneko mapa",
      barrioMapTitle: "Auzoaren uneko mapa",
      publicViewNote: "Hiri txosten honen bertsio publiko eta partekagarria ikusten ari zara.",
    },
  },
  ca: {
    cityReportUi: {
      menuLabel: "Report de ciutat",
      pageTitle: "Report de ciutat",
      pageIntro: "Busca una ciutat amb avisos actius i comparteix una vista ràpida de la situació actual.",
      premiumTitle: "Report de ciutat Premium",
      premiumBody: "Busca ciutats amb avisos actius, revisa l'estat actual i comparteix una vista pública.",
      viewPremiumPlans: "Veure plans Premium",
      cityListError: "No hem pogut carregar les ciutats actives",
      barrioListError: "No hem pogut carregar els barris actius",
      loadError: "No hem pogut carregar el report de la ciutat",
      searchPlaceholder: "Escriu una ciutat amb avisos actius",
      searchAction: "Buscar",
      searchHint: "Aquí només es mostren ciutats que tenen avisos actius ara mateix.",
      barrioSearchPlaceholder: "Escriu un barri amb avisos actius",
      barrioSearchAction: "Tria barri",
      barrioSearchHint: "Pots limitar aquest report a un barri amb avisos actius en aquesta ciutat.",
      loadingCities: "Carregant ciutats...",
      loadingBarrios: "Carregant barris...",
      activeCountShort: "{count} actius",
      noMatches: "No hi ha coincidències per a aquesta ciutat",
      noBarrioMatches: "No hi ha coincidències per a aquest barri",
      chooseCity: "Selecciona una ciutat per veure'n el report actual.",
      emptyState: "Ara mateix no hi ha cap report disponible per a aquesta ciutat.",
      shareButton: "Compartir",
      shareTitle: "{location} — report de ciutat",
      shareText: "{location}: {fresh} frescos, {older} antics, {fossils} fòssils. Mira el report de ciutat a Caca Radar.",
      copied: "Enllaç copiat",
      shareError: "Error en compartir",
      summaryLine: "{location} — {fresh} frescos, {older} antics, {fossils} fòssils.",
      locationWithBarrio: "{city} — {barrio}",
      totalActiveLabel: "Avisos actius",
      freshLabel: "Frescos",
      olderLabel: "Antics",
      fossilLabel: "Fòssils",
      mapTitle: "Mapa actual de la ciutat",
      barrioMapTitle: "Mapa actual del barri",
      publicViewNote: "Estàs veient una versió pública i compartible d'aquest report de ciutat.",
    },
  },
  val: {
    cityReportUi: {
      menuLabel: "Report de ciutat",
      pageTitle: "Report de ciutat",
      pageIntro: "Busca una ciutat amb avisos actius i compartix una vista ràpida de la situació actual.",
      premiumTitle: "Report de ciutat Premium",
      premiumBody: "Busca ciutats amb avisos actius, revisa l'estat actual i compartix una vista pública.",
      viewPremiumPlans: "Vore plans Premium",
      cityListError: "No hem pogut carregar les ciutats actives",
      barrioListError: "No hem pogut carregar els barris actius",
      loadError: "No hem pogut carregar el report de la ciutat",
      searchPlaceholder: "Escriu una ciutat amb avisos actius",
      searchAction: "Buscar",
      searchHint: "Ací només es mostren ciutats que tenen avisos actius ara mateix.",
      barrioSearchPlaceholder: "Escriu un barri amb avisos actius",
      barrioSearchAction: "Triar barri",
      barrioSearchHint: "Pots limitar este report a un barri amb avisos actius en esta ciutat.",
      loadingCities: "Carregant ciutats...",
      loadingBarrios: "Carregant barris...",
      activeCountShort: "{count} actius",
      noMatches: "No hi ha coincidències per a esta ciutat",
      noBarrioMatches: "No hi ha coincidències per a este barri",
      chooseCity: "Selecciona una ciutat per vore'n el report actual.",
      emptyState: "Ara mateix no hi ha cap report disponible per a esta ciutat.",
      shareButton: "Compartir",
      shareTitle: "{location} — report de ciutat",
      shareText: "{location}: {fresh} frescos, {older} antics, {fossils} fòssils. Mira el report de ciutat en Caca Radar.",
      copied: "Enllaç copiat",
      shareError: "Error en compartir",
      summaryLine: "{location} — {fresh} frescos, {older} antics, {fossils} fòssils.",
      locationWithBarrio: "{city} — {barrio}",
      totalActiveLabel: "Avisos actius",
      freshLabel: "Frescos",
      olderLabel: "Antics",
      fossilLabel: "Fòssils",
      mapTitle: "Mapa actual de la ciutat",
      barrioMapTitle: "Mapa actual del barri",
      publicViewNote: "Estàs veient una versió pública i compartible d'este report de ciutat.",
    },
  },
};

Object.keys(translations).forEach((lang) => {
  const extra = cityReportUiTranslations[lang] || cityReportUiTranslations.en;
  Object.entries(extra).forEach(([group, values]) => {
    translations[lang][group] = {
      ...(translations[lang][group] || {}),
      ...values,
    };
  });
});

const shareUiTranslations = {
  es: { shareUi: { tagline: "¿Cuánta caca de perro hay en nuestras aceras?" } },
  en: { shareUi: { tagline: "How much dog poop is on our sidewalks?" } },
  de: { shareUi: { tagline: "Wie viel Hundekot liegt auf unseren Gehwegen?" } },
  nl: { shareUi: { tagline: "Hoeveel hondenpoep ligt er op onze stoepen?" } },
  pl: { shareUi: { tagline: "Ile psich kup jest na naszych chodnikach?" } },
  uk: { shareUi: { tagline: "Скільки собачих какашок на наших тротуарах?" } },
  ru: { shareUi: { tagline: "Сколько собачьих какашек на наших тротуарах?" } },
  eu: { shareUi: { tagline: "Zenbat txakur kaka dago gure espaloietan?" } },
  ca: { shareUi: { tagline: "Quanta caca de gos hi ha a les nostres voreres?" } },
  val: { shareUi: { tagline: "Quanta caca de gos hi ha en les nostres voreres?" } },
};

Object.keys(translations).forEach((lang) => {
  const extra = shareUiTranslations[lang] || shareUiTranslations.en;
  Object.entries(extra).forEach(([group, values]) => {
    translations[lang][group] = {
      ...(translations[lang][group] || {}),
      ...values,
    };
  });
});

const downloadUiTranslations = {
  es: {
    downloadUi: {
      pageTitle: "Descarga Caca Radar",
      pageIntro: "Has abierto una tarjeta compartida desde Caca Radar. Aquí puedes ver un ejemplo visual y descargar la app en tu tienda favorita.",
      sharedCard: "Tarjeta compartida",
      sharedCardPreview: "Vista previa compartible",
      previewNote: "Esta imagen representa el formato visual que se comparte en redes y mensajería.",
      previewAlt: "Ejemplo de tarjeta compartida de Caca Radar",
      downloadTitle: "Consigue la app",
      downloadIntro: "Abre la tienda que prefieras para instalar Caca Radar en tu móvil.",
      openAppStore: "Abrir en App Store",
      openPlayStore: "Abrir en Google Play",
      whyTitle: "Qué podrás hacer en la app",
      whyOne: "Ver avisos activos cerca de ti y seguir su evolución.",
      whyTwo: "Compartir reportes, rankings y resúmenes de ciudad o barrio.",
      whyThree: "Participar en una herramienta comunitaria, privada e independiente.",
      watchTitle: "Companion app para reloj",
      watchIntro: "Lleva Caca Radar en tu muñeca con el companion app para Apple Watch y relojes Android.",
      watchOne: "Reporta desde tu ubicación actual con un toque cuando detectes una zona problemática.",
      watchTwo: "Funciona como vía rápida para avisar mientras paseas, corres o vas con las manos ocupadas.",
      watchThree: "La app del reloj se sincroniza con tu móvil para enviar avisos sin perder el contexto de tu cuenta.",
      municipalTitle: "Acceso municipal",
      municipalIntro: "Caca Radar también ofrece cuentas municipales para ayuntamientos que quieran seguir puntos problemáticos, revisar avisos y coordinar respuestas visibles.",
      municipalOne: "Planes para municipios pequeños, medianos y grandes según población y necesidad operativa.",
      municipalTwo: "Dashboards municipales, filtros por barrio y herramientas de revisión que se activan durante el onboarding.",
      municipalThree: "Configuración piloto disponible para los primeros municipios y opciones personalizadas según el flujo local.",
      municipalCta: "Ver cuentas municipales",
      cityReportForCity: "Reporte de ciudad: {city}",
      cityReportWithBarrio: "Reporte de ciudad: {city} — {barrio}",
      cleanestCities: "Ciudades más limpias",
      dirtiestCities: "Ciudades con más avisos",
      barrioRankingsForCity: "Ranking de barrios en {city}",
      profileForName: "Perfil compartido: {name}",
      reportInCity: "Aviso compartido en {city}",
    },
  },
  en: {
    downloadUi: {
      pageTitle: "Download Caca Radar",
      pageIntro: "You opened a shared card from Caca Radar. Here you can view the example image and download the app from your preferred store.",
      sharedCard: "Shared card",
      sharedCardPreview: "Share preview",
      previewNote: "This image shows the visual format used when these cards are shared on social and messaging apps.",
      previewAlt: "Caca Radar shared card example",
      downloadTitle: "Get the app",
      downloadIntro: "Open your preferred store to install Caca Radar on your phone.",
      openAppStore: "Open in the App Store",
      openPlayStore: "Open in Google Play",
      whyTitle: "What you can do in the app",
      whyOne: "See active reports near you and track how they evolve.",
      whyTwo: "Share reports, rankings, and city or neighborhood summaries.",
      whyThree: "Take part in a private, independent community tool.",
      watchTitle: "Watch companion app",
      watchIntro: "Take Caca Radar to your wrist with the companion app for Apple Watch and Android watches.",
      watchOne: "Report from your current location with one tap when you spot a problem area.",
      watchTwo: "It works as the fastest reporting path while walking, running, or when your hands are busy.",
      watchThree: "The watch app stays synced with your phone so reports keep your account context intact.",
      municipalTitle: "Municipal access",
      municipalIntro: "Caca Radar also offers municipal accounts for Ayuntamientos that want to track recurring problem areas, review reports, and coordinate visible responses.",
      municipalOne: "Plans for small, medium, and large municipalities based on population and operating needs.",
      municipalTwo: "Municipal dashboards, barrio filters, and review tools activated during onboarding.",
      municipalThree: "Pilot setup is available for early municipalities, with custom options shaped around the local workflow.",
      municipalCta: "View municipal accounts",
      cityReportForCity: "City report: {city}",
      cityReportWithBarrio: "City report: {city} — {barrio}",
      cleanestCities: "Cleanest cities",
      dirtiestCities: "Cities with the most reports",
      barrioRankingsForCity: "Neighborhood rankings in {city}",
      profileForName: "Shared profile: {name}",
      reportInCity: "Shared report in {city}",
    },
  },
  de: {
    downloadUi: {
      pageTitle: "Caca Radar herunterladen",
      pageIntro: "Du hast eine geteilte Karte von Caca Radar geöffnet. Hier kannst du das Beispielbild sehen und die App im passenden Store laden.",
      sharedCard: "Geteilte Karte",
      sharedCardPreview: "Geteilte Vorschau",
      previewNote: "Dieses Bild zeigt das visuelle Format, das in sozialen Netzwerken und Messengern geteilt wird.",
      previewAlt: "Beispiel einer geteilten Caca-Radar-Karte",
      downloadTitle: "Hol dir die App",
      downloadIntro: "Öffne den passenden Store, um Caca Radar auf dein Handy zu laden.",
      openAppStore: "Im App Store öffnen",
      openPlayStore: "Bei Google Play öffnen",
      whyTitle: "Was du in der App tun kannst",
      whyOne: "Aktive Meldungen in deiner Nähe sehen und ihre Entwicklung verfolgen.",
      whyTwo: "Meldungen, Rankings und Stadt- oder Viertelberichte teilen.",
      whyThree: "An einem privaten, unabhängigen Community-Tool teilnehmen.",
      cityReportForCity: "Stadtbericht: {city}",
      cityReportWithBarrio: "Stadtbericht: {city} — {barrio}",
      cleanestCities: "Sauberste Städte",
      dirtiestCities: "Städte mit den meisten Meldungen",
      barrioRankingsForCity: "Viertel-Ranking in {city}",
      profileForName: "Geteiltes Profil: {name}",
      reportInCity: "Geteilte Meldung in {city}",
    },
  },
  nl: {
    downloadUi: {
      pageTitle: "Download Caca Radar",
      pageIntro: "Je hebt een gedeelde kaart van Caca Radar geopend. Hier kun je het voorbeeldbeeld bekijken en de app uit je favoriete store downloaden.",
      sharedCard: "Gedeelde kaart",
      sharedCardPreview: "Deelvoorbeeld",
      previewNote: "Deze afbeelding toont het visuele formaat dat wordt gedeeld op sociale media en berichtenapps.",
      previewAlt: "Voorbeeld van een gedeelde Caca Radar-kaart",
      downloadTitle: "Download de app",
      downloadIntro: "Open je favoriete store om Caca Radar op je telefoon te installeren.",
      openAppStore: "Open in de App Store",
      openPlayStore: "Open in Google Play",
      whyTitle: "Wat je in de app kunt doen",
      whyOne: "Actieve meldingen in je buurt zien en volgen.",
      whyTwo: "Meldingen, ranglijsten en samenvattingen van stad of wijk delen.",
      whyThree: "Meedoen aan een private, onafhankelijke communitytool.",
      cityReportForCity: "Stadsrapport: {city}",
      cityReportWithBarrio: "Stadsrapport: {city} — {barrio}",
      cleanestCities: "Schoonste steden",
      dirtiestCities: "Steden met de meeste meldingen",
      barrioRankingsForCity: "Wijkranglijst in {city}",
      profileForName: "Gedeeld profiel: {name}",
      reportInCity: "Gedeelde melding in {city}",
    },
  },
  pl: {
    downloadUi: {
      pageTitle: "Pobierz Caca Radar",
      pageIntro: "Otworzono udostępnioną kartę z Caca Radar. Tutaj możesz zobaczyć przykładowy obraz i pobrać aplikację ze swojego sklepu.",
      sharedCard: "Udostępniona karta",
      sharedCardPreview: "Podgląd udostępnienia",
      previewNote: "Ten obraz pokazuje format wizualny używany przy udostępnianiu w mediach społecznościowych i komunikatorach.",
      previewAlt: "Przykład udostępnionej karty Caca Radar",
      downloadTitle: "Pobierz aplikację",
      downloadIntro: "Otwórz wybrany sklep, aby zainstalować Caca Radar na telefonie.",
      openAppStore: "Otwórz w App Store",
      openPlayStore: "Otwórz w Google Play",
      whyTitle: "Co możesz zrobić w aplikacji",
      whyOne: "Zobaczyć aktywne zgłoszenia w pobliżu i śledzić ich zmiany.",
      whyTwo: "Udostępniać zgłoszenia, rankingi oraz podsumowania miasta lub dzielnicy.",
      whyThree: "Brać udział w prywatnym, niezależnym narzędziu społecznościowym.",
      cityReportForCity: "Raport miasta: {city}",
      cityReportWithBarrio: "Raport miasta: {city} — {barrio}",
      cleanestCities: "Najczystsze miasta",
      dirtiestCities: "Miasta z największą liczbą zgłoszeń",
      barrioRankingsForCity: "Ranking dzielnic w {city}",
      profileForName: "Udostępniony profil: {name}",
      reportInCity: "Udostępnione zgłoszenie w {city}",
    },
  },
  uk: {
    downloadUi: {
      pageTitle: "Завантажити Caca Radar",
      pageIntro: "Ви відкрили поширену картку з Caca Radar. Тут можна переглянути приклад зображення та завантажити застосунок із потрібного магазину.",
      sharedCard: "Поширена картка",
      sharedCardPreview: "Попередній перегляд поширення",
      previewNote: "Це зображення показує формат, який використовується під час поширення в соцмережах і месенджерах.",
      previewAlt: "Приклад поширеної картки Caca Radar",
      downloadTitle: "Отримати застосунок",
      downloadIntro: "Відкрийте потрібний магазин, щоб встановити Caca Radar на телефон.",
      openAppStore: "Відкрити в App Store",
      openPlayStore: "Відкрити в Google Play",
      whyTitle: "Що можна робити в застосунку",
      whyOne: "Бачити активні повідомлення поруч і стежити за їхнім станом.",
      whyTwo: "Ділитися повідомленнями, рейтингами та підсумками міста чи району.",
      whyThree: "Брати участь у приватному незалежному інструменті спільноти.",
      cityReportForCity: "Звіт міста: {city}",
      cityReportWithBarrio: "Звіт міста: {city} — {barrio}",
      cleanestCities: "Найчистіші міста",
      dirtiestCities: "Міста з найбільшою кількістю повідомлень",
      barrioRankingsForCity: "Рейтинг районів у {city}",
      profileForName: "Поширений профіль: {name}",
      reportInCity: "Поширене повідомлення у {city}",
    },
  },
  ru: {
    downloadUi: {
      pageTitle: "Скачать Caca Radar",
      pageIntro: "Вы открыли общую карточку из Caca Radar. Здесь можно посмотреть пример изображения и скачать приложение из нужного магазина.",
      sharedCard: "Общая карточка",
      sharedCardPreview: "Предпросмотр для публикации",
      previewNote: "Это изображение показывает визуальный формат, который используется при публикации в соцсетях и мессенджерах.",
      previewAlt: "Пример общей карточки Caca Radar",
      downloadTitle: "Скачать приложение",
      downloadIntro: "Откройте нужный магазин, чтобы установить Caca Radar на телефон.",
      openAppStore: "Открыть в App Store",
      openPlayStore: "Открыть в Google Play",
      whyTitle: "Что можно делать в приложении",
      whyOne: "Смотреть активные сообщения рядом с вами и следить за их изменением.",
      whyTwo: "Делиться сообщениями, рейтингами и сводками по городу или району.",
      whyThree: "Участвовать в частном независимом инструменте сообщества.",
      cityReportForCity: "Отчёт по городу: {city}",
      cityReportWithBarrio: "Отчёт по городу: {city} — {barrio}",
      cleanestCities: "Самые чистые города",
      dirtiestCities: "Города с наибольшим числом сообщений",
      barrioRankingsForCity: "Рейтинг районов в {city}",
      profileForName: "Общий профиль: {name}",
      reportInCity: "Общее сообщение в {city}",
    },
  },
  eu: {
    downloadUi: {
      pageTitle: "Deskargatu Caca Radar",
      pageIntro: "Caca Radar-etik partekatutako txartel bat ireki duzu. Hemen adibideko irudia ikusi eta aplikazioa zure dendan deskarga dezakezu.",
      sharedCard: "Partekatutako txartela",
      sharedCardPreview: "Partekatze-aurrebista",
      previewNote: "Irudi honek sare sozialetan eta mezularitzan partekatzeko erabiltzen den formatua erakusten du.",
      previewAlt: "Caca Radar partekatutako txartelaren adibidea",
      downloadTitle: "Lortu aplikazioa",
      downloadIntro: "Ireki nahi duzun denda Caca Radar zure mugikorrean instalatzeko.",
      openAppStore: "App Store-n ireki",
      openPlayStore: "Google Play-n ireki",
      whyTitle: "Zer egin dezakezu aplikazioan",
      whyOne: "Zure inguruko txosten aktiboak ikusi eta haien bilakaera jarraitu.",
      whyTwo: "Txostenak, sailkapenak eta hiri edo auzo laburpenak partekatu.",
      whyThree: "Tresna komunitario pribatu eta independente batean parte hartu.",
      cityReportForCity: "Hiri txostena: {city}",
      cityReportWithBarrio: "Hiri txostena: {city} — {barrio}",
      cleanestCities: "Hiri garbienak",
      dirtiestCities: "Abisu gehien dituzten hiriak",
      barrioRankingsForCity: "{city}ko auzo sailkapena",
      profileForName: "Partekatutako profila: {name}",
      reportInCity: "{city}n partekatutako abisua",
    },
  },
  ca: {
    downloadUi: {
      pageTitle: "Descarrega Caca Radar",
      pageIntro: "Has obert una targeta compartida de Caca Radar. Aquí pots veure la imatge d’exemple i descarregar l’app des de la teua botiga preferida.",
      sharedCard: "Targeta compartida",
      sharedCardPreview: "Vista prèvia compartida",
      previewNote: "Aquesta imatge mostra el format visual utilitzat quan es comparteix en xarxes socials i missatgeria.",
      previewAlt: "Exemple de targeta compartida de Caca Radar",
      downloadTitle: "Descarrega l’app",
      downloadIntro: "Obri la botiga que preferisques per instal·lar Caca Radar al mòbil.",
      openAppStore: "Obrir a l’App Store",
      openPlayStore: "Obrir a Google Play",
      whyTitle: "Què podràs fer a l’app",
      whyOne: "Veure avisos actius prop teu i seguir-ne l’evolució.",
      whyTwo: "Compartir avisos, rànquings i resums de ciutat o barri.",
      whyThree: "Participar en una eina comunitària privada i independent.",
      cityReportForCity: "Informe de ciutat: {city}",
      cityReportWithBarrio: "Informe de ciutat: {city} — {barrio}",
      cleanestCities: "Ciutats més netes",
      dirtiestCities: "Ciutats amb més avisos",
      barrioRankingsForCity: "Rànquing de barris a {city}",
      profileForName: "Perfil compartit: {name}",
      reportInCity: "Avís compartit a {city}",
    },
  },
  val: {
    downloadUi: {
      pageTitle: "Descarrega Caca Radar",
      pageIntro: "Has obert una targeta compartida de Caca Radar. Ací pots vore la imatge d’exemple i descarregar l’app des de la botiga que preferisques.",
      sharedCard: "Targeta compartida",
      sharedCardPreview: "Vista prèvia compartida",
      previewNote: "Esta imatge mostra el format visual utilitzat quan es compartix en xarxes socials i missatgeria.",
      previewAlt: "Exemple de targeta compartida de Caca Radar",
      downloadTitle: "Descarrega l’app",
      downloadIntro: "Obri la botiga que preferisques per instal·lar Caca Radar al mòbil.",
      openAppStore: "Obrir en l’App Store",
      openPlayStore: "Obrir en Google Play",
      whyTitle: "Què podràs fer en l’app",
      whyOne: "Vore avisos actius prop de tu i seguir la seua evolució.",
      whyTwo: "Compartir avisos, rànquings i resums de ciutat o barri.",
      whyThree: "Participar en una ferramenta comunitària privada i independent.",
      cityReportForCity: "Informe de ciutat: {city}",
      cityReportWithBarrio: "Informe de ciutat: {city} — {barrio}",
      cleanestCities: "Ciutats més netes",
      dirtiestCities: "Ciutats amb més avisos",
      barrioRankingsForCity: "Rànquing de barris en {city}",
      profileForName: "Perfil compartit: {name}",
      reportInCity: "Avís compartit en {city}",
    },
  },
};

Object.keys(translations).forEach((lang) => {
  const extra = downloadUiTranslations[lang] || downloadUiTranslations.en;
  Object.entries(extra).forEach(([group, values]) => {
    translations[lang][group] = {
      ...(translations[lang][group] || {}),
      ...values,
    };
  });
});

const appGateTranslations = {
  es: {
    appGateUi: {
      checkingTitle: "Comprobando ubicación",
      checkingBody: "Necesitamos tu ubicación actual para confirmar que estás dentro de España.",
      blockedTitle: "Disponible solo en España",
      outsideSpain: "Caca Radar solo funciona cuando tu ubicación GPS actual está dentro del territorio nacional de España.",
      permissionDenied: "Necesitamos permiso de ubicación para comprobar si estás en España.",
      unavailable: "No pudimos obtener tu ubicación actual. Inténtalo de nuevo en unos segundos.",
      timeout: "La comprobación de ubicación tardó demasiado. Vuelve a intentarlo.",
      noGeolocation: "Este dispositivo no ofrece geolocalización, así que no podemos habilitar la app.",
      spainOnlyNotice: "El acceso a la app está limitado a personas cuya ubicación actual esté en {country}.",
      retry: "Volver a comprobar",
    },
  },
  en: {
    appGateUi: {
      checkingTitle: "Checking location",
      checkingBody: "We need your current location to confirm you're inside Spain.",
      blockedTitle: "Available only in Spain",
      outsideSpain: "Caca Radar only works when your current GPS location is within Spain's national territory.",
      permissionDenied: "We need location permission to check whether you're in Spain.",
      unavailable: "We couldn't get your current location. Please try again in a few seconds.",
      timeout: "The location check took too long. Please try again.",
      noGeolocation: "This device doesn't provide geolocation, so we can't enable the app.",
      spainOnlyNotice: "App access is limited to people whose current location is inside {country}.",
      retry: "Check again",
    },
  },
  de: {
    appGateUi: {
      checkingTitle: "Standort wird geprüft",
      checkingBody: "Wir brauchen deinen aktuellen Standort, um zu bestätigen, dass du dich in Spanien befindest.",
      blockedTitle: "Nur in Spanien verfügbar",
      outsideSpain: "Caca Radar funktioniert nur, wenn sich dein aktueller GPS-Standort innerhalb des spanischen Staatsgebiets befindet.",
      permissionDenied: "Wir brauchen Standortzugriff, um zu prüfen, ob du dich in Spanien befindest.",
      unavailable: "Dein aktueller Standort konnte nicht ermittelt werden. Bitte versuche es in ein paar Sekunden erneut.",
      timeout: "Die Standortprüfung hat zu lange gedauert. Bitte versuche es erneut.",
      noGeolocation: "Dieses Gerät bietet keine Geolokalisierung, daher können wir die App nicht freischalten.",
      spainOnlyNotice: "Der Zugriff auf die App ist auf Personen beschränkt, deren aktueller Standort sich in {country} befindet.",
      retry: "Erneut prüfen",
    },
  },
  nl: {
    appGateUi: {
      checkingTitle: "Locatie controleren",
      checkingBody: "We hebben je huidige locatie nodig om te bevestigen dat je in Spanje bent.",
      blockedTitle: "Alleen beschikbaar in Spanje",
      outsideSpain: "Caca Radar werkt alleen als je huidige GPS-locatie zich binnen het nationale grondgebied van Spanje bevindt.",
      permissionDenied: "We hebben locatietoegang nodig om te controleren of je in Spanje bent.",
      unavailable: "We konden je huidige locatie niet ophalen. Probeer het over een paar seconden opnieuw.",
      timeout: "De locatiecontrole duurde te lang. Probeer het opnieuw.",
      noGeolocation: "Dit apparaat biedt geen geolocatie, dus we kunnen de app niet inschakelen.",
      spainOnlyNotice: "Toegang tot de app is beperkt tot mensen van wie de huidige locatie zich in {country} bevindt.",
      retry: "Opnieuw controleren",
    },
  },
  pl: {
    appGateUi: {
      checkingTitle: "Sprawdzanie lokalizacji",
      checkingBody: "Potrzebujemy Twojej bieżącej lokalizacji, aby potwierdzić, że jesteś w Hiszpanii.",
      blockedTitle: "Dostępne tylko w Hiszpanii",
      outsideSpain: "Caca Radar działa tylko wtedy, gdy Twoja bieżąca lokalizacja GPS znajduje się na terytorium Hiszpanii.",
      permissionDenied: "Potrzebujemy dostępu do lokalizacji, aby sprawdzić, czy jesteś w Hiszpanii.",
      unavailable: "Nie udało się pobrać Twojej bieżącej lokalizacji. Spróbuj ponownie za kilka sekund.",
      timeout: "Sprawdzanie lokalizacji trwało zbyt długo. Spróbuj ponownie.",
      noGeolocation: "To urządzenie nie udostępnia geolokalizacji, więc nie możemy włączyć aplikacji.",
      spainOnlyNotice: "Dostęp do aplikacji jest ograniczony do osób, których bieżąca lokalizacja znajduje się w {country}.",
      retry: "Sprawdź ponownie",
    },
  },
  uk: {
    appGateUi: {
      checkingTitle: "Перевірка місцезнаходження",
      checkingBody: "Нам потрібне ваше поточне місцезнаходження, щоб підтвердити, що ви перебуваєте в Іспанії.",
      blockedTitle: "Доступно лише в Іспанії",
      outsideSpain: "Caca Radar працює лише тоді, коли ваше поточне місцезнаходження GPS знаходиться в межах національної території Іспанії.",
      permissionDenied: "Нам потрібен дозвіл на доступ до місцезнаходження, щоб перевірити, чи ви в Іспанії.",
      unavailable: "Не вдалося отримати ваше поточне місцезнаходження. Спробуйте ще раз за кілька секунд.",
      timeout: "Перевірка місцезнаходження тривала надто довго. Спробуйте ще раз.",
      noGeolocation: "Цей пристрій не надає геолокацію, тому ми не можемо увімкнути застосунок.",
      spainOnlyNotice: "Доступ до застосунку обмежено для людей, чия поточна локація знаходиться в {country}.",
      retry: "Перевірити ще раз",
    },
  },
  ru: {
    appGateUi: {
      checkingTitle: "Проверка местоположения",
      checkingBody: "Нам нужно ваше текущее местоположение, чтобы подтвердить, что вы находитесь в Испании.",
      blockedTitle: "Доступно только в Испании",
      outsideSpain: "Caca Radar работает только тогда, когда ваше текущее GPS-местоположение находится в пределах национальной территории Испании.",
      permissionDenied: "Нам нужен доступ к геолокации, чтобы проверить, находитесь ли вы в Испании.",
      unavailable: "Не удалось получить ваше текущее местоположение. Попробуйте снова через несколько секунд.",
      timeout: "Проверка местоположения заняла слишком много времени. Попробуйте снова.",
      noGeolocation: "Это устройство не предоставляет геолокацию, поэтому мы не можем включить приложение.",
      spainOnlyNotice: "Доступ к приложению ограничен для людей, чьё текущее местоположение находится в {country}.",
      retry: "Проверить снова",
    },
  },
  eu: {
    appGateUi: {
      checkingTitle: "Kokalekua egiaztatzen",
      checkingBody: "Zure uneko kokalekua behar dugu Espainiaren barruan zaudela baieztatzeko.",
      blockedTitle: "Espainian bakarrik erabilgarri",
      outsideSpain: "Caca Radar-ek zure uneko GPS kokapena Espainiako lurralde nazionalean dagoenean bakarrik funtzionatzen du.",
      permissionDenied: "Kokaleku-baimena behar dugu Espainian zauden ala ez egiaztatzeko.",
      unavailable: "Ezin izan dugu zure uneko kokalekua lortu. Saiatu berriro segundo batzuk barru.",
      timeout: "Kokaleku-egiaztapenak gehiegi iraun du. Saiatu berriro.",
      noGeolocation: "Gailu honek ez du geolokalizaziorik eskaintzen, eta ezin dugu aplikazioa gaitu.",
      spainOnlyNotice: "Aplikaziorako sarbidea {country}-n dagoen uneko kokalekua duten pertsonentzat bakarrik da.",
      retry: "Egiaztatu berriro",
    },
  },
  ca: {
    appGateUi: {
      checkingTitle: "Comprovant la ubicació",
      checkingBody: "Necessitem la teva ubicació actual per confirmar que ets dins d'Espanya.",
      blockedTitle: "Disponible només a Espanya",
      outsideSpain: "Caca Radar només funciona quan la teva ubicació GPS actual és dins del territori nacional d'Espanya.",
      permissionDenied: "Necessitem permís d'ubicació per comprovar si ets a Espanya.",
      unavailable: "No hem pogut obtenir la teva ubicació actual. Torna-ho a provar d'aquí a uns segons.",
      timeout: "La comprovació d'ubicació ha trigat massa. Torna-ho a provar.",
      noGeolocation: "Aquest dispositiu no ofereix geolocalització, així que no podem habilitar l'app.",
      spainOnlyNotice: "L'accés a l'app està limitat a persones la ubicació actual de les quals és dins de {country}.",
      retry: "Torna a comprovar",
    },
  },
  val: {
    appGateUi: {
      checkingTitle: "Comprovant la ubicació",
      checkingBody: "Necessitem la teua ubicació actual per confirmar que estàs dins d'Espanya.",
      blockedTitle: "Disponible només a Espanya",
      outsideSpain: "Caca Radar només funciona quan la teua ubicació GPS actual és dins del territori nacional d'Espanya.",
      permissionDenied: "Necessitem permís d'ubicació per comprovar si estàs a Espanya.",
      unavailable: "No hem pogut obtindre la teua ubicació actual. Torna-ho a provar d'ací a uns segons.",
      timeout: "La comprovació d'ubicació ha tardat massa. Torna-ho a provar.",
      noGeolocation: "Este dispositiu no oferix geolocalització, així que no podem habilitar l'app.",
      spainOnlyNotice: "L'accés a l'app està limitat a persones la ubicació actual de les quals és dins de {country}.",
      retry: "Tornar a comprovar",
    },
  },
};

Object.keys(translations).forEach((lang) => {
  const extra = appGateTranslations[lang] || appGateTranslations.en;
  Object.entries(extra).forEach(([group, values]) => {
    translations[lang][group] = {
      ...(translations[lang][group] || {}),
      ...values,
    };
  });
});

const navigationTranslations = {
  es: {
    legalUi: {
      termsOfUse: "Términos de uso",
      cookiesPolicy: "Política de Cookies",
      communityGuidelines: "Normas de la comunidad",
      statusPage: "Estado",
      andTerms: "y los",
      loginNoticePrefix: "Al iniciar sesión, puedes revisar la",
      acceptPrivacyPrefix: "He leído y acepto la",
      acceptTermsPrefix: "He leído y acepto los",
      ageConfirmation: "Confirmo que tengo al menos 14 años o que dispongo de la autorización legal necesaria para usar el servicio.",
      registrationConsentRequired: "Debes aceptar la Política de Privacidad, los Términos y confirmar los requisitos de edad o autorización.",
      nonOfficialDisclaimer: "Caca Radar es una herramienta privada, independiente y no oficial. No representa, sustituye ni está afiliada a ningún ayuntamiento, administración pública ni entidad gubernamental.",
    },
    helpUi: {
      cookiesTitle: "Cookies y tecnologías similares",
      communityTitle: "Normas de la comunidad y moderación",
      storeCancellationNote: "Si tienes una suscripción contratada en Apple App Store o Google Play, debes cancelarla también desde tu cuenta de la tienda.",
    },
    statusUi: {
      title: "Estado del servicio",
      intro: "Esta página resume el estado operativo público de Caca Radar usando los endpoints reales de salud y versión del servicio.",
      refresh: "Actualizar",
      loading: "Cargando estado del servicio...",
      loadError: "No se pudo cargar el estado del servicio.",
      queryError: "Incidencia al consultar el estado",
      operational: "Operativo",
      degraded: "Degradado",
      database: "Base de datos",
      reportReads: "Lectura de reportes",
      userReads: "Lectura de usuarios",
      productionSafe: "Base de datos segura para producción",
      runtimeTitle: "Runtime",
      environment: "Entorno",
      currentUptime: "Uptime actual",
      startedAt: "Arranque",
      deployedCommit: "Commit desplegado",
      databaseTitle: "Base de datos",
      host: "Host",
      logicalName: "Nombre lógico",
      localMongo: "Mongo local",
      publishedVersions: "Versiones publicadas",
      publicChecks: "Comprobaciones públicas",
      baseApi: "API base",
      deepHealth: "Estado profundo",
      versionMetadata: "Metadata de versión",
      publicChecksNote: "Esta página refleja lo que informan esos endpoints. No incluye métricas privadas ni datos personales de usuarios.",
      openPublicStatus: "Ver estado público",
      yes: "Sí",
      no: "No",
      notAvailable: "No disponible",
      lessThanMinute: "menos de 1 min",
    },
    municipalityUi: {
      dashboardLabel: "Dashboard",
    },
    rankingUi: {
      leaderboardTitle: "Leaderboard",
    },
  },
  en: {
    legalUi: {
      termsOfUse: "Terms of use",
      cookiesPolicy: "Cookie policy",
      communityGuidelines: "Community guidelines",
      statusPage: "Status",
      andTerms: "and the",
      loginNoticePrefix: "When signing in, you can review the",
      acceptPrivacyPrefix: "I have read and accept the",
      acceptTermsPrefix: "I have read and accept the",
      ageConfirmation: "I confirm that I am at least 14 years old or that I have the legally required authorization to use the service.",
      registrationConsentRequired: "You must accept the Privacy Policy, the Terms, and confirm the age or authorization requirement.",
      nonOfficialDisclaimer: "Caca Radar is a private, independent, unofficial tool. It does not represent, replace, or affiliate with any city council, public administration, or government entity.",
    },
    helpUi: {
      cookiesTitle: "Cookies and similar technologies",
      communityTitle: "Community guidelines and moderation",
      storeCancellationNote: "If you have a subscription through the Apple App Store or Google Play, you must also cancel it from your store account.",
    },
    statusUi: {
      title: "Service status",
      intro: "This page summarizes the public operating status of Caca Radar using the live health and version endpoints.",
      refresh: "Refresh",
      loading: "Loading service status...",
      loadError: "Could not load service status.",
      queryError: "Issue while checking status",
      operational: "Operational",
      degraded: "Degraded",
      database: "Database",
      reportReads: "Report reads",
      userReads: "User reads",
      productionSafe: "Production-safe database",
      runtimeTitle: "Runtime",
      environment: "Environment",
      currentUptime: "Current uptime",
      startedAt: "Started at",
      deployedCommit: "Deployed commit",
      databaseTitle: "Database",
      host: "Host",
      logicalName: "Logical name",
      localMongo: "Local Mongo",
      publishedVersions: "Published versions",
      publicChecks: "Public checks",
      baseApi: "Base API",
      deepHealth: "Deep health",
      versionMetadata: "Version metadata",
      publicChecksNote: "This page reflects what those endpoints report. It does not include private metrics or personal user data.",
      openPublicStatus: "Open public status",
      yes: "Yes",
      no: "No",
      notAvailable: "Not available",
      lessThanMinute: "less than 1 min",
    },
    municipalityUi: {
      dashboardLabel: "Dashboard",
    },
    rankingUi: {
      leaderboardTitle: "Leaderboard",
    },
  },
  de: {
    legalUi: {
      statusPage: "Status",
      andTerms: "und die",
      loginNoticePrefix: "Beim Anmelden kannst du die",
      nonOfficialDisclaimer: "Caca Radar ist ein privates, unabhängiges und inoffizielles Tool. Es vertritt keine Stadtverwaltung, Behörde oder staatliche Stelle, ersetzt sie nicht und ist nicht mit ihnen verbunden.",
    },
    helpUi: {
      cookiesTitle: "Cookies und ähnliche Technologien",
      communityTitle: "Community-Richtlinien und Moderation",
      storeCancellationNote: "Wenn du ein Abo über den Apple App Store oder Google Play abgeschlossen hast, musst du es dort auch separat kündigen.",
    },
    statusUi: {
      title: "Servicestatus",
      intro: "Diese Seite fasst den öffentlichen Betriebsstatus von Caca Radar anhand der Live-Endpunkte für Gesundheit und Version zusammen.",
      refresh: "Aktualisieren",
      loading: "Servicestatus wird geladen...",
      loadError: "Der Servicestatus konnte nicht geladen werden.",
      queryError: "Fehler beim Abrufen des Status",
      operational: "Betriebsbereit",
      degraded: "Beeinträchtigt",
      database: "Datenbank",
      reportReads: "Berichtszugriffe",
      userReads: "Nutzerzugriffe",
      productionSafe: "Produktionssichere Datenbank",
      runtimeTitle: "Runtime",
      environment: "Umgebung",
      currentUptime: "Aktuelle Laufzeit",
      startedAt: "Gestartet um",
      deployedCommit: "Bereitgestellter Commit",
      databaseTitle: "Datenbank",
      host: "Host",
      logicalName: "Logischer Name",
      localMongo: "Lokales Mongo",
      publishedVersions: "Veröffentlichte Versionen",
      publicChecks: "Öffentliche Prüfungen",
      baseApi: "Basis-API",
      deepHealth: "Tiefer Gesundheitscheck",
      versionMetadata: "Versionsmetadaten",
      publicChecksNote: "Diese Seite zeigt nur, was die öffentlichen Endpunkte melden. Private Metriken oder personenbezogene Daten sind nicht enthalten.",
      openPublicStatus: "Öffentlichen Status ansehen",
      yes: "Ja",
      no: "Nein",
      notAvailable: "Nicht verfügbar",
      lessThanMinute: "weniger als 1 Min.",
    },
  },
  nl: {
    legalUi: {
      statusPage: "Status",
      andTerms: "en de",
      loginNoticePrefix: "Bij het inloggen kun je het volgende bekijken:",
      nonOfficialDisclaimer: "Caca Radar is een privé, onafhankelijke en niet-officiële tool. Het vertegenwoordigt geen gemeente, overheidsinstantie of andere publieke organisatie, vervangt die niet en is er niet mee verbonden.",
    },
    helpUi: {
      cookiesTitle: "Cookies en vergelijkbare technologieën",
      communityTitle: "Communityrichtlijnen en moderatie",
      storeCancellationNote: "Als je een abonnement hebt via de Apple App Store of Google Play, moet je dat ook vanuit je winkelaccount annuleren.",
    },
    statusUi: {
      title: "Servicestatus",
      intro: "Deze pagina vat de openbare operationele status van Caca Radar samen met de live status- en versie-endpoints.",
      refresh: "Vernieuwen",
      loading: "Servicestatus laden...",
      loadError: "De servicestatus kon niet worden geladen.",
      queryError: "Probleem bij het opvragen van de status",
      operational: "Operationeel",
      degraded: "Gedegradeerd",
      database: "Database",
      reportReads: "Rapportlezingen",
      userReads: "Gebruikerslezingen",
      productionSafe: "Productieveilige database",
      runtimeTitle: "Runtime",
      environment: "Omgeving",
      currentUptime: "Huidige uptime",
      startedAt: "Gestart op",
      deployedCommit: "Uitgerolde commit",
      databaseTitle: "Database",
      host: "Host",
      logicalName: "Logische naam",
      localMongo: "Lokale Mongo",
      publishedVersions: "Gepubliceerde versies",
      publicChecks: "Openbare controles",
      baseApi: "Basis-API",
      deepHealth: "Diepe status",
      versionMetadata: "Versiemetadata",
      publicChecksNote: "Deze pagina toont alleen wat de openbare endpoints rapporteren. Er staan geen privémetrics of persoonsgegevens op.",
      openPublicStatus: "Openbare status bekijken",
      yes: "Ja",
      no: "Nee",
      notAvailable: "Niet beschikbaar",
      lessThanMinute: "minder dan 1 min",
    },
  },
  pl: {
    legalUi: {
      statusPage: "Status",
      andTerms: "oraz",
      loginNoticePrefix: "Logując się, możesz zapoznać się z",
      nonOfficialDisclaimer: "Caca Radar to prywatne, niezależne i nieoficjalne narzędzie. Nie reprezentuje żadnego urzędu, administracji publicznej ani podmiotu rządowego, nie zastępuje ich i nie jest z nimi powiązane.",
    },
    helpUi: {
      cookiesTitle: "Pliki cookie i podobne technologie",
      communityTitle: "Zasady społeczności i moderacja",
      storeCancellationNote: "Jeśli masz subskrypcję przez Apple App Store lub Google Play, musisz anulować ją również na koncie sklepu.",
    },
    statusUi: {
      title: "Status usługi",
      intro: "Ta strona pokazuje publiczny stan działania Caca Radar na podstawie rzeczywistych endpointów zdrowia i wersji.",
      refresh: "Odśwież",
      loading: "Ładowanie statusu usługi...",
      loadError: "Nie udało się wczytać statusu usługi.",
      queryError: "Błąd podczas sprawdzania statusu",
      operational: "Działa",
      degraded: "Ograniczone działanie",
      database: "Baza danych",
      reportReads: "Odczyt zgłoszeń",
      userReads: "Odczyt użytkowników",
      productionSafe: "Bezpieczna baza produkcyjna",
      runtimeTitle: "Środowisko uruchomieniowe",
      environment: "Środowisko",
      currentUptime: "Bieżący uptime",
      startedAt: "Uruchomiono",
      deployedCommit: "Wdrożony commit",
      databaseTitle: "Baza danych",
      host: "Host",
      logicalName: "Nazwa logiczna",
      localMongo: "Lokalne Mongo",
      publishedVersions: "Opublikowane wersje",
      publicChecks: "Publiczne testy",
      baseApi: "Bazowe API",
      deepHealth: "Rozszerzony stan",
      versionMetadata: "Metadane wersji",
      publicChecksNote: "Ta strona odzwierciedla tylko dane z publicznych endpointów. Nie zawiera prywatnych metryk ani danych osobowych użytkowników.",
      openPublicStatus: "Zobacz publiczny status",
      yes: "Tak",
      no: "Nie",
      notAvailable: "Niedostępne",
      lessThanMinute: "mniej niż 1 min",
    },
  },
  uk: {
    legalUi: {
      cookiesPolicy: "Політика файлів кукі",
      statusPage: "Статус",
      andTerms: "та",
      loginNoticePrefix: "Під час входу ви можете переглянути",
      nonOfficialDisclaimer: "Caca Radar — це приватний, незалежний і неофіційний інструмент. Він не представляє, не замінює й не пов’язаний із жодною міською радою, державною адміністрацією чи урядовою установою.",
    },
    helpUi: {
      cookiesTitle: "Файли кукі та подібні технології",
      communityTitle: "Правила спільноти та модерація",
      storeCancellationNote: "Якщо у вас є підписка через Apple App Store або Google Play, її також потрібно скасувати у відповідному магазині.",
    },
    statusUi: {
      title: "Статус сервісу",
      intro: "Ця сторінка показує публічний стан роботи Caca Radar на основі реальних ендпоінтів здоров’я та версії.",
      refresh: "Оновити",
      loading: "Завантаження стану сервісу...",
      loadError: "Не вдалося завантажити стан сервісу.",
      queryError: "Помилка під час перевірки стану",
      operational: "Працює",
      degraded: "Частково недоступний",
      database: "База даних",
      reportReads: "Читання звітів",
      userReads: "Читання користувачів",
      productionSafe: "Безпечна продакшн-база",
      runtimeTitle: "Runtime",
      environment: "Середовище",
      currentUptime: "Поточний uptime",
      startedAt: "Час запуску",
      deployedCommit: "Розгорнутий коміт",
      databaseTitle: "База даних",
      host: "Хост",
      logicalName: "Логічна назва",
      localMongo: "Локальний Mongo",
      publishedVersions: "Опубліковані версії",
      publicChecks: "Публічні перевірки",
      baseApi: "Базовий API",
      deepHealth: "Поглиблений стан",
      versionMetadata: "Метадані версії",
      publicChecksNote: "Ця сторінка показує лише те, що повідомляють публічні ендпоінти. Вона не містить приватних метрик чи персональних даних користувачів.",
      openPublicStatus: "Відкрити публічний статус",
      yes: "Так",
      no: "Ні",
      notAvailable: "Недоступно",
      lessThanMinute: "менше 1 хв",
    },
    municipalityUi: {
      dashboardLabel: "Панель",
    },
    rankingUi: {
      leaderboardTitle: "Таблиця лідерів",
    },
  },
  ru: {
    legalUi: {
      cookiesPolicy: "Политика файлов куки",
      statusPage: "Статус",
      andTerms: "и",
      loginNoticePrefix: "При входе вы можете ознакомиться с",
      nonOfficialDisclaimer: "Caca Radar — это частный, независимый и неофициальный инструмент. Он не представляет, не заменяет и не связан ни с одним муниципалитетом, органом власти или государственной организацией.",
    },
    helpUi: {
      cookiesTitle: "Файлы куки и похожие технологии",
      communityTitle: "Правила сообщества и модерация",
      storeCancellationNote: "Если у вас есть подписка через Apple App Store или Google Play, ее также нужно отменить в аккаунте магазина.",
    },
    statusUi: {
      title: "Статус сервиса",
      intro: "Эта страница показывает публичный рабочий статус Caca Radar на основе реальных эндпоинтов здоровья и версии.",
      refresh: "Обновить",
      loading: "Загрузка статуса сервиса...",
      loadError: "Не удалось загрузить статус сервиса.",
      queryError: "Ошибка при проверке статуса",
      operational: "Работает",
      degraded: "Частично недоступен",
      database: "База данных",
      reportReads: "Чтение сообщений",
      userReads: "Чтение пользователей",
      productionSafe: "Безопасная прод-база",
      runtimeTitle: "Runtime",
      environment: "Среда",
      currentUptime: "Текущий uptime",
      startedAt: "Время запуска",
      deployedCommit: "Развернутый коммит",
      databaseTitle: "База данных",
      host: "Хост",
      logicalName: "Логическое имя",
      localMongo: "Локальный Mongo",
      publishedVersions: "Опубликованные версии",
      publicChecks: "Публичные проверки",
      baseApi: "Базовый API",
      deepHealth: "Глубокая проверка",
      versionMetadata: "Метаданные версии",
      publicChecksNote: "Эта страница отражает только данные публичных эндпоинтов. Она не содержит приватных метрик или персональных данных пользователей.",
      openPublicStatus: "Открыть публичный статус",
      yes: "Да",
      no: "Нет",
      notAvailable: "Недоступно",
      lessThanMinute: "меньше 1 мин",
    },
    municipalityUi: {
      dashboardLabel: "Панель",
    },
    rankingUi: {
      leaderboardTitle: "Таблица лидеров",
    },
    mapUi: {
      feedback: "Обратная связь",
    },
    profileUi: {
      upgradePremium: "Перейти на Премиум",
    },
  },
  eu: {
    legalUi: {
      statusPage: "Egoera",
      andTerms: "eta",
      loginNoticePrefix: "Saioa hastean, hau berrikus dezakezu:",
      nonOfficialDisclaimer: "Caca Radar tresna pribatu, independente eta ez-ofiziala da. Ez du udalik, administrazio publikorik edo gobernu-erakunderik ordezkatzen, ez ditu ordezten, eta ez dago haiekin lotuta.",
    },
    helpUi: {
      cookiesTitle: "Cookieak eta antzeko teknologiak",
      communityTitle: "Komunitate arauak eta moderazioa",
      storeCancellationNote: "Apple App Store edo Google Play bidezko harpidetza baduzu, dendako kontuan ere bertan behera utzi behar duzu.",
    },
    statusUi: {
      title: "Zerbitzuaren egoera",
      intro: "Orrialde honek Caca Radar-en egoera publiko operatiboa erakusten du benetako osasun eta bertsio endpointak erabilita.",
      refresh: "Eguneratu",
      loading: "Zerbitzuaren egoera kargatzen...",
      loadError: "Ezin izan da zerbitzuaren egoera kargatu.",
      queryError: "Errorea egoera kontsultatzean",
      operational: "Martxan",
      degraded: "Murriztuta",
      database: "Datu-basea",
      reportReads: "Txostenen irakurketa",
      userReads: "Erabiltzaileen irakurketa",
      productionSafe: "Produkziorako datu-base segurua",
      runtimeTitle: "Runtime",
      environment: "Ingurunea",
      currentUptime: "Uneko uptime-a",
      startedAt: "Abiarazte-data",
      deployedCommit: "Hedatutako commit-a",
      databaseTitle: "Datu-basea",
      host: "Ostalaria",
      logicalName: "Izen logikoa",
      localMongo: "Mongo lokala",
      publishedVersions: "Argitaratutako bertsioak",
      publicChecks: "Egiaztapen publikoak",
      baseApi: "Oinarrizko APIa",
      deepHealth: "Egoera sakona",
      versionMetadata: "Bertsio metadatuak",
      publicChecksNote: "Orrialde honek endpoint publikoek adierazten dutena besterik ez du erakusten. Ez du metrika pribaturik edo erabiltzaileen datu pertsonalik biltzen.",
      openPublicStatus: "Ikusi egoera publikoa",
      yes: "Bai",
      no: "Ez",
      notAvailable: "Ez dago erabilgarri",
      lessThanMinute: "1 min baino gutxiago",
    },
  },
  ca: {
    legalUi: {
      statusPage: "Estat",
      andTerms: "i els",
      loginNoticePrefix: "En iniciar sessió, pots consultar la",
      nonOfficialDisclaimer: "Caca Radar és una eina privada, independent i no oficial. No representa, no substitueix ni està afiliada a cap ajuntament, administració pública ni entitat governamental.",
    },
    helpUi: {
      cookiesTitle: "Cookies i tecnologies similars",
      communityTitle: "Normes de la comunitat i moderació",
      storeCancellationNote: "Si tens una subscripció a l’Apple App Store o Google Play, també l’has de cancel·lar des del teu compte de la botiga.",
    },
    statusUi: {
      title: "Estat del servei",
      intro: "Aquesta pàgina resumeix l’estat operatiu públic de Caca Radar amb els endpoints reals de salut i versió.",
      refresh: "Actualitza",
      loading: "Carregant l’estat del servei...",
      loadError: "No s’ha pogut carregar l’estat del servei.",
      queryError: "Incidència en consultar l’estat",
      operational: "Operatiu",
      degraded: "Degradat",
      database: "Base de dades",
      reportReads: "Lectura d’avisos",
      userReads: "Lectura d’usuaris",
      productionSafe: "Base de dades segura per a producció",
      runtimeTitle: "Runtime",
      environment: "Entorn",
      currentUptime: "Uptime actual",
      startedAt: "Inici",
      deployedCommit: "Commit desplegat",
      databaseTitle: "Base de dades",
      host: "Host",
      logicalName: "Nom lògic",
      localMongo: "Mongo local",
      publishedVersions: "Versions publicades",
      publicChecks: "Comprovacions públiques",
      baseApi: "API base",
      deepHealth: "Estat profund",
      versionMetadata: "Metadades de versió",
      publicChecksNote: "Aquesta pàgina reflecteix només el que informen aquests endpoints. No inclou mètriques privades ni dades personals d’usuaris.",
      openPublicStatus: "Veure estat públic",
      yes: "Sí",
      no: "No",
      notAvailable: "No disponible",
      lessThanMinute: "menys d’1 min",
    },
  },
  val: {
    legalUi: {
      statusPage: "Estat",
      andTerms: "i els",
      loginNoticePrefix: "En iniciar sessió, pots consultar la",
      nonOfficialDisclaimer: "Caca Radar és una eina privada, independent i no oficial. No representa, no substituïx ni està afiliada a cap ajuntament, administració pública ni entitat governamental.",
    },
    helpUi: {
      cookiesTitle: "Cookies i tecnologies similars",
      communityTitle: "Normes de la comunitat i moderació",
      storeCancellationNote: "Si tens una subscripció a l’Apple App Store o Google Play, també l’has de cancel·lar des del teu compte de la botiga.",
    },
    statusUi: {
      title: "Estat del servici",
      intro: "Esta pàgina resumeix l’estat operatiu públic de Caca Radar amb els endpoints reals de salut i versió.",
      refresh: "Actualitza",
      loading: "Carregant l’estat del servici...",
      loadError: "No s’ha pogut carregar l’estat del servici.",
      queryError: "Incidència en consultar l’estat",
      operational: "Operatiu",
      degraded: "Degradat",
      database: "Base de dades",
      reportReads: "Lectura d’avisos",
      userReads: "Lectura d’usuaris",
      productionSafe: "Base de dades segura per a producció",
      runtimeTitle: "Runtime",
      environment: "Entorn",
      currentUptime: "Uptime actual",
      startedAt: "Inici",
      deployedCommit: "Commit desplegat",
      databaseTitle: "Base de dades",
      host: "Host",
      logicalName: "Nom lògic",
      localMongo: "Mongo local",
      publishedVersions: "Versions publicades",
      publicChecks: "Comprovacions públiques",
      baseApi: "API base",
      deepHealth: "Estat profund",
      versionMetadata: "Metadades de versió",
      publicChecksNote: "Esta pàgina reflectix només el que informen eixos endpoints. No inclou mètriques privades ni dades personals d’usuaris.",
      openPublicStatus: "Vore estat públic",
      yes: "Sí",
      no: "No",
      notAvailable: "No disponible",
      lessThanMinute: "menys d’1 min",
    },
  },
};

Object.keys(translations).forEach((lang) => {
  const extra = navigationTranslations[lang] || navigationTranslations.es;
  Object.entries(extra).forEach(([group, values]) => {
    translations[lang][group] = {
      ...(translations[lang][group] || {}),
      ...values,
    };
  });
});

export const rtlLanguages = [];

export function isRtl(lang) {
  return rtlLanguages.includes(lang);
}
